/**
 * @frozen CP-1 v2.48 (frozen-contract rule: scripts/guards.mjs)
 * v2.48 (ADR-0096, CB14): additive, optional: DecisionAttribution.cardWithheld (per answered non-default card, the played year less the same year with that card withheld); Scorecard.components.todayDollarFactor (year-end dollars per twin share to today's dollars per share held at the start).
 * v2.47 (ADR-0095, CB13): REMOVED (unread since OR-30.80; every raise prices at 08.2 E7 δ(I)): Expander `raiseDiscountRate` and Effect `capitalRaise.discountRate`; the data and the generator follow. ADDED, optional: BankState.capitalRecord.sumCountedQuarterEndRate (10.2 E1′, OR-30.84: the counted capital record, min of the ratio and the target in force plus headroom, summed over quarter-ends; the engine lane fills it).
 * v2.46 (ADR-0094, CB12): additive, optional: EventCard.publicLine (a digit-free sentence a reader outside the bank sees); LoansParams.rm.byBook.<book>.depositsPerAddedRmUsd; DriverYearProducts.bookIdByProduct (product id to its book, so a backcast year is read by book without the naming rule).
 * v2.45 (ADR-0092, CB10): additive, optional: LogitShareParams.adjustmentLambdaPerMonth minimum 0.04 → 0.02 (a widened bound); BankState.qtd.lapsingOverrideUsd; riskyChoices[].kpis.noCardYear (the no-card year-end KPI snapshot); PreviewInput.nextStep.decisionId and PreviewResult.nextStep.decisionId widened to a DecisionId or a leaf DecisionPath; ContentParams.valuation.priceModel.marketMbsTenorYears; ValueBridgeStep.step member `capital`; CreditPdParams.growthLossPerUnit (04.1 E8, was the pin credit.growthLoss.perUnit.<book>, which stays the fallback).
 * v2.44 (ADR-0091, CB9): additive, optional: BusinessDrivers (the drivers a decision rests on, per period) and PeriodReport.businessDrivers; PreviewInput.nextStep and PreviewResult.nextStep / .yearEndDrivers (the one-notch probe and the year-end drivers of the draft and the no-change plan).
 * v2.43 (ADR-0090, CB8): additive, optional: DepositFlowParams.serviceAttrition.ratePerPointOfExpenseProgramme (the expense programme's own service-point rate, half the pay / closure rate; OR-30.45).
 * v2.42 (ADR-0088, CB6): additive, optional: PreviewInput.anchors.startAssessmentUsd (A0 from the true SimStart); ArchetypePack.startAssessmentUsd (the preview's implied pack carries it); BankState.lastYearWindow (the played year's window NIM and NCO rate, 13.1 §2).
 * v2.41 (ADR-0087, CB5): additive, optional: QuarterRecord.aociAfsUsd/.lapsingOverrideUsd; riskyChoices[].kpis.lookThrough.withoutCardUsdPerShare; LookThroughResult.franchiseRawUsdPerShare; ValueBridgeStep.step members `distributions` and `sharesRetired` (the split of `excessShortfallAndDistributions`, which stays for stored results).
 * v2.40 (ADR-0086, CB4): additive, optional: IrrSnapshot.niiSensitivityWorseRate and the KpiId `niiSensitivityLossRate`; FeesParams.ecrAnalysedShareRate/.ecrPassThroughRate/.ecrStartRate/.ecrFloorRate/.mortgageRefiShareRate/.mortgagePurchaseRateSensitivity, OpexParams.depositInsuranceBpByComposite and TreasuryParams.funding.weaknessSpreadBp (the N2 pins given their own fields; `ContentParams.pins` stays the fallback); LookThroughResult.standingPremiaBp/.capitalLookThroughRate; Shock kind `loanSpreadShift`; FranchiseState.pendingOpenings. Two comments corrected (opexBalanceScale, ValuationBreakdown).
 * v2.39 (ADR-0085, G4): additive, optional: riskyChoices[].rateRisk.cardHedge (a card hedge's distance from neutral in notches and the most notches the card moves, so the player lines can say a hedge was cut or has nothing to close).
 * v2.38 (ADR-0084, E4): additive, optional: LoansParams.rm/.lo.annualAttritionRateByPayNotch (03.5 E1: the annual attrition at pay Lower / Hold / Higher, in the data since Gate 3d, now read), FranchiseState.payNotches (the pay notch in force by start month, so a resumed run reads its team's past attrition back).
 * v2.37 (ADR-0083): additive, optional: MarketOutlook.pauseSignal.calmQuarters (the calm quarter-ends in a row so far).
 * v2.36 (ADR-0082): additive, optional: LoansParams.rm.rateConcessionFloorBp (OR-30.1), BankState.qtd.opexUsd (the quarter's operating expense so far, carried across run segments); removed: PreviewResult.answeredCards (v2.34, never populated; the per-card price effect is CP-3 RiskProjection.answeredCards).
 * v2.35 (ADR-0081, OR-30.10): additive, optional: EventCard.variants[].deferIfDisplaced (a bank-level card's variant the per-bank cap displaces is tried again next round, never applied at its default; 12.1 E4a).
 * v2.34 (ADR-0080): additive, optional: QuarterRecord.opexUsd, ProductDef.detail, Attribution.expectationTerminal.perCard, riskyChoices[].changes/.ratingBefore/.ratingAfter, PreviewResult.answeredCards, PreviewResult.eveBridge.balanceUsd, SeatRoundResult.riskAppetiteBreaches[].quarterEnds.
 * v2.33 (ADR-0079): additive, optional: ContentParams.learningSurprise (the cap, in bp, on how far a solo run's hidden rate path may sit from the published consensus, by base level; 01.1 E5).
 * v2.32 (ADR-0077): additive, optional: PreviewTrace.decisions[].valueUsdPerShare/.laterUsdPerShare and interaction.valueUsdPerShare/.laterUsdPerShare (each decision's three-year value and its later-years leg), PreviewResult.costProgramme (the expense programme's charge, savings, payback and capital use).
 * v2.31 (ADR-0076): additive: PUBLIC_KPIS_EXTENDED (the further KPIs a peer group's public filings give; PUBLIC_KPIS itself is unchanged).
 * v2.30 (ADR-0075): additive, optional: PreviewTrace.decisions[].because, PreviewResult.priceBridge/.eveBridge (why each preview number moved: one engine-worded sentence per KPI per decision, the price and the equity-value move split into their causes).
 * v2.29 (ADR-0074): additive, optional: Attribution.expectation[].expectedAvg/.actualAvg (the year's average of NIM and NCO rate, the basis the forecast is scored on).
 * v2.28 (ADR-0072, C1): additive, optional: ContentParams.valuation.priceModel.securitiesOptionCostBp, PreviewInput.limitChanges, DecisionAttribution.carriedByRound[].fromRound/.value, ContentParams.attribution.splitRounds, QuarterRecord.oneOffOpexUsd, BankState.qtd.oneOffOpexUsd, ContentParams.valuation.priceModel.oneOffOpex, ContentParams.limitsNotes, LoansParams.rm.byBook/.newHirePricingConcessionBp/.newHireLossMultiplier/.newHireLossDecayMonths/.rateConcessionBp/.rateConcessionMonths, DecisionAttribution.carriedByRound, riskyChoices[].chance.adverse, LaggedEffect branches[].adverse, Shock opexHitRateOfTrailingOpex.
 * v2.27 (ADR-0070, F24.0): additive, optional: riskyChoices[].kpis.lookThrough (the plan's look-through value per share without and with the answer, the figure the score counts).
 * v2.26 (ADR-0069, H-0): additive, optional: ContentParams.valuation.priceModel.securitiesReference, LoansParams.rm.marketDepthRate, swapDealerMarginBp (beside swapSpreadBp), Scorecard.components.bidMonth, ValueBridgeStep.premiumBp, riskyChoices[].chance.lookThrough, Effect loanModification.reliefRate/.reliefMonths, Effect decisionMove, PreviewResult.ratePosition.cause "pastNeutral", ContentParams.readings.
 * v2.25 (ADR-0068 rev, F22.0): additive, optional: riskyChoices[].chance (the odds of a chance event on a card option, with the share price on each outcome).
 * v2.24 (ADR-0068 rev, F20.0): additive, optional: PreviewResult.ratePosition.sameAsNoChange, Attribution.expectation[].residual and expectationTerminal(.twin).residualUsdPerShare (the residual leg).
 * v2.23 (ADR-0068 rev, F19.0b): additive, optional: CamelsState.ratedOn[k].kpi and .higherIsBetter (the rated measure's reported KPI and which way is better).
 * v2.22 (ADR-0068 rev, F19.0): additive, optional: Attribution.expectation[].cardsArrived/.cardsAnswer and expectationTerminal(.twin).cardsArrivedUsdPerShare/.cardsAnswerUsdPerShare (the card leg split), expectationTerminal.surpriseDrivers, CamelsState.ratedOn, PreviewResult.ratePosition.
 * v2.21 (ADR-0068 rev, F18.0): additive, optional: EventChoice.relatedDecisions (the decisions a choice acts on, for the Review's Object button).
 * v2.20 rev. F17.5c (ADR-0068 revision): CamelsState.limitBreachQuarterEnds entries are { month, limits, breachedKpis } (the field was unused); ContentParams.supervisory.modifiers.mBreach (optional, 09.1 E11).
 * v2.20 (ADR-0068, F17.0): additive, optional: ContentParams.valuation.terminal.inFlightHaircutMaxRate/.inFlightFullSpreadPp, DecisionAttribution.carriedRows/.carriedInteraction, LoanDemandParams.unemployment, Attribution.expectation[].rivals/.expectationTerminal.rivals/.twin.rivals, PreviewInput.anchors.cardTitles, CamelsState.limitBreachQuarterEnds; ProductLine.interestUsd and AlmSnapshot.depositBetas[].realizedBetaRate become optional (absent = no reading).
 * v2.19 (ADR-0067, F16.0d): additive, optional: QuarterRecord.swapInterestUsd and qtd.swapInterestUsd (the live swaps' net interest, inside reported PPNR).
 * v2.18 (ADR-0066, F16.0c): additive, optional: PreviewInput.anchors.consensusBandPaths (the published low and high consensus band paths).
 * v2.17 (ADR-0065, F16.0b): additive, optional: LookThroughEstimate.low and .high (the plan's score on the published low and high consensus band paths).
 * v2.16 (ADR-0064, F16.0): additive, optional: riskyChoices[].kpis (the draft's year-end NIM and share price, and the same with that option answered), riskyChoices[].ownLimits[].quarterEndLow, Attribution.expectationTerminal.twin, AttributionKey `cardAnswers`, baselines.twinOnBands (the status-quo twin on the published low and high consensus paths).
 * v2.15 (ADR-0063, F15.1): additive, optional: PreviewTrace.decisions[].reason/later, LookThroughResult.lineDirections/lineReasons.
 * v2.14 (ADR-0061, F14.1): additive, optional: AlmSnapshot.swaps, riskyChoices[].rateRisk.hedge.
 * v2.13 (ADR-0062, E4.5): additive: LookThroughResult.franchiseBeyondCapUsdPerShare (optional); ContentParams.valuation.terminal.inFlightCapPp (10.3 E8: the franchise line counts up to that many points of wealth at T).
 * v2.12 (ADR-0060, E4.4): additive, optional: OpexParams.serviceDepositLossCapShareOfBranchDeposits (07.3 E8's cap on the deposits service cuts can drive out; in the data since Gate 3d, now read).
 * v2.11 (ADR-0059, F13.1): additive, optional: Scorecard.components.shares/horizonToStartDollarRate, SeatRoundResult.priorPrice.youSharesOutstanding/twinSharesOutstanding (priceMoves now on the one basis of priceVsTwin),
 * Attribution.expectationTerminal, MarketOutlook.pauseSignal, DecisionAttribution.rows[].valueParts.
 * v2.10 (ADR-0058, A4.1): additive: EventFactKey `ciGrowthVsTrendRate` (24-month C&I growth above the market's trend, a fact of EV-07); `PayoutSchedule` named (the shape of BankState.payoutSchedule, unchanged).
 * v2.9 (ADR-0057, X4.6 / P4-D13): additive, optional: CreditPdParams.lossCurve, BookCreditState.worstDriverLevel/recoveryDriverLevel/workoutBacklogUsd/stressNonaccrualUsd.
 * CreditPdParams.burnoutPoolRate, the macroBetas values (the key still names the driver) and BookCreditState.burnoutUsedRate are no longer read (data keeps them).
 * v2.8 (ADR-0055, E4.2): additive, optional: DepositFlowParams.checkingMigration/moneyFundPool, OpexParams.cpiPassThroughRate/opexBalanceElasticityRate/opexDownwardElasticityRate/costCutChannels,
 * FranchiseState.checkingMovedRate/moneyFundPoolRate/opexPriceIndex, BankState.payoutSchedule, ContentParams.capitalPolicy.distributionSchedule/cycleEarnings/simStartMarket.
 * ddaMigration, rateLeakagePer100Bp and teamCutShareOfRunRateCutByLevel are @deprecated (data keeps them; the engine no longer reads them).
 * v2.7 (ADR-0054, E4.1: the chapter 10 price model and terminal value): additive, optional: BankState.valuation/rotceHistoryRate/balanceHistoryUsd/enforcementClosedMonth, ValuationBreakdown.rotceNormRate/ptbvFair/ptbvFairWithEvents/xvalUsd/floorUsd/normProvUsd/balancesUsd and the premiaBp rows dividend/enforcement,
 * LookThroughResult.marketPriceUsdPerShare/terminalValueUsdPerShare/lines/composition/rotceLookThroughRate/growthLookThroughRate/sharesOutstanding, ValueBridgeStep steps `growth`/`terminalLine` and `.line`, ContentParams.valuation.priceModel/terminal.
 * Retired: ContentParams valuation.{excessIncomeRate,gCapRate,gRetentionMult,shortfallMult,ptbvMin,coeInterceptRate}, premia.{mComponent,supervisory}, capitalPolicy.{dividendCutPremiumBp,suspensionPremiumBp,lookThroughCure}, autopilot.{cureIssuanceTargetRate,cureDiscountRate}, the premiaBp rows mComponent/supervisory, LookThroughResult.{shadowCureIssuedUsd,normProvBoxTermUsd}.
 * CP-1 — packages/domain: the shared vocabulary for engine, models, scoring, personas, contracts, ai, web. The docs/models
 * chapters own the equations; every field a model reads cites its chapter/equation id (e.g. "02.3 E1"). A @deprecated field
 * is optional and absent in data.
 * v2.6 (ADR-0056, E4.3): additive, optional: CamelsState.earningsPendingBetterQuarters/.liquidityAfterRun, BankState.lastDepositRunMonth/.preRunOvernightFhlbUsd, ContentParams.supervisory.earningsRule/.liquidityAfterRun,
 * ContentParams.treasury.liquidity.afterRun, ContentPack.guided.opensInRound/.unlockOnCapitalNeed/.stepLimit; @deprecated CamelsState.lModifierUntilMonth, supervisory.modifiers.lModifierMonths (09.1 E10 replaces the timed L notch).
 * v2.5 (ADR-0053, F12.1): additive, optional: DecisionConstraint.before, riskyChoices[].ownLimits/rateRisk, baselines.noChange.pointYearEnd, PreviewResult.yearEnd/yearEndDeltasVsNoChange/basis,
 * PreviewTrace.held and decisions[].bookLines, AlmSnapshot.policyMoveBp, Attribution.marketDrivers.nim, byCause[].lines/taxUsd, expectation[].basis, DecisionAttribution.basis and lineAttribution[].gapUsd,
 * forecastErrors[].basis, Scorecard.components.twin/priceMoves, valueTwinRoundEnd.distributions, SeatRoundResult.priorPrice.
 * v2.4 (ADR-0052, F11.1): additive, optional: Attribution.expectation[].surprise, Attribution.marketDrivers.policyRateCardBp, ValueBridgeStep.cause.
 * v2.3 (ADR-0051): `PreviewInput.scheduledShocks?`, and `pendingEvents` also carries the seat's answered cards of the round, so the preview and the CRO memo see them.
 * v2.2 (ADR-0049, contract batch 10): additive, every field optional (OpexParams.investTechTopUpRateByLevel and the `investAggressively` level, LoansParams.consumerMarketingMultByNotch,
 * CroMemo item decisionIds, SwapPosition.floatIndex "SOFR", BankState.terminatedSwapMarkUsd, PreviewTrace.levels, DomainIssue `conflictingDecisions`).
 * v2.1 (ADR-0048 amendment, R2.2/R2.3): the ExpanderParams deposits/loans/operations blocks.
 * v2.0 (ADR-0048, R2.0, BREAKING): the sixteen levers L1–L16 are replaced by the product-organised decision set (`Decisions`, five families, 32
 * decisions, dotted paths); `DecisionSet.levers` → `.decisions` + `schemaVersion: 2`; every `Lever*` type and id is retired. Fresh-cohort cut-over, no backfill.
 * v1.15 (ADR-0047, contract batch 9): additive transparency-programme fields, every one optional: per-product output (ProductLine), ALM (AlmSnapshot),
 * formula inputs (KpiInputs), MarketOutlook, PreviewTrace, LookThroughEstimate, DecisionAttribution; PreviewInput.rivals/baselines; Scorecard.components.
 * v1.15 amendment (ADR-0047, same version as ADR-0041's precedent): PreviewInput.anchors.envHistory, optional.
 * Labels: DET-1..DET-5 = the determinism rules below; OD4-n, OD5-n, M1–M12 = owner decisions (docs/decisions.md). Decision ids
 * are dotted paths (`loans.cre.pricing`); rubric levels are "Level 1–4".
 * Naming (OD5-2): identifiers keep `autopilot` for the do-nothing policy and its counterfactual (STANDING_POLICY,
 * autopilotTsrRate, …). Participant-facing COPY calls it the "status-quo twin"; CP-3 DTO fields for it say `twin`.
 * Rules:
 *  - zod schema is the source of truth; every type is z.infer of its schema.
 *  - Units are in field names: *Usd (whole dollars, integer), *UsdPerShare (float),
 *    *Rate (decimal fraction: 0.0352 = 3.52%), *Bp (basis points), *Month (engine month
 *    index, 0 = SimStart), *Months (a duration), *Years, *Round (round index, 0 = R0 strategy).
 *  - v1 fields are present and `.optional()` where the pilot does not use them.
 *  - Money is rounded exactly once, at posting time (roundToUsd). Splitting a rounded total uses
 *    allocateUsd (largest remainder) so parts always sum to the whole.
 *  - Only InvariantViolation is ever thrown. Domain outcomes are values (Result / union).
 *  - Naming: a "cohort" is ALWAYS a program cohort (a run of the game: CohortId, UUID).
 *    A loan/deposit/security origination bucket is a "vintage" (Vintage, VintageId).
 *  - Determinism rules (engine, models, scoring, personas):
 *      DET-1 never iterate a Record with Object.keys/values/entries — use sortedEntries() or the
 *         MarketState.seats array order (seats are sorted by SeatId at initMarket). Postgres jsonb
 *         and canonicalJson both reorder keys, so insertion order is NOT stable across a reload.
 *      DET-2 randomness only via rngFor(seed, stream, key) (cp2): keyed, counter-free substreams, so a
 *         seat's draws never depend on how many draws another seat (or a counterfactual) made.
 *      DET-3 no Date/clock/locale (no localeCompare, no toFixed for logic); no Math.random.
 *      DET-4 authoritative resolution + stateDigest run server-side only (Node/V8). The browser preview
 *         is advisory and is never compared by hash.
 *      DET-5 hashes = sha256(canonicalJson(x)) with a pure-JS sync sha256 (e.g. @noble/hashes).
 *  - This package also owns the app-layer shared primitives (CohortId, TeamId, UserId, enums used
 *    by contracts + ai). No other package may redeclare them.
 */
import { z } from "zod";

// ───────────────────────────────────────────────────────────── ids & units

/** Whole US dollars (integer). $25B fits well inside 2^53. */
export const Usd = z.number().int().brand<"Usd">();
export type Usd = z.infer<typeof Usd>;
/** Per-share dollar value (price, TBVPS, DPS); not rounded to whole dollars. */
export const UsdPerShare = z.number().brand<"UsdPerShare">();
export type UsdPerShare = z.infer<typeof UsdPerShare>;
/** Decimal fraction (0.0352 = 3.52%). Used for rates, ratios, shares, growth. */
export const Rate = z.number().brand<"Rate">();
export type Rate = z.infer<typeof Rate>;
/** Basis points (1bp = 0.0001 Rate); may be fractional (e.g. 21.33bp). */
export const Bp = z.number().brand<"Bp">();
export type Bp = z.infer<typeof Bp>;
/** Engine month index; 0 = SimStart month-end. */
export const Month = z.number().int().nonnegative().brand<"Month">();
export type Month = z.infer<typeof Month>;
/** Round index; 0 = R0 (strategy statement, no resolution), 1..N scored rounds. */
export const RoundIndex = z.number().int().nonnegative().brand<"RoundIndex">();
export type RoundIndex = z.infer<typeof RoundIndex>;
/** Share count (integer). */
export const Shares = z.number().int().nonnegative().brand<"Shares">();
export type Shares = z.infer<typeof Shares>;

const slug = z.string().regex(/^[a-z0-9][a-z0-9_.-]*$/);
/**
 * Engine seat id. Letter-first, no dots: never an integer-like object key (JS key-order trap) and
 * always a valid FactId segment. Pilot convention: "s1".."s8" (= team.seat_no). ArchetypePack
 * templates use "template".
 */
export const SeatId = z.string().regex(/^[a-z][a-z0-9_]{0,15}$/).brand<"SeatId">();
export type SeatId = z.infer<typeof SeatId>;
export const MarketId = slug.brand<"MarketId">();
export type MarketId = z.infer<typeof MarketId>;
export const ProductId = slug.brand<"ProductId">();
export type ProductId = z.infer<typeof ProductId>;
/** One origination vintage (quarter) / position inside a book. NOT a program cohort. */
export const VintageId = slug.brand<"VintageId">();
export type VintageId = z.infer<typeof VintageId>;
export const EventId = z.string().regex(/^EV-\d{2}$/).brand<"EventId">();
export type EventId = z.infer<typeof EventId>;
export const EventInstanceId = slug.brand<"EventInstanceId">();
export type EventInstanceId = z.infer<typeof EventInstanceId>;
export const PersonaId = slug.brand<"PersonaId">();
export type PersonaId = z.infer<typeof PersonaId>;
export const ArchetypeId = slug.brand<"ArchetypeId">();
export type ArchetypeId = z.infer<typeof ArchetypeId>;
export const ScenarioId = slug.brand<"ScenarioId">();
export type ScenarioId = z.infer<typeof ScenarioId>;
/** App-layer ids (DB/API): UUIDv7 strings, unbranded so zod-parsed rows flow without casts. */
export const Uuid = z.uuid();
export const UserId = Uuid;
export type UserId = z.infer<typeof UserId>;
/** Program cohort = one run of the game (facilitated workshop or solo run). DB table `cohort`. */
export const CohortId = Uuid;
export type CohortId = z.infer<typeof CohortId>;
/** DB team (a bank seat in a cohort). Maps 1:1 to an engine SeatId via team.seat_id. */
export const TeamId = Uuid;
export type TeamId = z.infer<typeof TeamId>;
/** Deterministic: `${seatId}:${month}:${seq}` (seq = emission order within the seat-month). Never a UUID. */
export const PostingId = z.string().regex(/^[a-z][a-z0-9_]{0,15}:\d+:\d+$/).brand<"PostingId">();
export type PostingId = z.infer<typeof PostingId>;
/**
 * Fact id grammar (shared by engine, packet builder, verifier):
 *   <scope>.r<round>[.q<1-4>|.m<month>].<metric>[.<qualifier>]
 *   scope = SeatId | "mkt" | "ev_<instance>" | "k" (content constant); metric = KpiId or content key.
 *   e.g. s3.r2.nim · s3.r2.q4.cet1Reported · mkt.r2.ffRate · k.creGuidance
 */
export const FactId = z.string().regex(/^[a-z][a-z0-9_]*(\.[A-Za-z0-9_]+){1,5}$/).brand<"FactId">();
export type FactId = z.infer<typeof FactId>;
/** Decision path for constraints/overrides/rules: "loans.cre.pricing", "deposits.retailMm.rate.front", "capital.buyback.cet1TargetRate". The family is the first segment; a path is also its field path in `Decisions`. */
export const DecisionPath = z.string().regex(/^(loans|deposits|treasury|capital|operations)(\.[A-Za-z0-9]+)+$/);
export type DecisionPath = z.infer<typeof DecisionPath>;
/** Scalar a rule/override may write into a decision path (notch, enum value, rate, boolean, null = Off). */
export const DecisionValue = z.union([z.number(), z.string(), z.boolean(), z.null()]);
export type DecisionValue = z.infer<typeof DecisionValue>;
/** GL account: `<class>:<name>` e.g. asset:cre, liab:mmda, income:interest.cre, oci:afs. */
export const AccountId = z
  .string()
  .regex(/^(asset|contra|liab|equity|income|expense|oci|offbs):[a-z0-9_.]+$/)
  .brand<"AccountId">();
export type AccountId = z.infer<typeof AccountId>;
export const Sha256Hex = z.string().regex(/^[0-9a-f]{64}$/);
export const SemVer = z.string().regex(/^\d+\.\d+\.\d+(-[0-9A-Za-z.-]+)?$/);
/** ISO-8601 with offset (API emits "Z"). App layer only — the engine never reads a timestamp (DET-3). */
export const IsoDateTime = z.iso.datetime({ offset: true });

/** Round half away from zero to whole dollars — the single rounding point for money. */
export function roundToUsd(x: number): Usd {
  const r = Math.sign(x) * Math.round(Math.abs(x));
  if (!Number.isSafeInteger(r)) throw new InvariantViolation("I19", `non-finite money ${x}`);
  return (r === 0 ? 0 : r) as Usd;
}

/**
 * Split a rounded total across weights so the parts sum EXACTLY to the total (largest remainder;
 * ties → lower index). Use for charge-off schedules, pro-rata sales, quarterly slices, fee lines.
 */
export function allocateUsd(total: Usd, weights: readonly number[]): Usd[] {
  const sumW = weights.reduce((a, w) => a + w, 0);
  if (!(sumW > 0) || weights.some((w) => !(w >= 0))) throw new InvariantViolation("I19", "allocateUsd: bad weights");
  const sign = total < 0 ? -1 : 1;
  const abs = Math.abs(total);
  const raw = weights.map((w) => (abs * w) / sumW);
  const floors = raw.map(Math.floor);
  let rest = abs - floors.reduce((a, b) => a + b, 0);
  const order = raw.map((r, i) => [r - Math.floor(r), i] as const).sort((a, b) => b[0] - a[0] || a[1] - b[1]);
  for (const [, i] of order) { if (rest <= 0) break; floors[i] = (floors[i] ?? 0) + 1; rest -= 1; }
  return floors.map((f) => (sign * f === 0 ? 0 : sign * f) as Usd);
}

/**
 * Cumulative split (docs/models README §4): parts_k = round(T·C_k/W) − round(T·C_{k−1}/W), C_k = Σ_{j≤k} w_j,
 * W = Σ w. O(n), no sort, exact to the total, deterministic. Use it for MONTHLY per-vintage splits in step modules (charge-off
 * queues, pro-rata flows); allocateUsd (largest remainder) stays for one-off SimStart spreading.
 */
export function splitUsdCumulative(total: Usd, weights: readonly number[]): Usd[] {
  const sumW = weights.reduce((a, w) => a + w, 0);
  if (!(sumW > 0) || weights.some((w) => !(w >= 0))) throw new InvariantViolation("I19", "splitUsdCumulative: bad weights");
  const out: Usd[] = [];
  let cum = 0;
  let prev = 0;
  for (const w of weights) {
    cum += w;
    const at = roundToUsd((total * cum) / sumW);
    out.push(roundToUsd(at - prev));
    prev = at;
  }
  return out;
}

/** Deterministic iteration over a Record (DET-1): keys sorted by UTF-16 code unit, never locale. */
export function sortedEntries<K extends string, V>(r: Readonly<Partial<Record<K, V>>>): [K, V][] {
  return (Object.keys(r) as K[]).sort((a, b) => (a < b ? -1 : a > b ? 1 : 0)).map((k) => [k, r[k] as V]);
}

/**
 * Canonical JSON (RFC 8785-style): object keys sorted, no whitespace, numbers via ES shortest
 * round-trip, -0 → 0, undefined object members dropped. Throws on NaN/±Infinity/undefined-in-array.
 * Used for contentHash, decisionHash, inputs_hash, stateDigest, packetHash, memoHash.
 */
export function canonicalJson(v: unknown): string {
  if (v === null || typeof v === "boolean" || typeof v === "string") return JSON.stringify(v);
  if (typeof v === "number") {
    if (!Number.isFinite(v)) throw new InvariantViolation("I15", `non-finite number in canonicalJson`);
    return JSON.stringify(v === 0 ? 0 : v);
  }
  if (Array.isArray(v)) return `[${v.map((x) => { if (x === undefined) throw new InvariantViolation("I15", "undefined in array"); return canonicalJson(x); }).join(",")}]`;
  if (typeof v === "object") {
    const o = v as Record<string, unknown>;
    return `{${Object.keys(o).filter((k) => o[k] !== undefined).sort((a, b) => (a < b ? -1 : a > b ? 1 : 0)).map((k) => `${JSON.stringify(k)}:${canonicalJson(o[k])}`).join(",")}}`;
  }
  throw new InvariantViolation("I15", `unsupported type in canonicalJson: ${typeof v}`);
}
/** Convert basis points to a decimal Rate. */
export const bpToRate = (bp: Bp): Rate => (bp / 10_000) as Rate;
/** Convert a decimal Rate to basis points. */
export const rateToBp = (r: Rate): Bp => (r * 10_000) as Bp;

// ───────────────────────────────────────────────────────────── errors & results

/** The only thrown error: a broken engine identity (I1–I38, docs/spec/goldens/identities.json). Never a player mistake. */
export class InvariantViolation extends Error {
  override readonly name = "InvariantViolation";
  constructor(
    readonly invariantId: string,
    readonly detail: string,
    readonly context?: { seatId?: SeatId; month?: Month; magnitude?: number },
  ) {
    super(`${invariantId}: ${detail}`);
  }
}

/** Domain outcome as a value. */
export type Result<T, E> = { readonly ok: true; readonly value: T } | { readonly ok: false; readonly error: E };

/** Recoverable, player-facing problems (never thrown). */
export const DomainIssue = z.object({
  code: z.enum([
    "leverOutOfRange",
    "conflictingDecisions", // ADR-0049: a combination of decisions the round refuses (each is in range alone)
    "leverLocked",
    "covenantBlocked",
    "supervisoryBlocked",
    "rationaleMissing",
    "forecastRequired",
    "croMemoUnacknowledged",
    "eventResponseMissing",
    "roundClosed",
    "signoffMissing",
    "thesisRequired", // no lever family changed and no ≤140-char thesis line
  ]),
  path: z.array(z.union([z.string(), z.number()])),
  message: z.string(),
});
export type DomainIssue = z.infer<typeof DomainIssue>;

// ───────────────────────────────────────────────────────────── enums

/** 18 balance-sheet books (incl. the discount window, dw) + swap overlay. */
export const BookId = z.enum([
  // assets
  "cash", "ust_afs", "mbs_afs", "mbs_htm", "ci", "cre", "resi", "consumer", "card",
  // liabilities
  "dda", "int_checking", "mmda", "time", "brokered", "fhlb", "ffp", "dw", "sub_debt",
  // off-balance-sheet derivative overlay (the rate-position decision)
  "swap_overlay",
]);
export type BookId = z.infer<typeof BookId>;
export const ASSET_BOOKS = ["cash", "ust_afs", "mbs_afs", "mbs_htm", "ci", "cre", "resi", "consumer", "card"] as const satisfies readonly BookId[];
export const LOAN_BOOKS = ["ci", "cre", "resi", "consumer", "card"] as const satisfies readonly BookId[];
export const DEPOSIT_BOOKS = ["dda", "int_checking", "mmda", "time", "brokered"] as const satisfies readonly BookId[];
/** Books the funding waterfall may plug (I33 order is engine rule, not content). */
export const PLUG_BOOKS = ["cash", "fhlb", "dw", "ffp"] as const satisfies readonly BookId[];
/** Securities books by accounting: AFS carried at fair value (marks → oci:afs + DTA); HTM at amortized cost. */
export const AFS_BOOKS = ["ust_afs", "mbs_afs"] as const satisfies readonly BookId[];
export const HTM_BOOKS = ["mbs_htm"] as const satisfies readonly BookId[];
/**
 * Balance-sheet liability books. With `StaticItemId` "other_liabilities" they are the whole liability side:
 * liabilities = Σ LIABILITY_BOOKS + other_liabilities; equity = Σ Equity fields; total assets = liabilities + equity (I1).
 * `swap_overlay` is off-balance-sheet as a book: the swaps' net fair value sits in total assets when ≥ 0 and in liabilities
 * when < 0 (StatementSet.balanceSheet.booksUsd.swap_overlay carries it signed).
 */
export const LIABILITY_BOOKS = ["dda", "int_checking", "mmda", "time", "brokered", "fhlb", "ffp", "dw", "sub_debt"] as const satisfies readonly BookId[];

export const StaticItemId = z.enum(["premises", "goodwill", "intangibles_cdi", "boli", "dta", "other_assets", "other_liabilities"]);
export type StaticItemId = z.infer<typeof StaticItemId>;

export const Accounting = z.enum(["HFI", "AFS", "HTM", "amortizedCost", "fairValueOci", "na"]);
export const RateType = z.enum(["fixed", "floating", "hybrid", "administered"]);
export const RateIndex = z.enum(["FF", "SOFR", "CP", "prime", "UST_2Y", "UST_10Y", "none"]);
export type RateIndex = z.infer<typeof RateIndex>;
/** 01.2 E1: the market index a product's reference rate (and new-money rate) is read from; spreads are derived at SimStart. */
export const ReferenceIndex = z.enum(["FF", "SOFR", "CP", "UST_2Y", "UST_5Y", "UST_10Y", "MORTGAGE", "MBS", "DEPOSIT", "NONE"]);
export type ReferenceIndex = z.infer<typeof ReferenceIndex>;
export const HqlaLevel = z.enum(["L1", "L2A", "L2B", "none"]);
export const Segment = z.enum(["underbanked", "mass", "affluent", "smallBusiness", "middleMarket", "largeCorporate", "cre_construction", "cre_office", "cre_ownerOccupied", "cre_otherIpre", "na"]);
export type Segment = z.infer<typeof Segment>;
export const Competency = z.enum(["C1", "C2", "C3", "C4"]);
export type Competency = z.infer<typeof Competency>;
/**
 * Complexity levels. Pilot ships `executive` (32 decisions) and `guided` (ADR-0023, OD4-6; ADR-0048): the player owns the focus
 * decisions of each DecisionFamily that are open in the round (ContentPack.guided.focusDecisions); every other decision stays at
 * STANDING_POLICY (provenance derived) and the Expander fills fine decisions as usual.
 */
export const ComplexityLevel = z.enum(["guided", "board", "executive", "manager", "analyst"]);
export const SeatKind = z.enum(["human", "ai", "autopilot"]);
export type SeatKind = z.infer<typeof SeatKind>;
export const PlayMode = z.enum(["facilitated", "solo"]);
/** Underwriting box notch −2 (tight) … +2 (loose). */
export const Box = z.number().int().min(-2).max(2);
export type Box = z.infer<typeof Box>;
export const CamelsRating = z.number().int().min(1).max(5);
export type CamelsRating = z.infer<typeof CamelsRating>;
/** 4 pilot tech themes (expander_personas §1b L14). */
export const TechTheme = z.enum(["digitalRetail", "commercialTm", "riskCompliance", "efficiencyData"]);
export type TechTheme = z.infer<typeof TechTheme>;
export const PcaStatus = z.enum(["wellCapitalized", "adequatelyCapitalized", "undercapitalized", "significantlyUndercapitalized", "criticallyUndercapitalized"]);
export type PcaStatus = z.infer<typeof PcaStatus>;
export const SupervisoryStatus = z.enum(["none", "mou", "consentOrder", "forcedRecap"]);
export type SupervisoryStatus = z.infer<typeof SupervisoryStatus>;
export const ConfidenceTier = z.enum(["high", "medium", "low"]);
export type ConfidenceTier = z.infer<typeof ConfidenceTier>;
export const Direction = z.enum(["up", "down", "flat"]);
export type Direction = z.infer<typeof Direction>;

// ── app-layer shared enums (single definition; contracts + ai + db import these) ──
/** Who may see a Fact: market = published; team = owner seat only; facilitator = facilitators only. */
export const Visibility = z.enum(["market", "team", "facilitator"]);
export type Visibility = z.infer<typeof Visibility>;
export const NarrativeKind = z.enum(["analyst_note", "press_item", "market_wrap", "supervisory_letter", "customer_sentiment"]);
export type NarrativeKind = z.infer<typeof NarrativeKind>;
/** ai_generation.review_state (narratives). */
export const NarrativeReviewState = z.enum(["not_required", "auto_released", "pending_facilitator", "approved", "rejected", "superseded"]);
export type NarrativeReviewState = z.infer<typeof NarrativeReviewState>;
export const VerifierVerdict = z.enum(["pass", "repaired", "fail"]);
export type VerifierVerdict = z.infer<typeof VerifierVerdict>;
/** Kinds always held for the facilitator (never auto-published), whatever the verdict (ADR-0019 §5). */
export const NARRATIVE_HELD_KINDS = ["supervisory_letter"] as const satisfies readonly NarrativeKind[];
/**
 * Publication rule at round close (ADR-0019 §5). Every other kind (analyst notes, press items, …) that
 * passed the verifier (pass | repaired) auto-publishes. Supervisory letters and any verifier-failed item
 * are held for the facilitator; in solo there is no facilitator, so a held item is replaced by its
 * template version. Supervisory letters are ALWAYS content templates, never AI: held = the facilitator releases
 * the template (no editing).
 */
export function narrativeDisposition(kind: NarrativeKind, verdict: VerifierVerdict, mode: "facilitated" | "solo"): "autoPublish" | "holdForFacilitator" | "templateFallback" {
  const held = (NARRATIVE_HELD_KINDS as readonly NarrativeKind[]).includes(kind) || verdict === "fail";
  if (!held) return "autoPublish";
  return mode === "solo" ? "templateFallback" : "holdForFacilitator";
}
export const AssessmentStatus = z.enum(["draft", "needs_review", "reviewed", "released"]);
export type AssessmentStatus = z.infer<typeof AssessmentStatus>;
/** Competency proficiency level 1–4 (facilitator-facing only; participants never see levels). */
export const CompetencyLevel = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]);
export type CompetencyLevel = z.infer<typeof CompetencyLevel>;
/** Coach hint ladder: 0 concept · 1 pointed question · 2 lever + direction (never a value). UI shows level+1. */
export const HintLevel = z.union([z.literal(0), z.literal(1), z.literal(2)]);
export type HintLevel = z.infer<typeof HintLevel>;
export const ConceptCardId = z.string().regex(/^CC-[0-9]{2}$/);
export type ConceptCardId = z.infer<typeof ConceptCardId>;
/** Developmental feedback item (participant-visible after facilitator release). */
export const FeedbackItem = z.object({
  kind: z.enum(["strength", "growth"]),
  competency: Competency,
  round: RoundIndex,
  citedBehavior: z.string(),
  whyItMatters: z.string(),
  tryNextTime: z.string(),
  reflect: z.string(),
});
export type FeedbackItem = z.infer<typeof FeedbackItem>;

/** KPI ids; unit + @gxs/metric-defs mapping lives in KPI_DEFS. */
export const KpiId = z.enum([
  "nii", "nim", "roa", "roe", "rotce", "eps", "dps", "efficiencyRatio", "feeIncome", "feeGrowth", "coreRevenueGrowth",
  "cet1Reported", "cet1Marked", "tier1", "trbc", "leverage", "rwa",
  "lcrLite", "slc", "ldr", "adjLdr", "uninsuredShare", "wholesaleShare", "depositGrowth", "costOfDeposits", "ibDepositCost", "ddaShare", "cumulativeBeta",
  "ncoRate", "nplRate", "aclRatio", "provision", "creToTrbc", "constructionToTrbc", "creGrowth36m",
  "aoci", "htmMark", "niiSensitivity", "eve200",
  "niiSensitivityLossRate", // ADR-0086: the income lost in the worse of the ±100bp shocks, as a positive share of a year's NII (max(0, −IrrSnapshot.niiSensitivityWorseRate)); an own limit (le) and the supervisory S threshold read it
  "tbvps", "price", "ptbv", "coe", "valueCreated", "camelsComposite",
  "customerIndex", "employeeIndex",
  "loanGrowth", // gross loans, trailing-12-month growth (Growth pillar; golden probes)
]);
export type KpiId = z.infer<typeof KpiId>;
/** `multiple` renders as "1.55x" (P/TBV). */
export type KpiUnit = "usd" | "usdPerShare" | "rate" | "bp" | "index" | "rating" | "multiple";
/** Unit and metric-definition link per KPI (metricDefId resolves in @gxs/metric-defs when shared). */
export const KPI_DEFS: Readonly<Record<KpiId, { unit: KpiUnit; metricDefId?: string }>> = {
  nii: { unit: "usd" }, nim: { unit: "rate", metricDefId: "nim" }, roa: { unit: "rate", metricDefId: "roa" },
  roe: { unit: "rate" }, rotce: { unit: "rate", metricDefId: "rotce" }, eps: { unit: "usdPerShare" }, dps: { unit: "usdPerShare" },
  efficiencyRatio: { unit: "rate", metricDefId: "efficiency_ratio" }, feeIncome: { unit: "usd" }, feeGrowth: { unit: "rate" },
  coreRevenueGrowth: { unit: "rate" }, cet1Reported: { unit: "rate", metricDefId: "cet1_ratio" },
  cet1Marked: { unit: "rate", metricDefId: "cet1_marked" }, tier1: { unit: "rate" }, trbc: { unit: "rate" },
  leverage: { unit: "rate" }, rwa: { unit: "usd" }, lcrLite: { unit: "rate" }, slc: { unit: "rate" }, ldr: { unit: "rate" },
  adjLdr: { unit: "rate", metricDefId: "adjusted_ldr" }, uninsuredShare: { unit: "rate" }, wholesaleShare: { unit: "rate" },
  depositGrowth: { unit: "rate" }, costOfDeposits: { unit: "rate" }, ibDepositCost: { unit: "rate" }, ddaShare: { unit: "rate" },
  cumulativeBeta: { unit: "rate" }, ncoRate: { unit: "rate" }, nplRate: { unit: "rate" }, aclRatio: { unit: "rate" },
  provision: { unit: "usd" }, creToTrbc: { unit: "rate" }, constructionToTrbc: { unit: "rate" }, creGrowth36m: { unit: "rate" },
  aoci: { unit: "usd" }, htmMark: { unit: "usd" }, niiSensitivity: { unit: "rate" }, eve200: { unit: "rate" }, niiSensitivityLossRate: { unit: "rate" },
  tbvps: { unit: "usdPerShare", metricDefId: "tbvps" }, price: { unit: "usdPerShare" }, ptbv: { unit: "multiple" },
  coe: { unit: "rate" }, valueCreated: { unit: "rate" }, camelsComposite: { unit: "rating" },
  customerIndex: { unit: "index" }, employeeIndex: { unit: "index" }, loanGrowth: { unit: "rate" },
};
/** Competitive-info KPI subset published for every seat (never levers, never gated internals). */
export const PUBLIC_KPIS = ["price", "ptbv", "tbvps", "rotce", "nim", "efficiencyRatio", "cet1Reported", "ncoRate", "depositGrowth", "dps", "customerIndex"] as const satisfies readonly KpiId[];
/**
 * ADR-0076: the further KPIs a real peer group's public filings give (return on assets, cost of deposits, loans to deposits, uninsured share, non-performing loans, reserve coverage,
 * CRE to total capital, the game's liquidity cover, total capital ratio, demand-deposit share, loan growth). Kept apart from `PUBLIC_KPIS` so the stored published market (and every state hash) is unchanged;
 * read from each bank's own KPIs when the market view is served (`MarketView.banks[].kpisExtended`).
 */
export const PUBLIC_KPIS_EXTENDED = ["roa", "costOfDeposits", "ldr", "uninsuredShare", "nplRate", "aclRatio", "creToTrbc", "lcrLite", "trbc", "ddaShare", "loanGrowth"] as const satisfies readonly KpiId[];
/**
 * "Call the year" (OD5-1, ADR-0026 §1). At round open each team forecasts exactly these KPIs
 * FOR ITS STATUS-QUO TWIN: the round-end values the bank would post if it changed nothing this round = the per-round
 * autopilot counterfactual from the round-start state (cp2 counterfactual; 10.4). Levers cannot move the twin, so there
 * is no re-lock: ONE commit per team per round, and after it the preview is open all round.
 * CET1 = MARKED CET1 (13.1): the twin runs the autopilot capital rule, so its REPORTED CET1 sits at ≈ 11.33%
 * (±1bp) at every quarter-end in both storylines and "same as last year" is always right; marked CET1 (reported + after-tax
 * AFS AOCI + HTM mark) moves 8–60bp a year with rates and pull-to-par, and is the capital number the game teaches (C3).
 */
export const FORECAST_GATED_KPIS = ["nim", "ncoRate", "cet1Marked"] as const satisfies readonly KpiId[];
export type ForecastKpi = (typeof FORECAST_GATED_KPIS)[number];
/** Forecast input format by complexity (OD5-6): executive = numeric; guided = band picker (forecastFormatFor). */
export const ForecastFormat = z.enum(["numeric", "band"]);
export type ForecastFormat = z.infer<typeof ForecastFormat>;
/** Guided band picker (OD5-6): change vs last year's value (noChangeBaseline, the previous-window measure; 13.1), in the order shown. Cut points: ContentParams.forecast.bands. */
export const ForecastBand = z.enum(["down", "flat", "upLittle", "upLot"]);
export type ForecastBand = z.infer<typeof ForecastBand>;
/**
 * What the preview actually masks BEFORE the round's forecast commit = forecast KPIs + reported CET1 (both CET1s stay masked:
 * marked CET1 is derivable from reported CET1 + marks). No route or screen may show a forward (projected) value of these before the commit — the cockpit shows
 * released actuals only (no status-quo-twin CET1 projection band) and event cards mask their CET1 facts
 * (EVENT_GATED_FACT_KEYS, OD5-3). After the commit nothing is masked for the rest of the round.
 */
export const PREVIEW_GATED_KPIS = [...FORECAST_GATED_KPIS, "cet1Reported"] as const satisfies readonly KpiId[];
/** KPI values by id (unit per KPI_DEFS). */
export const KpiSnapshot = z.partialRecord(KpiId, z.number());
export type KpiSnapshot = z.infer<typeof KpiSnapshot>;

// ───────────────────────────────────────────────────────────── predicates (content triggers)

/**
 * Trigger-only derived metrics (OD5-7; 12.1). Evaluated by planRoundEvents on the ROUND-START state and
 * the PublishedMarket (peers = all seats' published KPIs). Units in the name: *Ratio = multiple of the peer median (1 = median),
 * *Rate = decimal difference. Pilot values of any threshold are content (EventCard.trigger.when), pinned in gameplay data.
 */
export const TriggerMetric = z.enum([
  "ptbvToPeerMedianRatio",     // own P/TBV ÷ median P/TBV of all seats (activist; EV-05 HFL eligibility uses the same measure)
  "rotceToPeerMedianRatio",    // own trailing ROTCE ÷ peer median
  "rotceMinusCoeRate",         // trailing ROTCE − COE (negative = earning below the cost of equity)
  "tsrVsPeerMedianRate",       // own PublishedMarket peers[].tsrSinceSimStartRate − median of all seats' (negative = lagging)
  "efficiencyRatioVsPeerMedianRate",
  "aociToCet1Rate",            // AOCI ÷ CET1 (EV-01 trigger)
  "fhlbCapacityUsedRate",      // FHLB used ÷ capacity
  "ciGrowthVsTrendRate",       // own trailing-24-month C&I balance growth − market C&I DEMAND growth over the same 24 months (03.1 g^D compounded; seat-independent; months before SimStart at trend), from QuarterRecord.booksUsd (EV-07, P4-D5)
  "officeVacancyRate",         // the round-start EnvSnapshot.officeVacancyRate (market-level; EV-02 soft-landing severity)
  "officeShareOfCreRate",      // own office CRE (Segment cre_office) balance ÷ own CRE balance; 0 = no office exposure (EV-02)
  "roundIndex",                // the round being planned (personas and cards; 12.1)
  "ndfiSliceUsd",              // BankState.credit.ci.ndfiShareRate × C&I balance on the round-start snapshot; EV-07 fires only when > 0 (M6; 03.2, 12.1 E1)
]);
export type TriggerMetric = z.infer<typeof TriggerMetric>;
/**
 * A Predicate.metric must be a KpiId, a TriggerMetric, or a scenario flag declared in EnvSnapshot.flags ("flag" op).
 * Decision settings use op "decision", never a metric name. The content build rejects anything else (content test, WP26).
 */
export function isPredicateMetric(m: string): boolean {
  return (KpiId.options as readonly string[]).includes(m) || (TriggerMetric.options as readonly string[]).includes(m);
}

/**
 * Comparison of a named metric (KpiId or TriggerMetric; flags use op "flag") to a value.
 * op "decision" (EV-02 "CRE box ≥ +1"): compares the seat's decision setting IN FORCE at evaluation (the decisions of its last
 * effective submission; R1 = STANDING_POLICY) at `path` to a number. Numeric decision paths only (notches, boxes, rates, Usd;
 * e.g. "loans.cre.underwriting", "loans.ci.growth", "capital.buyback.cet1TargetRate"); an enum, boolean or null-valued path fails the content build (WP26).
 */
export type Predicate =
  | { op: "all"; of: Predicate[] }
  | { op: "any"; of: Predicate[] }
  | { op: "not"; of: Predicate }
  | { op: "cmp"; metric: string; cmp: "lt" | "le" | "gt" | "ge" | "eq" | "ne"; value: number }
  | { op: "decision"; path: string; cmp: "lt" | "le" | "gt" | "ge" | "eq" | "ne"; value: number }
  | { op: "flag"; flag: string };
export const Predicate: z.ZodType<Predicate> = z.lazy(() =>
  z.union([
    z.object({ op: z.literal("all"), of: z.array(Predicate) }),
    z.object({ op: z.literal("any"), of: z.array(Predicate) }),
    z.object({ op: z.literal("not"), of: Predicate }),
    z.object({ op: z.literal("cmp"), metric: z.string(), cmp: z.enum(["lt", "le", "gt", "ge", "eq", "ne"]), value: z.number() }),
    z.object({ op: z.literal("decision"), path: DecisionPath, cmp: z.enum(["lt", "le", "gt", "ge", "eq", "ne"]), value: z.number() }),
    z.object({ op: z.literal("flag"), flag: z.string() }),
  ]),
);

// ───────────────────────────────────────────────────────────── model refs (params per kind)

export const ModelKind = z.enum([
  "depositBeta", "depositFlow", "loanDemand", "logitShare", "underwriting", "creditPd", "cecl", "prepay", "mtm", "fees", "opex", "capability",
]);
export type ModelKind = z.infer<typeof ModelKind>;
/** No free-form `extra` bags: a new parameter = a new model version (ModelRef.version) + schema field. */

/**
 * Deposit beta (01.3): reference target = r₀ + β·(FF − FF₀) with a
 * CONSTANT through-cycle β per product and one h; reference r += h·(target − r); indexed tranche (β 0.95) has no lag.
 * The lever offset sits OUTSIDE the lag: posted = max(floor, reference + offset) (G6 HARD +21.33bp step at m13).
 * `logistic` and `downAsymmetry` are v1: the pilot pack leaves them unset.
 */
export const DepositBetaParams = z.object({
  betaThroughCycle: z.number().min(0).max(1.2),
  adjustmentSpeedPerMonth: z.number().min(0).max(1), // h (01.3 E2): 0.06 on IC, retail MMDA and new CDs (M3(iii)); 1 = lag-free (indexed, brokered)
  /** @deprecated lag-free ⇔ adjustmentSpeedPerMonth = 1 (01.3). */
  indexedNoLag: z.boolean().optional(),
  logistic: z.object({ midpointRate: Rate, slope: z.number(), betaMin: z.number(), betaMax: z.number() }).optional(), // v1
  downAsymmetry: z.number().positive().optional(), // v1: multiplier on h when rates fall
  floorRate: Rate,
});
/** Organic deposit flows: retention vs price/service/branch/tech, DDA migration, branch-closure attrition, λ/3 return. */
export const DepositFlowParams = z.object({
  baseGrowthAnnualRate: Rate,
  /**
   * DDA migration (02.2): the DDA share drifts toward s₀·e^(−θ·FF) at `driftSpeedPerMonth` (0.20);
   * migrated balances move to `receivingProductId` (retail MMDA). θ = 5 provisional (G1 band implies 2.1–7.4).
   */
  ddaMigration: z.object({ thetaPerRate: z.number().nonnegative(), driftSpeedPerMonth: z.number().min(0).max(1), receivingProductId: ProductId, s0: Rate }),
  branchClosureAttritionRate: Rate, // a_br (02.3 E1): 0.20 of closed-branch deposits at a one-shot cut of branchClosureAttritionRefCutRate (M2)
  branchAttritionRealizationMonths: z.number().int().positive(), // ≥90% within this many months (02.3 E2 hazard; 12, OR-30.5)
  /** c_ref (02.3 E1 depth rule): attrition a = a_br·(x0 + x1) ÷ c_ref for a closure moving the cumulative depth x0 → x1. */
  branchClosureAttritionRefCutRate: Rate.optional(),
  /** ω_open (02.3 E1, M2): an opening wins ω_open × a_br of the new branches' share of branch deposits from rivals (via Φ, 02.1). */
  branchOpeningGainShare: Rate.optional(),
  /** 02.3 BD_i: branch-served share of the balances of dda, int_checking, mmda_retail, time_cd = SS /franchise/branchDepositsUsd ÷ their SimStart balances (indexed MMDA is not branch-served); the L13/L15/L16 attrition base is this × the branch-scope balances. */
  branchServedShareRate: Rate,
  /** ρ (02.3 E2): share realized within branchAttritionRealizationMonths (pin flow.branchAttrition.realizedShare, 0.9). */
  attritionRealizedShare: Rate.optional(),
  /** @deprecated ADR-0055 (Gate 4, R5): the market grows at baseGrowthAnnualRate at every rate; the rate gap moves a level, `moneyFundPool`. Unread. */
  rateLeakagePer100Bp: z.number().optional(),
  /**
   * 02.2 E1–E3 (ADR-0055, P4-D2): checking migration. The natural checking share of deposits falls `naturalShareSlopePer100Bp` per 100bp of fed funds above
   * `naturalShareKneeRate` (anchored on SimStart's share at SimStart's fed funds); the share of checking moved to `receivingProductId` is drawn toward the rate-level target
   * at `outSpeedPerMonth` (back at 1 ÷ lostBalanceReturnDivisor of it), never past 1 − the product's operating floor (`floorShareByProduct`: dda 0.70; int_checking 0.60, the base leak's floor, 02.5 E6).
   * Absent = no migration and no floor.
   */
  checkingMigration: z.object({
    naturalShareKneeRate: Rate, naturalShareSlopePer100Bp: Rate, outSpeedPerMonth: z.number().min(0).max(1),
    floorShareByProduct: z.partialRecord(ProductId, Rate), receivingProductId: ProductId,
  }).optional(),
  /**
   * 02.1 E1a (ADR-0055, R5): the money-fund pool, the share of deposits p in money funds and bills: `shareOfDepositsPer100BpGap` per 100bp that fed funds pays over the deposit
   * market's average rate beyond SimStart's gap, drawn at `outSpeedPerMonth` (back at 1 ÷ lostBalanceReturnDivisor of it). Absent = no pool.
   */
  moneyFundPool: z.object({ shareOfDepositsPer100BpGap: Rate, outSpeedPerMonth: z.number().min(0).max(1) }).optional(),
  /**
   * Franchise cost of the service index (02.3 E1). Each service-index point LOST (L13 serviceIndexDelta < 0; also customerIndex −1:1) adds
   * ratePerPointOfBranchDeposits × branch-served deposits (franchise, scaling with balances) to pending attrition, realized
   * linearly over realizationMonths and replaced through the funding waterfall (same channel as branch closures). A point
   * GAINED wins gainShareOfLoss × that rate. Permanent in the pilot (no recovery). Pilot pins 0.0387 / 0.5 / 24, anchored
   * so G7 B-j (L13 Modest R1–R4) = +0.30pp; re-anchor this rate, not the band, if the engine lands elsewhere.
   */
  serviceAttrition: z.object({
    ratePerPointOfBranchDeposits: Rate, gainShareOfLoss: Rate, realizationMonths: z.number().int().positive(),
    /** OR-30.45: the rate for the points an expense programme moves (half of the pay / closure rate; 02.3 E1). Absent = the same rate. */
    ratePerPointOfExpenseProgramme: Rate.optional(),
    /** L16 notches priced through the service index (07.4 E6, M1): customer-index points per fee / comp notch. */
    customerIndexPointsPerNotch: z.object({ fees: z.number(), comp: z.number() }).optional(),
  }),
  lostBalanceReturnDivisor: z.number().positive(), // λ/3
  hotMoneyAttritionMult: z.number().positive(), // ×2 (02.1 E5; M7a); excess to the outside good
  sympathyOutflowShare: Rate.optional(),
  /**
   * 02.5 / 02.6 (Gate 3c, ADR-0048; R2.2): the front book. The keys R1.3 put under `depositFlow` in model_params_v1.json; absent = the one-rate
   * market (no front lots). By product where marked: the checking, retail and indexed MMDA take the front/back rules, `time_cd` only the multiple.
   */
  rateSensitivityMultByProduct: z.partialRecord(ProductId, z.number().positive()).optional(), // σ_k: multiplies the share utility, acquisition and the base leak
  newMoneyShareByProduct: z.partialRecord(ProductId, Rate).optional(), // τ_k: share of the base a year that turns over as new money
  newMoneyNotchBp: z.number().positive().optional(), // one notch of the front/back/CD rate decisions
  acquisitionBaseRatePerYear: Rate.optional(), // a_k: one standard year of acquisition, share of Φ
  marketingAcquisitionElasticity: z.number().positive().optional(), // ε of the marketing multiple
  acquisitionRatePerNotch: z.number().nonnegative().optional(), // κ: standard months of acquisition per notch of new-money gap
  frontBookMonths: z.number().int().positive().optional(), // n_front
  ownBaseMigrationShare: Rate.optional(), // μ: the part of a lead's inflow that is the bank's own base repricing
  baseLeakRatePerMonth: Rate.optional(), // λ_b
  baseLeakNewMoneyGapShare: Rate.optional(), // θ
  frontLotEveDurationYears: z.number().nonnegative().optional(), // 05.5: a front lot's EVE duration until it graduates
  frontLotBeta: z.number().nonnegative().optional(), // 05.5: a front lot's pass-through until it graduates
});
/** Loan demand f(GDP, CPI, rate). */
export const LoanDemandParams = z.object({
  baseGrowthAnnualRate: Rate,
  gdpElasticity: z.number(),
  cpiElasticity: z.number(),
  rateElasticityPer100Bp: z.number(), // L5 acts through share (14.1), not through market demand
  /** ADR-0068: percentage-point change in loan demand per point of unemployment above its base (04.3 D1, PROPOSED; absent = 0, today's behaviour). */
  unemployment: z.number().optional(),
});
/**
 * Logit share (14.1): U = +β_r·gap + β_m·φ(x) + γ·(cap − cap̄), where gap is the
 * CUSTOMER-FAVOURABLE price gap in pp (+ = pays more on deposits / cheaper loans; = cp2 LogitShareModel), x = marketing ÷ M0,
 * φ(x) = ln x for x ≤ knee, ln knee + slopeAboveKnee·ln(x/knee) above. Deposits: stock shares move toward the
 * logit target at λ (4–6%/month). Loans: new origination flow takes the equilibrium share each month (no λ).
 */
export const LogitShareParams = z.object({
  betaRPerPp: z.number(),                   // β_r per pp of customer-favourable price gap
  betaM: z.number(),                        // β_m (marketing)
  gamma: z.number(),                        // γ (capability gap)
  saturationKneeMultiple: z.number().positive(),   // 2
  saturationSlopeAboveKnee: z.number().positive(), // 0.25
  /** Deposits: 0.04–0.06 (stock shares move toward target). Loans: 1.0 (new flow at the equilibrium share). */
  adjustmentLambdaPerMonth: z.number().min(0.02).max(1), // ADR-0092: the floor widened 0.04 → 0.02 (commercial checking moves slower than retail)
  deadBandBp: Bp.optional(),
});
/** Underwriting box: approval logistic, loss multiplier exp(κ·box), marginal-applicant form. */
export const UnderwritingParams = z.object({
  kappa: z.number(), // 0.25 pinned
  alpha: z.number(), // 0.35
  baseApprovalRate: Rate,
  creSeverityPerNotchRate: Rate, // +5pp per notch
  recognitionStartFraction: z.number(), // κ_r = 0.5κ at origination
  recognitionRampMonths: z.number().int().positive(), // → κ by 12m
});
/**
 * Monthly per-book credit (04.1 E1–E7, 04.2): the trend loss ℓ_v = B_v·[1 + (M_v − 1)·σ(a)]·k_v·LGD_v/LGD_b·λ0_b/12 (box seasoned only
 * where seasonsBoxEffect: consumer, card; 03.4 ramp) through the charge-off queue; the stress loss a working-out stock on the worst decline
 * of the book's macro driver (lagged driverLagMonths) along `lossCurve` (v2.9, P4-D13); nonaccrual window nonaccrualQuarters.
 */
export const CreditPdParams = z.object({
  basePdAnnualRate: Rate,
  macroBetas: z.object({ unemployment: z.number(), hpi: z.number(), creIndex: z.number(), officeIndex: z.number(), gdp: z.number() }).partial(), // one driver per book: the key names it (v2.9: the value is no longer read)
  lgdBaseRate: Rate,
  chargeOffScheduleByQuarter: z.array(Rate), // CRE/C&I 70/20/10
  nonaccrualRiskWeightMult: z.number().optional(), // 150% non-resi
  driverLagMonths: z.number().int().nonnegative(), // 04.1 E2: 3 commercial/resi, 0 consumer/card
  burnoutPoolRate: Rate, // v2.9: no longer read (the stress loss is the lossCurve stock; data keeps the old pool)
  nonaccrualQuarters: z.number().int().nonnegative(), // 04.2: 0 = card, never on NPL
  /** ADR-0092 (CB10, 04.1 E8, OR-30.24): the book's loss multiple per unit of growth above trend, 1 + κ·(G − ḡ); absent = the pin `credit.growthLoss.perUnit.<book>` (today's data), else no channel. */
  growthLossPerUnit: z.number().nonnegative().optional(),
  seasonsBoxEffect: z.boolean().optional(), // 04.1 E1 σ(a) on the box effect (consumer, card)
  longRateIndexCutPerPp: z.number().optional(), // 04.1 E2 (M3(i), CRE): index × (1 − ε·max(0, Δ10y pp))
  /** 04.2 E3 n0_b: trend nonaccrual as a share of the book (SimStart NPL ÷ balance), so it grows with B_b. */
  trendNonaccrualRate: Rate.optional(),
  /** @deprecated one LGD per book; stress severity via shocks (04.1). */
  lgdStressRate: Rate.optional(),
  /** @deprecated seasoning uses the 03.4 recognition ramp. */
  seasoningModeMonths: z.number().positive().optional(),
  /** @deprecated as seasoningModeMonths. */
  seasoningShape: z.number().positive().optional(),
  /** @deprecated use burnoutPoolRate. */
  burnoutCapMult: z.number().positive().optional(),
  /**
   * v2.9 (ADR-0057, P4-D13) 04.1 E3 lifetime stress loss per $ on the worst driver decline d: τ(d) = Σ_s shareRate·[preCushionSlopeRate·d +
   * severeExcessLossRate·(max(0, d − driverCushion)/(severeDriverLevel − driverCushion))^excessPower] (driver units: unemployment pp above SimStart,
   * index decline as a fraction); 04.2 E4–E6 the workout backlog's monthly charge-off share, the recovery trim cap and the stress nonaccrual entry and
   * exit rates. Computed by the builder (ch04.py::calibrate). Absent = no stress loss (a run-rate stand-in).
   */
  lossCurve: z.object({
    severeDriverLevel: z.number().positive(),
    excessPower: z.number().positive(),
    segments: z.array(z.object({ id: z.string(), shareRate: Rate, driverCushion: z.number().nonnegative(), preCushionSlopeRate: z.number().nonnegative(), severeExcessLossRate: Rate })).min(1),
    workoutRatePerMonth: Rate,
    recoveryTrimMaxRate: Rate,
    nonaccrualEntryRatePerMonth: Rate,
    nonaccrualExitRatePerMonth: Rate,
  }).optional(),
});
/**
 * CECL-lite (04.3 E1–E4; M4): current driver + forecastWeight (0.25) of the consensus change
 * over the next four quarters, held holdQuarters (4), reverted straight-line over reversionQuarters (4) to TTC (ProductDef.ttcLossRate);
 * one forward sum per book over lifeYears; qFactorRate solved unrounded so SimStart ACL is exact.
 */
export const CeclParams = z.object({
  forecastWeight: z.number(), // 0.25 (M4)
  holdQuarters: z.number().int(), // 4 (M4)
  reversionQuarters: z.number().int(), // 4
  qFactorRate: Rate,
  lifeYears: z.number().positive(), // 04.3: per book, from the G4 oracle
  /** @deprecated TTC lives only on ProductDef.ttcLossRate. */
  ttcLossRate: Rate.optional(),
});
/** Prepayment S-curve on refinance incentive; moneyness-based convexity feeds mtm. */
export const PrepayParams = z.object({
  baseCprRate: Rate,
  /** 05.1 E1: x = the mortgage-rate rally (bp) since the vintage's prepayAnchorRate; midpointBp = the rally at which CPR is halfway (one value, 285). */
  sCurve: z.object({ midpointBp: Bp, slopePerBp: z.number(), minCprRate: Rate, maxCprRate: Rate }),
  burnout: z.number().optional(),
});
/** MTM ΔP ≈ −D·Δy + ½C·Δy², duration updated along path; convexity by moneyness. */
export const MtmParams = z.object({
  convexityByMoneyness: z.array(z.object({ moneynessBp: Bp, convexity: z.number() })),
  /** 05.4: K(T) = UST curve at T + swapSpreadBp (−10); the swap MtmParams sit in ArchetypePack.bankModels (id mtm.swap). */
  swapSpreadBp: Bp.optional(),
  /** ADR-0069 (05.4 E1, P5-D4): the dealer's margin, paid by the bank once at entry, struck into the fixed rate; absent = 0. */
  swapDealerMarginBp: Bp.optional(),
  /** @deprecated use swapSpreadBp. */
  termPremiumBp: Bp.optional(),
});
/** Fee income by line, fee posture, and fee-growth trend (feeds EV-03 BSA trigger). */
const FeeLine = z.enum(["deposit", "treasury", "card", "wealth", "mortgage", "other"]);
export const FeesParams = z.object({
  baseFeesAnnualUsd: z.partialRecord(FeeLine, Usd),
  depositBalanceElasticity: z.number(),
  /** D_ℓ(0) (07.2 E1): SimStart driver balance of the lines that follow a book (deposit, treasury, card, mortgage). Absent line = follows σ (wealth, other). */
  driverBaseUsd: z.partialRecord(FeeLine, Usd),
  // fee schedule multiplier comes from FineDecisions.operations.feeScheduleMult (L16)
  techThemeUplift: z.partialRecord(TechTheme, z.number()).optional(),
  /**
   * ADR-0086 (CB4; N2, 07.2 E3/E4): the earnings credit on commercial checking and the mortgage-banking wave, typed. Each was a numeric pin (`ContentParams.pins` `fees.ecr.*`, `fees.mortgage.*`); the models read the field first
   * and the pin as the fallback, and absent in both = the effect is off. `ecrAnalysedShareRate` s_an: the share of commercial checking in analysed accounts that settle in fees; `ecrPassThroughRate` β_ecr: the credit's rise per unit rise in fed funds;
   * `ecrStartRate` ECR(0) and `ecrFloorRate`: the credit rate at SimStart and the least it falls to; `mortgageRefiShareRate` ρ_refi: the refinancing part of the mortgage-banking line at SimStart; `mortgagePurchaseRateSensitivity` κ_purchase:
   * the purchase part's fall per percentage point of mortgage-rate rise.
   */
  ecrAnalysedShareRate: Rate.optional(),
  ecrPassThroughRate: z.number().nonnegative().optional(),
  ecrStartRate: Rate.optional(),
  ecrFloorRate: Rate.optional(),
  mortgageRefiShareRate: Rate.optional(),
  mortgagePurchaseRateSensitivity: z.number().nonnegative().optional(),
});
export const OpexParams = z.object({
  baseOpexAnnualUsd: Usd,
  /** ADR-0086 (CB4; N2, 07.3 E15): the deposit-insurance assessment a_c in bp a year of total assets less Tier 1 capital, for composites 1 to 5 (index 0 = composite 1); `opex.depositInsurance.c1…c5` pins are the fallback; absent in both = no assessment. */
  depositInsuranceBpByComposite: z.array(Bp).length(5).optional(),
  controllableOpexChangeRate: z.object({ investAggressively: Rate, invest: Rate, none: Rate, modest: Rate, aggressive: Rate, deep: Rate }), // 07.3 E2 level rates (values: model_params opex ref; owner M2, M10)
  /** One-time charge × annual savings by L13 level: {invest 0, none 0, modest 1.0, aggressive 1.2, deep 1.5} (expander §1a). */
  restructuringChargeMultByLevel: z.object({ investAggressively: z.number(), invest: z.number(), none: z.number(), modest: z.number(), aggressive: z.number(), deep: z.number() }),
  /** Service-index change per L13 program by level (owner M2; Modest's small cost, M10); priced by DepositFlowParams.serviceAttrition (02.3 E1). */
  serviceIndexDeltaByLevel: z.object({ investAggressively: z.number(), invest: z.number(), none: z.number(), modest: z.number(), aggressive: z.number(), deep: z.number() }),
  /** 07.3 E9 (ADR-0049): an Invest level tops up the efficiency-and-data theme's spend for the programme's first 12 months by this share ({investAggressively 0.20, invest 0.10}). */
  investTechTopUpRateByLevel: z.object({ investAggressively: Rate, invest: Rate }).optional(),
  costPerBranchAnnualUsd: Usd,
  /** N0 (07.3 E3): the SimStart branch count; ΔN = franchise.branchCount − N0. */
  branchCountAtSimStart: z.number().int().positive(),
  /** 07.3 E3: the lines L13 scales, SimStart $/yr (Σ = expander.controllableOpexBaseUsd). */
  baseLinesAnnualUsd: z.object({ comp: Usd, occupancy: Usd, other: Usd }).optional(),
  cdiAmortizationAnnualUsd: Usd.optional(), // 07.3 E5 (fixed)
  trainingBaseAnnualUsd: Usd.optional(), // 07.3 E3 Tr0
  /** 07.3 E6 (M2): one-time build cost of an opening, × costPerBranchAnnualUsd (the branch carries full running cost from then on). */
  branchOpeningCostMult: z.number().nonnegative().optional(),
  /** 07.3 E3 σ_cl (M2): a closed branch saves this share of costPerBranchAnnualUsd. */
  /** 07.3 E8 (ADR-0060): the most all programmes' service points together can drive out, as a share of the branch-served base (0.08); absent = uncapped. */
  serviceDepositLossCapShareOfBranchDeposits: Rate.optional(),
  branchClosureSavingShare: Rate.optional(),
  /**
   * 07.3 E2a ρ (M10): repeat programs find less. The k-th cut program since SimStart (k = 0 first; any cut
   * level; Invest and None do not count) achieves controllableOpexChangeRate[level] × ρ^k, and its restructuring charge is sized
   * on that. Absent = 1 (no diminishing returns).
   */
  repeatProgramSavingsRetentionRate: Rate.optional(),
  /** 07.3 E7 (Gate 3d): the lease-exit charge per branch a closure closes. */
  branchLeaseExitChargePerBranchUsd: Usd.optional(),
  /** @deprecated ADR-0055 (Gate 4, P4-D7): OR-18's team cut is replaced by `costCutChannels` (attrition spike). Unread. */
  teamCutShareOfRunRateCutByLevel: z.partialRecord(z.string(), Rate).optional(),
  /** 07.3 E3a (ADR-0055, R1): the share of the scenario's CPI the programme lines are paid at; the price index I(m) = Π(1 + κ·CPI(k))^(1/12). Absent = 0 (no inflation). */
  cpiPassThroughRate: z.number().nonnegative().optional(),
  /** 07.3 E3 (ADR-0055, R1): the programme lines grow with the balance sheet σ at this elasticity while σ ≥ 1, and fall with it at `opexDownwardElasticityRate` below. Absent = 1. */
  opexBalanceElasticityRate: z.number().nonnegative().optional(),
  opexDownwardElasticityRate: z.number().nonnegative().optional(),
  /**
   * 07.3 E10–E14 (ADR-0055, P4-D7): the channels of a cost cut beyond its bare saving, by level: the realised share (creep-back between `creepBackStartMonth` and `creepBackEndMonth`),
   * the best-banker attrition spike (RM attrition rate, months, leaver book multiple and share taken; 03.5 E7), the fee drag on the deposit and treasury lines, Deep's operational losses
   * and the quarter-ends the management rating sits one notch down (09.1).
   */
  costCutChannels: z.object({
    realisedShareByLevel: z.partialRecord(z.string(), Rate), creepBackStartMonth: z.number().int().nonnegative(), creepBackEndMonth: z.number().int().positive(),
    rmAttritionAnnualRateByLevel: z.partialRecord(z.string(), Rate), attritionSpikeMonthsByLevel: z.partialRecord(z.string(), z.number().int().positive()),
    leaverBookMultByLevel: z.partialRecord(z.string(), z.number().positive()), leaverBookTakenRateByLevel: z.partialRecord(z.string(), Rate),
    feeDragRateByLevel: z.partialRecord(z.string(), Rate), operationalLossAnnualUsdByLevel: z.partialRecord(z.string(), Usd), operationalLossMonths: z.number().int().positive(),
    managementNotchQuartersByLevel: z.partialRecord(z.string(), z.number().int().positive()),
  }).optional(),
});
/** Capability stocks (07.4 E1–E9): 1-year lag, δ decay; competition enters through 14.1 γ, not a fair share. */
export const CapabilityParams = z.object({
  lagMonths: z.number().int(), // 12
  decayAnnualRate: Rate, // δ 20%
  elasticity: z.number(), // π: return per $ of referenceSpendAnnualUsd per log unit (1.2158, anchored to G7 B-a)
  referenceSpendAnnualUsd: Usd.optional(), // T0 (80M)
  /** F0 (07.4 E4): SimStart annual fees, Σ of the fee-line base; divides the fee effect. */
  feeBaseAnnualUsd: Usd,
  /** ΣL0 (07.4 E4): SimStart annual comp + occupancy + other, the L13-scaled lines; divides the efficiency effect. */
  efficiencyBaseAnnualUsd: Usd,
  /** @deprecated competition is 14.1's γ. */
  fairShareWeight: z.number().optional(),
});

/** A versioned model reference; params schema is selected by kind. */
export const ModelRef = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("depositBeta"), id: z.string(), version: SemVer, params: DepositBetaParams }),
  z.object({ kind: z.literal("depositFlow"), id: z.string(), version: SemVer, params: DepositFlowParams }),
  z.object({ kind: z.literal("loanDemand"), id: z.string(), version: SemVer, params: LoanDemandParams }),
  z.object({ kind: z.literal("logitShare"), id: z.string(), version: SemVer, params: LogitShareParams }),
  z.object({ kind: z.literal("underwriting"), id: z.string(), version: SemVer, params: UnderwritingParams }),
  z.object({ kind: z.literal("creditPd"), id: z.string(), version: SemVer, params: CreditPdParams }),
  z.object({ kind: z.literal("cecl"), id: z.string(), version: SemVer, params: CeclParams }),
  z.object({ kind: z.literal("prepay"), id: z.string(), version: SemVer, params: PrepayParams }),
  z.object({ kind: z.literal("mtm"), id: z.string(), version: SemVer, params: MtmParams }),
  z.object({ kind: z.literal("fees"), id: z.string(), version: SemVer, params: FeesParams }),
  z.object({ kind: z.literal("opex"), id: z.string(), version: SemVer, params: OpexParams }),
  z.object({ kind: z.literal("capability"), id: z.string(), version: SemVer, params: CapabilityParams }),
]);
export type ModelRef = z.infer<typeof ModelRef>;
export type ModelRefOf<K extends ModelKind> = Extract<ModelRef, { kind: K }>;

// ───────────────────────────────────────────────────────────── products, vintages, books

/** Static definition of a product inside a book (e.g. mmda_indexed within mmda). */
export const ProductDef = z.object({
  id: ProductId,
  bookId: BookId,
  label: z.string(),
  /** ADR-0080: the plain sub-line under the label (PRODUCT_LABELS.detail); absent = none. */
  detail: z.string().optional(),
  segment: Segment,
  accounting: Accounting,
  rateType: RateType,
  index: RateIndex,
  termMonths: z.number().int().positive().optional(),
  resetMonths: z.number().int().positive().optional(), // hybrids ≥ 60
  amortizing: z.boolean(),
  riskWeightRate: Rate,
  hqlaLevel: HqlaLevel,
  /** @deprecated LCR run-off is by insured / uninsured / hot money (ContentParams.liquidity, 06.3 E2). */
  lcrRunoffRate: Rate.optional(),
  referenceIndex: ReferenceIndex.optional(), // 01.2 E1
  /** 05.5 E1 EVE inputs per product: duration (years) and convexity; NMD durations carry β × L_eve (M8). */
  eve: z.object({ durationYears: z.number().nonnegative(), convexity: z.number() }).optional(),
  /** 03.2 E4: constant monthly paydown of every vintage (card account cohorts, 1/60). */
  runoffRatePerMonth: Rate.optional(),
  uninsuredShareRate: Rate.optional(), // deposits
  inRunScope: z.boolean().optional(), // time deposits excluded
  reciprocal: z.boolean().optional(), // ICS/CDARS insured sweep
  fhlbLendableRate: Rate.optional(), // resi 0.75, non-construction CRE 0.60, securities 0.95
  dwLendableRate: Rate.optional(), // 0.97 FV
  nmdAverageLifeYears: z.number().positive().optional(), // DDA 6, IC/MMDA 4
  ttcLossRate: Rate.optional(), // terminal normalization + CECL reversion target
  /** @deprecated one LGD per book (CreditPdParams.lgdBaseRate). */
  stressLgdRate: Rate.optional(),
  models: z.array(ModelRef),
  /** v1: PSI-grade fine levers (min balance, monthly fee, cash back, min score, collections). */
  v1: z.object({ minBalanceUsd: Usd, monthlyFeeUsd: Usd, annualFeeUsd: Usd, cashBackRate: Rate, minCreditScore: z.number().int() }).partial().optional(),
});
export type ProductDef = z.infer<typeof ProductDef>;

/** One vintage per product and origination month (03.2), or a SimStart position, within a book. All money rounded at posting. */
export const Vintage = z.object({
  id: VintageId,
  bookId: BookId,
  productId: ProductId,
  originMonth: Month,
  /** Back-book seasoning at SimStart (vintages with originMonth 0); age = ageAtSimStartMonths + month. */
  ageAtSimStartMonths: z.number().int().nonnegative().optional(),
  maturityMonth: Month.optional(),
  nextResetMonth: Month.optional(),
  /**
   * Book balance (amortized cost for securities/loans; par for deposits). Total assets use `fairValueUsd` for
   * AFS vintages; AFS marks post `asset:<book>.mark` against `oci:afs` (net) and `static.dta` (tax).
   * Accrual: every book accrues on its OPENING (month-start) balance; intra-month flows earn nothing.
   */
  balanceUsd: Usd,
  couponRate: Rate, // current contractual/posted rate
  wacCouponRate: Rate.optional(), // MBS: underlying mortgage WAC (moneyness for prepay/convexity), vs couponRate = pass-through
  spreadBp: Bp.optional(), // over index for floaters
  underwritingBox: Box.optional(),
  // securities
  fairValueUsd: Usd.optional(),
  durationYears: z.number().nonnegative().optional(),
  convexity: z.number().optional(),
  pledgedUsd: Usd.optional(),
  // credit (credit state is per book in BankState.credit; vintage ACL/nonaccrual are derived views)
  /** Derived view: written at SimStart (aclByVintage convention), computed on read by the 04.2 E3 split; not stored monthly. */
  aclUsd: Usd.optional(),
  /** Derived view, as aclUsd. */
  nonaccrualUsd: Usd.optional(),
  /** @deprecated use BankState.credit[book]. */
  lossPoolRemainingUsd: Usd.optional(),
  /** @deprecated use BankState.credit[book].chargeOffQueueUsd. */
  pendingChargeOffsUsd: z.array(Usd).optional(),
  /** @deprecated no vintage charge (M7d); NormProv scales TTC by M_v (10.3 E1). */
  vintageChargeBookedUsd: Usd.optional(),
  /** 05.1 E1: the 30y mortgage rate the prepay S-curve is anchored to (SimStart env for the back book; origination month for new vintages). */
  prepayAnchorRate: Rate.optional(),
  /** 03.3 E3: the loss multiplier of the price the loan opened at (Premium ×1.08 a notch, Discount ×0.96); absent = 1. */
  adverseSelectionMult: z.number().positive().optional(),
  // deposits
  targetRate: Rate.optional(), // §3a lag state = the REFERENCE rate (no lever offset, no floor); posted rate = couponRate
  uninsuredUsd: Usd.optional(),
  /** Price-won or event-tagged balance (02.1 E7, 12.2 `hotMoneyTag`); `beta` = its pass-through of the reference rate (01.3 E3), absent = the product's own. */
  hotMoney: z.object({ advantageEndsMonth: Month.optional(), beta: z.number().optional() }).optional(),
  originatedBySeatAction: z.boolean().optional(), // price-won / decision-caused (attribution, λ/3)
  /**
   * 02.1 (ADR-0048): a front-book lot of a non-maturity deposit product: money won since the new-money rate, posted at the new-money rate
   * until `graduatesMonth` (won month + ExpanderParams.deposits.frontBookMonths), `wonAtGapBp` the new-money rate's gap to the base rate when
   * won (generalises `hotMoney`, which stays as the subset with a gap above 0). Absent = a back-book vintage. R2.2 writes it.
   */
  frontBook: z.object({ graduatesMonth: Month, wonAtGapBp: Bp }).optional(),
});
export type Vintage = z.infer<typeof Vintage>;

/** A book is an ordered list of vintages (ascending originMonth, then id); aggregates are derived, never stored. */
export const Book = z.object({ id: BookId, vintages: z.array(Vintage) });
export type Book = z.infer<typeof Book>;

/** Swap overlay position (both legs on FF; 05.4). Positive notional semantics via direction. */
export const SwapPosition = z.object({
  id: z.string(),
  direction: z.enum(["payFixed", "receiveFixed"]),
  notionalUsd: Usd,
  fixedRate: Rate,
  floatIndex: z.enum(["FF", "SOFR"]), // ADR-0049: SOFR added (R2.4); absent legs stay FF
  startMonth: Month,
  maturityMonth: Month,
  fairValueUsd: Usd,
  hedgeAccounting: z.enum(["cashFlowOci", "fairValuePnl"]),
});
export type SwapPosition = z.infer<typeof SwapPosition>;

// ───────────────────────────────────────────────────────────── bank state

export const Equity = z.object({ commonApicUsd: Usd, retainedEarningsUsd: Usd, aociAfsUsd: Usd, aociSwapUsd: Usd });
/**
 * Quarter record for ERI / distribution gates. I28: distributions for quarter q post in MONTH 1
 * of q, sized on the q−1 record (BB_q = min(cap, max(0, cet1Usd − target·rwaUsd)) of q−1).
 */
export const QuarterRecord = z.object({
  quarterEndMonth: Month,
  netIncomeUsd: Usd,
  dividendsUsd: Usd,
  buybacksUsd: Usd,
  cet1Usd: Usd,
  rwaUsd: Usd,
  cet1Rate: Rate,
  tier1Rate: Rate,
  trbcRate: Rate,
  leverageRate: Rate,
  camelsComposite: CamelsRating,
  /**
   * Book balances at this quarter-end (balanceUsd sums: amortized cost / par), recorded by the step. Feeds
   * trailing-growth trigger metrics (ciGrowthVsTrendRate: this record vs the one 4 quarter-ends earlier). Absent on the
   * pre-SimStart trailing records; the SimStart (lag 0) record carries the SimStart books.
   */
  booksUsd: z.partialRecord(BookId, Usd).optional(),
  /** NI_core inputs (10.1): PPNR (NII + fees − opex incl. CDI), NCO, the CDI amortization in that opex. */
  ppnrUsd: Usd.optional(),
  ncoUsd: Usd.optional(),
  cdiAmortizationUsd: Usd.optional(),
  feesUsd: Usd.optional(), // 07.2: the PPNR builder rule reads it
  /** ADR-0067 (10.1 E4a SwapAdj): the live swaps' net interest received in the quarter, included in `ppnrUsd` (reported PPNR); core earnings for the price and the look-through are `ppnrUsd − swapInterestUsd`. Absent = 0. */
  swapInterestUsd: Usd.optional(),
  /** ADR-0072 (M10): one-time opex posted in the quarter (event opex hits, the cut-programme restructuring charge, the branch-closure lease-exit charge); pre-tax, positive = cost, included in `ppnrUsd` like `swapInterestUsd`. Absent = 0. */
  oneOffOpexUsd: Usd.optional(),
  /** ADR-0080: the quarter's operating expense, whole dollars, positive = cost, one-off opex and CDI amortization included (the opex line of `ppnrUsd`); absent = not recorded. */
  opexUsd: Usd.optional(),
  /** ADR-0087 (CB5): the quarter-end AFS accumulated other comprehensive income, whole dollars, signed; absent = not recorded. */
  aociAfsUsd: Usd.optional(),
  /** ADR-0087 (CB5): the interest or fee cost posted in the quarter under a card override that lapses at a known month, whole dollars, positive = cost; absent = none or not recorded. */
  lapsingOverrideUsd: Usd.optional(),
  /** 08.2 E10 (M11): this quarter's month-1 buyback was zeroed by the outlook pause (policy had pauseOnOutlook). Absent = false. */
  buybackPausedByOutlook: z.boolean().optional(),
});

export const CapitalSnapshot = z.object({
  cet1Usd: Usd, tier1Usd: Usd, trbcUsd: Usd, rwaUsd: Usd,
  markedCet1Usd: Usd,
  /** Quarter-to-date average of month-end leverage assets (08.1 E6; I28). */
  avgAssetsForLeverageUsd: Usd,
  /**
   * 08.1 E3: dtaNol = t × max(0, −BankState.cumulativeTaxableIncomeUsd) (the NOL DTA); dtaExcess = 0 (the 25% threshold
   * deduction stays cut); aclExcessRwa = ACL above aclCapRate × RWA, which leaves Tier 2 and RWA.
   */
  deductionsUsd: z.object({ goodwill: Usd, intangibles: Usd, dtaNol: Usd, dtaExcess: Usd, aclExcessRwa: Usd }),
  rwaByBucketUsd: z.record(z.string(), Usd),
});
export const LiquiditySnapshot = z.object({
  hqlaL1Usd: Usd, hqlaL2Usd: Usd, hqlaL2CappedUsd: Usd, netOutflow30dUsd: Usd,
  cashFloorUsd: Usd, fhlbCapacityUsd: Usd, fhlbUsedUsd: Usd, dwCapacityUsd: Usd, ffpLineUsd: Usd,
  uninsuredDepositsUsd: Usd, lcrLiteRate: Rate, slcRate: Rate,
});
export const IrrSnapshot = z.object({
  /** The +100bp income sensitivity (signed; the displayed figure). */
  niiSensitivityRate: Rate,
  eve200Rate: Rate,
  eve200EquityBasisUsd: Usd,
  /** ADR-0086 (CB4; 05.4): the worse (lower) of the +100bp and −100bp income sensitivities, signed, both as shares of a year's NII; absent = not computed, and the +100bp figure stands. `niiSensitivityLossRate` reads it. */
  niiSensitivityWorseRate: Rate.optional(),
});

export const CamelsComponents = z.object({ C: CamelsRating, A: CamelsRating, M: CamelsRating, E: CamelsRating, L: CamelsRating, S: CamelsRating });
export type CamelsComponents = z.infer<typeof CamelsComponents>;
/** CAMELS-lite state incl. I32 integer-twentieths and upgrade hysteresis. */
export const CamelsState = z.object({
  components: CamelsComponents,
  s20: z.number().int(), // 5C+5A+3M+2E+3L+2S
  composite: CamelsRating,
  pendingUpgradeQuarters: z.number().int().nonnegative(),
  /** @deprecated 09.1 E10 replaces the timed L notch; absent in data. */
  lModifierUntilMonth: Month.optional(),
  /** 09.1 E9: consecutive quarter-ends whose earnings rule rating was better than E (one notch better on the `upgradeAfterQuarters`-th). Absent = 0. */
  earningsPendingBetterQuarters: z.number().int().nonnegative().optional(),
  /**
   * ADR-0068 rev. F17.5c (09.1 E11): the own-limit record, one entry per quarter-end, the last four kept, newest last (fewer while the bank is younger; an empty `breachedKpis` is an entry):
   * `month` = the engine month of the quarter-end, `limits` = the limits in force at it (KPI to value), `breachedKpis` = the KPIs read strictly past the tightest limit value held in the window. Absent = no record yet.
   */
  limitBreachQuarterEnds: z.array(z.object({ month: Month, limits: z.partialRecord(KpiId, z.number()), breachedKpis: z.array(KpiId) })).max(4).optional(),
  /**
   * 09.1 E10: the liquidity floor after the last deposit run on record: the run's month, the floor at the last quarter-end, and whether cover was at the bank's liquidity
   * target at each quarter-end since (newest last). Absent = no run on record.
   */
  liquidityAfterRun: z.object({ runMonth: Month, floor: CamelsRating, coverAtTargetQuarterEnds: z.array(z.boolean()) }).optional(),
  /**
   * ADR-0068 rev (F19.0): the measure each rated component was rated on at the last rating and its value ("Sensitivity rated on the +200bp economic value loss at year-end: 21.8%"), so the gate line names its cause.
   * Pin (F19.0): on CamelsState (where the rating is held), not the round report: the engine writes it where it rates; `measure` is plain words, `value` a decimal rate. Absent = no reading.
   */
  ratedOn: z.partialRecord(z.enum(["C", "A", "M", "E", "L", "S"]), z.object({
    measure: z.string(),
    value: z.number(),
    /** ADR-0068 rev (F19.0b): filled by the engine from the one metric-to-KPI link beside the rating thresholds (scoring); absent when the rated measure has no reported KPI. `kpi` is the reported KPI the rated measure moves with (the api reads a family revert's `kpiDeltas[kpi]`); `higherIsBetter` is which way is better. */
    kpi: KpiId.optional(),
    higherIsBetter: z.boolean().optional(),
  })).optional(),
});
export type CamelsState = z.infer<typeof CamelsState>;

export const Finding = z.object({
  id: z.string(),
  kind: z.enum(["MRA", "MOU", "consentOrder"]),
  variant: z.enum(["cre", "creSoft", "bsaAml", "modification", "riskRating", "other", "capitalDistribution"]),
  openedMonth: Month,
  escalatesAtMonth: Month.optional(),
  closedMonth: Month.optional(),
  sourceEventInstanceId: EventInstanceId.optional(),
});
/**
 * A decision constraint from events, the activist, an MOU or a consent order — the clamp contract the Expander pre-clamps and
 * validateDecisionSet enforces. Limits are ABSOLUTE (`value`) or RELATIVE (`relativeDelta`; EV-07 choice A
 * "C&I box one notch tighter through R3" = {decisionId "loans.ci.underwriting", kind "max", relativeDelta −1}). A relative limit is resolved ONCE,
 * when its effect is applied (applyEventResponse / supervisory start): value = the seat's setting in force at
 * that moment + relativeDelta, snapped to the decision's grid and clamped to its range (never looser than the grid end). Only
 * the resolved form is stored: BankState.constraints and DraftView.activeConstraints always carry `value`, never
 * `relativeDelta`. Exactly one of value / relativeDelta for max | min | fixed; neither for locked (content build, WP26).
 */
export const DecisionConstraint = z.object({
  decisionId: DecisionPath, // "loans.cre.growth", "loans.cre.underwriting", "capital.dividend"…
  kind: z.enum(["max", "min", "fixed", "locked"]),
  value: z.number().optional(),
  relativeDelta: z.number().optional(), // content form only: notches (or the decision's unit) vs the setting in force
  untilRound: RoundIndex.optional(),
  /** "dealCovenant" is never emitted: the covenant and MOU "no buybacks" are posting rules in 08.2. */
  source: z.enum(["event", "mou", "consentOrder", "pca", "dealCovenant", "activist"]),
  sourceRef: z.string().optional(),
  /** ADR-0053: for a card's row, the decision's value in the round-open seed when the card was answered: what the decision returns to when the card's hold ends. */
  before: DecisionValue.optional(),
});
export type DecisionConstraint = z.infer<typeof DecisionConstraint>;
export const SupervisoryState = z.object({
  camels: CamelsState,
  status: SupervisoryStatus,
  statusSinceMonth: Month.optional(),
  pca: PcaStatus,
  findings: z.array(Finding),
  dividendApprovalRequired: z.boolean(),
});
export type SupervisoryState = z.infer<typeof SupervisoryState>;

/** Transient valuation adjustments (event price shocks decay over 4q; COE / P/TBV nudges). */
export const ValuationAdjustment = z.object({
  kind: z.enum(["priceShockRate", "coePremiumBp", "ptbvAdjust"]),
  value: z.number(),
  startMonth: Month,
  decayMonths: z.number().int().nonnegative(),
  sourceRef: z.string(),
});
/**
 * EV-05 takeover bid (OD4-1; ADR-0025; 10.5). Recorded for EVERY seat that receives an offer (accept, reject or
 * default). The bank keeps running either way (an acceptor under the ONE deal covenant, DEAL_COVENANT: buybacks off and the
 * DPS frozen until closing — a posting rule in 08.2 E3, never a LeverConstraint; OD5-8a); the headline stays the bank's own standalone Value Created and NEVER reads this object (I37).
 * Offer (I35), fixed in dollars at the bid month: [W_auto,post + PI × W_auto] / (1 + COE)^τ, from a single-seat autopilot
 * projection of THIS seat at the bid pause (engine-internal projectAutopilotTwin; frozen market, rivals on their submitted
 * levers, no events). PI = ContentParams.bid.premiumVcRate (pilot 0.0075). The price is never
 * locked to the offer. Targeting: human seats only, by published P/TBV, never by VC. The merger itself is never
 * consummated in the sim: "closing" only ends the covenant window (the bank keeps running standalone).
 */
export const DealOffer = z.object({
  offerUsdPerShare: UsdPerShare,
  premiumVcRate: Rate, // PI used (incl. a Negotiate / market-check step)
  autopilotWealthUsdPerShare: UsdPerShare, // W_auto: the projected twin's total terminal wealth per share
  autopilotPostBidWealthUsdPerShare: UsdPerShare, // W_auto,post: its wealth after the bid month (scoring convention)
  yearsToScoring: z.number().nonnegative(), // τ: bid month-end → scoring date
  /** Base COE (10.79% pilot) used to compound the offer and distributions to the scoring date (10.4 convention). */
  coeRateAtOffer: Rate,
  stockConsiderationRate: Rate,
  offeredMonth: Month,
  decision: z.enum(["pending", "accepted", "rejected", "defaulted"]), // defaulted = treated as rejected (+ a C4 evidence ding)
  /** Required on every EV-05 choice: the team's stated standalone value per share (rubric 2.4; the deal call). */
  standaloneEstimateUsdPerShare: UsdPerShare.nullable(),
  approvalCheckMonth: Month, // bid month + bid.approvalLagMonths
  breaksIfCompositeAbove: CamelsRating,
  /**
   * Covenant lifecycle (accepted only; 10.5): pending until approvalCheckMonth (= closing), then broken (composite
   * above threshold, p = bid.breakProbability) or lifted (the deal clears; the bank still runs standalone for scoring, I37).
   * Either way DEAL_COVENANT stops applying at that month.
   */
  covenantStatus: z.enum(["none", "pending", "broken", "lifted"]),
  sourceEventInstanceId: EventInstanceId,
  /** BankState.distributionsPvUsdPerShare at the end of the bid month: D_pre = this × (1 + baseCoeRate)^(T/12). */
  preBidDistributionsPvUsdPerShare: z.number().nonnegative().optional(),
  /** ADR-0041: the price the bid month first priced (`offerUsdPerShare` moves with a negotiation) and the choice the seat took; absent in results stored before. */
  originalOfferUsdPerShare: UsdPerShare.optional(),
  choiceId: z.string().optional(),
});
export type DealOffer = z.infer<typeof DealOffer>;

/** Capability stocks (1-year lag) and franchise state. */
export const FranchiseState = z.object({
  techStockUsdByTheme: z.partialRecord(TechTheme, Usd),
  techSpendHistoryUsd: z.array(z.partialRecord(TechTheme, Usd)), // per month, for lag
  branchCount: z.number().int().nonnegative(),
  atmCount: z.number().int().nonnegative().optional(),
  closedBranchDepositsPendingUsd: Usd, // attrition not yet realized
  serviceAttritionPendingUsd: Usd, // expense-programme service-index attrition not yet realized (DepositFlowParams.serviceAttrition)
  employeeCount: z.number().int().nonnegative().optional(),
  customerIndex: z.number(), // 100 = SimStart
  employeeIndex: z.number(),
  serviceLevelByArea: z.record(z.string(), Rate).optional(), // v1
  /** Expense programmes in force (absent = none), appended by the engine at a round's first month; applied by the opex model. */
  opexPrograms: z.array(z.object({ startMonth: Month, level: z.enum(["investAggressively", "invest", "none", "modest", "aggressive", "deep"]), changeRate: Rate.optional() })).optional(),
  /** 03.5 E1 (v2.38): the pay notch in force (0 Lower, 1 Hold, 2 Higher) from each start month, appended by the engine at a round's first month when it changes; absent = Hold throughout. */
  payNotches: z.array(z.object({ startMonth: Month, notch: z.number().int().min(0).max(2) })).optional(),
  /** Opex balance scale (absent = 1): prior month-end loans plus deposits ÷ SimStart loans plus deposits (B = loans plus deposits; 07.3 E3, OR-30.18); engine-written. */
  opexBalanceScale: z.number().positive().optional(),
  /** ADR-0086 (CB4; 03.2 E8): branch openings not yet mature, a stock apart from `branchCount`, each maturing over 36 months (the engine fills it in pass 3; absent = openings count in full at once). */
  pendingOpenings: z.array(z.object({ openedMonth: Month, count: z.number().int().positive() })).optional(),
  /** Φ (02.1 E2): the franchise balance per deposit product, the logit weight; moved by growth and franchise flows only. */
  depositFranchiseUsdByProduct: z.partialRecord(ProductId, Usd).optional(),
  /** L (02.1 E6): price-lost deposits that return at λ/d (lostBalanceReturnDivisor). */
  priceLostDepositsUsdByProduct: z.partialRecord(ProductId, Usd).optional(),
  /** x (02.2 E3, ADR-0055): the share of the seat's rate-neutral checking balance now in the receiving money market (absent = 0). Engine-written. */
  checkingMovedRate: Rate.optional(),
  /** p (02.1 E1a, ADR-0055): the share of deposits in money funds and bills; one market level, kept on every seat (absent = 0). Engine-written. */
  moneyFundPoolRate: z.number().optional(),
  /** I (07.3 E3a, ADR-0055): the price level the programme lines are paid at, 1 at SimStart; month-end, engine-written. */
  opexPriceIndex: z.number().positive().optional(),
  /** 03.5 (ADR-0048): relationship managers by commercial book: the team and its hire cohorts (ramp, attrition and leaver run-off key on the cohort). Absent = the SimStart team (ExpanderParams.loans.rm.startingHeadcount). R2.1 writes it. */
  relationshipManagers: z.partialRecord(z.enum(["ci", "cre"]), z.object({ headcount: z.number().nonnegative(), cohorts: z.array(z.object({ hireMonth: Month, count: z.number().nonnegative() })) })).optional(),
  /** 03.5 (ADR-0048): the mortgage loan-officer team, as `relationshipManagers`. */
  loanOfficers: z.object({ headcount: z.number().nonnegative(), cohorts: z.array(z.object({ hireMonth: Month, count: z.number().nonnegative() })) }).optional(),
});

/**
 * Per-book credit state (04.1–04.4): the charge-off queue (monthly slots), the above-trend default window for nonaccrual, the book's
 * ACL and nonaccrual, event sleeves (04.4, individually assessed) and (v2.9, P4-D13) the stress stock: the worst driver decline so far, the
 * recovery mark, the workout backlog and its nonaccrual. BankState.aclUsd = Σ_b aclUsd.
 */
export const BookCreditState = z.object({
  burnoutUsedRate: z.number().nonnegative(), // v2.9: no longer read or moved (the pool is retired)
  chargeOffQueueUsd: z.array(Usd),
  aboveTrendDefaultsUsd: z.array(Usd),
  aboveTrendLossUsd: z.array(Usd),
  nonaccrualUsd: Usd,
  aclUsd: Usd,
  eventSleeves: z.array(z.object({ sourceRef: z.string(), reserveUsd: Usd, nonaccrualUsd: Usd, chargeOffsDue: z.array(z.object({ month: Month, usd: Usd })) })),
  /** C&I only (M6, 03.2 E4): the bank's NDFI share of C&I; SimStart = simstart_v3 /credit/ndfiShareOfCiRate; 0 after an NDFI exit (EV-07 C). */
  ndfiShareRate: Rate.optional(),
  /** v2.9 04.1 E2 d_b: the worst level of the book's lagged driver so far (absent = 0, SimStart). */
  worstDriverLevel: z.number().nonnegative().optional(),
  /** v2.9 04.2 E5 R_b: the lowest driver level since the worst (a new low trims the backlog); absent = 0. */
  recoveryDriverLevel: z.number().nonnegative().optional(),
  /** v2.9 04.2 E4 B_b: recognized stress loss not yet charged off, reserved in full in the ACL (04.3 E3); absent = 0. */
  workoutBacklogUsd: Usd.optional(),
  /** v2.9 04.2 E6 N_b: loans on nonaccrual behind the backlog; absent = 0. */
  stressNonaccrualUsd: Usd.optional(),
});
export type BookCreditState = z.infer<typeof BookCreditState>;

/** Scheduled lagged effect awaiting its due month (branch drawn from event RNG substream at due month). */
export const PendingLaggedEffect = z.object({
  id: z.string(),
  dueMonth: Month,
  sourceEventInstanceId: EventInstanceId,
  sourceChoiceId: z.string(),
  lagged: z.lazy(() => LaggedEffect),
});

/** R0 strategy statement and own risk appetite (evidence baseline). */
export const StrategyStatement = z.object({
  text: z.string().max(2000),
  objectives: z.array(z.lazy(() => Objective)).max(5),
  riskAppetite: z.array(z.object({ kpi: KpiId, cmp: z.enum(["le", "ge"]), limit: z.number() })),
  authoredBy: UserId.optional(),
});
export type StrategyStatement = z.infer<typeof StrategyStatement>;

/** The quarter's dividend and buyback schedule in force (ADR-0055; named for the wire in ADR-0058). */
export const PayoutSchedule = z.object({ quarterStartMonth: Month, dividendPayableUsd: Usd, buybackTranchesUsd: z.array(Usd), stopped: z.boolean() });
export type PayoutSchedule = z.infer<typeof PayoutSchedule>;

/** Complete state of one bank at a month-end. Derived snapshots are recomputed each step (I21). */
const BankStateObject = z.object({
  seatId: SeatId,
  archetypeId: ArchetypeId,
  month: Month,
  books: z.record(BookId, Book),
  swaps: z.array(SwapPosition),
  staticItemsUsd: z.record(StaticItemId, Usd),
  aclUsd: Usd, // contra-asset total (must equal Σ vintage ACL = Σ book ACL — I5 roll-forward per book and total)
  equity: Equity,
  sharesOutstanding: Shares,
  dpsLastUsdPerShare: UsdPerShare,
  quarters: z.array(QuarterRecord), // trailing history (≥ 9 kept: the current quarter-end + 8 back, for the 24-month growth window, P4-D5)
  /** Quarter-to-date accumulators, reset at each quarter-end; ppnr/nco/cdi/fees feed QuarterRecord (feesUsd = Σ the months' fee income, 07.2). */
  /** ADR-0088 (13.1 §2): the round just played's window NIM and NCO rate (Σ flow over the months, annualised, ÷ mean earning assets or loans), the "same as last year" benchmark of the next round's forecast; absent in round 1 (then the SimStart KPIs stand) and for an AI seat. */
  lastYearWindow: z.object({ nimRate: Rate, ncoRate: Rate }).optional(),
  qtd: z.object({ netIncomeUsd: Usd, dividendsUsd: Usd, buybacksUsd: Usd, ppnrUsd: Usd.optional(), ncoUsd: Usd.optional(), cdiAmortizationUsd: Usd.optional(), feesUsd: Usd.optional(), swapInterestUsd: Usd.optional(), oneOffOpexUsd: Usd.optional(), opexUsd: Usd.optional(),
    /** ADR-0092 (CB10, OR-30.38): the whole dollars a lapsing card override cost this quarter, counted once; absent = none. */ lapsingOverrideUsd: Usd.optional() }),
  /**
   * Capital record K for the OD4-2 premium (I34; 10.2 E1): running sum S_n of reported CET1 at each of the n quarter-ends of the
   * current horizon (play + look-through run). K = S_n ÷ n at a quarter-end month-end (that month is already in S_n) and for
   * horizonFinal; (S_n + current CET1) ÷ (n + 1) while a quarter is in progress; current CET1 when n = 0.
   */
  /** 10.2 E1 (the plain mean the memo and I34 read) and, since CB13, E1′: `sumCountedQuarterEndRate` sums min(CET1_q ÷ RWA_q, target in force + headroom) at each quarter-end (OR-30.84); absent on a bank written before the batch, read as the plain sum. */
  capitalRecord: z.object({ sumQuarterEndCet1Rate: z.number().nonnegative(), quarterEnds: z.number().int().nonnegative(), sumCountedQuarterEndRate: z.number().nonnegative().optional() }),
  capital: CapitalSnapshot,
  liquidity: LiquiditySnapshot,
  irr: IrrSnapshot,
  kpis: KpiSnapshot,
  supervisory: SupervisoryState,
  constraints: z.array(DecisionConstraint),
  franchise: FranchiseState,
  valuationAdjustments: z.array(ValuationAdjustment),
  pendingEffects: z.array(PendingLaggedEffect),
  eventCooldowns: z.partialRecord(EventId, RoundIndex), // eligible again from this round
  eventsFiredOnce: z.array(EventId),
  dealOffer: DealOffer.optional(),
  /** EV-05 "Just say no" (lagged branch, effect `activistFlagRelax`): this bank's EV-04 F2 flag reads at least `ptbvRatio` at every activist screen. Absent = not relaxed. */
  activistRelax: z.object({ flag: z.literal("F2"), ptbvRatio: z.number().positive() }).optional(),
  /** EV-04 "Settle" (effect `bidThresholdRelax`): the bid card's P/TBV-to-median threshold reads `ptbvRatio` for this bank when that is looser. Absent = not relaxed. */
  bidRelax: z.object({ ptbvRatio: z.number().positive() }).optional(),
  strategy: StrategyStatement.optional(),
  wholesaleStressUntilMonth: Month.optional(),
  /** 12.2 `depositRateAdjust`: a posted-rate offset on the books' products (01.3 E3) for the months up to and including `untilMonth`. Absent = none. */
  depositRateAdjustments: z.array(z.object({ books: z.array(BookId), deltaBp: Bp, untilMonth: Month })).optional(),
  /** Decisions in force (absent = STANDING_POLICY): the last effective submission's, written by resolveRound. */
  decisionsInForce: z.lazy(() => Decisions).optional(),
  /**
   * 08.2 / 09.1 E4′ (OR-15d): the buyback target in force at each of the last four quarter-ends, newest last (null = Off); the management notch's
   * "own target" is the lower of the highest of these and the standing target. Engine-written at each quarter-end. Absent = the standing target throughout.
   */
  buybackTargetAtQuarterEnds: z.array(Rate.nullable()).max(4).optional(),
  /**
   * 06.3 E7-E8, 09.1 E10 (ADR-0056): the month of the last deposit run (a `depositOutflow` shock landing on this seat) and the overnight FHLB balance at the end of the month before it
   * (what the term-out leaves in place). Engine-written at the run month by the funding step; absent = no run.
   */
  lastDepositRunMonth: Month.optional(),
  preRunOvernightFhlbUsd: Usd.optional(),
  /** 08.2 E2a (OR-15a): the live cost-of-equity premium of a dividend cut or suspension (opened at `openedMonth`, fading evenly over four quarters; buybacks are zero while it is live). Absent = none live. */
  dividendPremium: z.object({ openedBp: Bp, openedMonth: Month }).optional(),
  /**
   * 08.2 E6 (ADR-0055, P4-D1): the quarter's capital return still to run after its sizing month. The dividend is declared (off CET1) in month 1 and its cash leaves in month 2
   * (`dividendPayableUsd`, in other liabilities meanwhile); the buyback runs 40/35/25% in months 1–3 (`buybackTranchesUsd`: the tranches not yet executed, next month first).
   * `stopped`: a month-end read CET1 under the buyback target (E6a), so no tranche executes for the rest of the quarter. Absent / empty = nothing due. The funding step reads it.
   */
  payoutSchedule: PayoutSchedule.optional(),
  /**
   * 10.1 E10 and 10.2 (ADR-0054): the price model's state, written by step 14 every month-end in every run profile. `valuation` is the month's full price decomposition (the market's multiple μ_m
   * is `valuation.ptbvRequired`; `kpis.price` is its price), so a round-end bank is read, never re-priced. `rotceHistoryRate` is the last `priceModel.rotceHistoryMonths` month-end forward ROTCE values and
   * `balanceHistoryUsd` the last `growthLookbackMonths + 1` month-end loans + deposits (the current month last; SimStart's grown back at trend before month 1). `enforcementClosedMonth` is the
   * month a consent order or forced recapitalization closed (10.2 E2's fade). Absent on hand-built banks: the price then reads the market multiple as the fair multiple and the history as the month itself.
   */
  valuation: z.lazy(() => ValuationBreakdown).optional(),
  rotceHistoryRate: z.array(Rate).optional(),
  balanceHistoryUsd: z.array(z.number()).optional(),
  enforcementClosedMonth: Month.optional(),
  /**
   * 05.4 E7 (ADR-0049): the mark of each terminated swap still to run into net interest income, evenly to its original maturity. Engine-written at a termination and shrunk as it
   * runs; absent = none. The overlay's own `swaps` then hold live positions only.
   */
  terminatedSwapMarkUsd: z.array(z.object({ id: z.string(), markUsd: Usd, maturityMonth: Month })).optional(),
  /** Σ DPS_m ÷ (1 + valuation.baseCoeRate)^(m/12) since SimStart (absent = 0); W uses it (10.4). */
  distributionsPvUsdPerShare: z.number().nonnegative().optional(),
  /** Per-book credit state (04.x). Absent only on hand-built test states. */
  credit: z.partialRecord(BookId, BookCreditState).optional(),
  /** 07.5 E3: cumulative taxable income since SimStart (provision deductible at charge-off); feeds 08.1 E3 dtaNol. */
  cumulativeTaxableIncomeUsd: z.number().int().optional(),
  /**
   * 08.2 E1 (payout-ratio dividend): the sticky-DPS reference = the last DPS declared under the SAME payout policy; any policy change
   * (a round's dividend decision, the shadow reversion to the twin) resets it to the new policy's own DPS. R2.1 retires it (DPS steps).
   */
  dpsReferencePolicy: z.object({ payoutRate: Rate, sticky: z.boolean(), dpsUsdPerShare: UsdPerShare }).optional(),
  /** ADR-0047: the CET1 target the bank's buyback policy runs to (written from the plan's capital decision); the supervision rule reads it in place of the autopilot target. Absent = ContentParams.autopilot.targetCet1Rate. */
  cet1TargetRate: Rate.optional(),
});
// An interface (not an alias) so declaration emit refers to `BankState` by name; the route table's type is otherwise too long to serialize.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface BankState extends z.infer<typeof BankStateObject> {}
/** Typed by its inferred shape (like `Decisions` and `Predicate`) so the route table's declaration stays small enough to emit. */
export const BankState: z.ZodType<BankState> = BankStateObject;

// ───────────────────────────────────────────────────────────── environment, scenario, shocks

export const CurvePoint = z.enum(["3m", "2y", "5y", "10y"]);
/** Exogenous macro/market environment at a month (01.1). SOFR and CP keep their SimStart spread over FF (01.2 E1). */
export const EnvSnapshot = z.object({
  month: Month,
  ffRate: Rate,
  sofrRate: Rate,
  cpRate: Rate,
  curveRate: z.record(CurvePoint, Rate),
  /** 30y mortgage rate (05.1 prepay anchor, 03.3 resi new money). SimStart 6.25%. */
  mortgageRate: Rate,
  /** MBS current-coupon yield (05.2 buys, 05.3 MBS MTM). SimStart 4.38%. */
  mbsYieldRate: Rate,
  gdpGrowthRate: Rate,
  cpiRate: Rate,
  unemploymentRate: Rate,
  hpiIndex: z.number(), // 100 = SimStart
  creIndex: z.number(),
  officeIndex: z.number(),
  officeVacancyRate: Rate,
  flags: z.record(z.string(), z.boolean()), // e.g. peerFailure
});
export type EnvSnapshot = z.infer<typeof EnvSnapshot>;

/** Shock primitives (content EventCards and scenarios compose these). */
export const Shock = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("rateShift"), scope: z.enum(["market", "bankWholesaleSpread"]), shiftBp: z.partialRecord(z.enum(["ff", "3m", "2y", "5y", "10y", "spread"]), Bp), durationMonths: z.number().int().positive().optional() }),
  z.object({ kind: z.literal("depositOutflow"), scope: z.enum(["uninsured", "insured", "all"]), books: z.array(BookId), pctRate: Rate, split: z.array(z.object({ monthOffset: z.number().int().nonnegative(), shareRate: Rate })) }),
  z.object({ kind: z.literal("creditMult"), books: z.array(BookId), segments: z.array(Segment).optional(), pdMult: z.number(), lgdRate: Rate.optional(), holdMonths: z.number().int(), reversionMonths: z.number().int(), delayMonths: z.number().int().optional() }),
  z.object({ kind: z.literal("demandMult"), books: z.array(BookId), mult: z.number(), durationMonths: z.number().int() }),
  z.object({ kind: z.literal("opexHit"), amountUsd: Usd, monthOffset: z.number().int().nonnegative().optional() }),
  /** ADR-0072: a one-off operating cost of `rate` × the trailing-12-month opex, posted in the firing month (or `monthOffset` after it); the base scales with the bank, so any card can reuse it. */
  z.object({ kind: z.literal("opexHitRateOfTrailingOpex"), rate: Rate, monthOffset: z.number().int().nonnegative().optional() }),
  z.object({ kind: z.literal("mtmHit"), books: z.array(BookId), amountUsd: Usd }),
  z.object({ kind: z.literal("priceShock"), rate: Rate, decayMonths: z.number().int() }),
  /**
   * ADR-0086 (CB4; 03.3 E1): new-money loan spreads widen by `spreadBp` on `books` over `rampMonths` from the firing month, then decay back over `decayMonths`; the back books are unchanged (only new originations price at the wider spread).
   * Absent kind = spreads follow the rate path alone.
   */
  z.object({ kind: z.literal("loanSpreadShift"), books: z.array(BookId).min(1), spreadBp: Bp, rampMonths: z.number().int().nonnegative(), decayMonths: z.number().int().nonnegative() }),
  z.object({ kind: z.literal("supervisory"), finding: Finding.shape.variant, escalateAfterRounds: z.number().int().optional(), componentNotch: z.partialRecord(z.enum(["C", "A", "M", "E", "L", "S"]), z.number().int()).optional() }),
  /**
   * EV-07 NDFI borrower fraud (OD5-7): a one-off charge-off on EXISTING books (no new loan book), scaled by the bank's own
   * growth and credit-box choices. loss = baseLossRate × exposure × clamp(mult, multFloor, multCap), where
   * mult = Π(1 + perUnit·x) (linear) or exp(Σ perUnit·x) (exponential) over scaleBy, x read on the round-start state:
   * decisionNotch = the current notch at decisionPath (e.g. "loans.ci.growth"), underwritingBox = the box notch at decisionPath (e.g. "loans.ci.underwriting"),
   * growthVsTrendRate = ciGrowthVsTrendRate. Charge-offs follow `chargeOffScheduleByQuarter` from `delayMonths` and run through
   * ACL/provision (CECL-lite). Every number is a content pin (12.3, 04.4).
   */
  z.object({
    kind: z.literal("scaledChargeOff"),
    books: z.array(BookId).min(1),
    segments: z.array(Segment).optional(),
    /** ndfiSlice (M6; 04.4): BankState.credit.ci.ndfiShareRate × C&I balance on the event snapshot (EventInstance.snapshot). */
    exposure: z.enum(["balance", "originationsTrailing12m", "originationsSinceSimStart", "ndfiSlice"]),
    baseLossRate: Rate,
    scaleBy: z.array(z.object({ driver: z.enum(["decisionNotch", "underwritingBox", "growthVsTrendRate"]), decisionPath: DecisionPath.optional(), perUnit: z.number() })).max(4),
    form: z.enum(["linear", "exponential"]),
    multFloor: z.number().nonnegative(),
    multCap: z.number().positive(),
    delayMonths: z.number().int().nonnegative(),
    chargeOffScheduleByQuarter: z.array(Rate).min(1),
  }),
]);
export type Shock = z.infer<typeof Shock>;

/** Macro scenario: keyframes linearly interpolated per month + scheduled shocks + event schedule. */
export const Scenario = z.object({
  id: ScenarioId,
  name: z.string(),
  description: z.string(),
  keyframes: z.array(EnvSnapshot.partial().extend({ month: Month })).min(1),
  /**
   * Published consensus path (what banks and the preview may "know"). Absent ⇒ consensus = the
   * round-start EnvSnapshot held flat. Personas, Expander and preview never see `keyframes`.
   */
  consensusKeyframes: z.array(EnvSnapshot.partial().extend({ month: Month })).optional(),
  shocks: z.array(z.object({ month: Month, shock: Shock })),
  /** target: market-wide, the card's own trigger.targetOrder (e.g. lowest published P/TBV), or its conditional trigger. Never by Value Created (ADR-0025). */
  eventSchedule: z.array(z.object({ round: RoundIndex, eventId: EventId, month: z.number().int().positive().optional(), target: z.enum(["market", "targetOrder", "conditional"]) })),
  /** Shadow years: neutral reversion macro identical for all seats (01.1). */
  shadowReversion: z.object({ monthsToNeutral: z.number().int().positive(), neutral: EnvSnapshot.partial() }),
  /** ADR-0047: ±1σ range around the consensus per env field ("policyRate", "unemploymentRate", …) by horizon month; feeds MarketOutlook. Absent = no range drawn. */
  consensusBands: z.record(z.string(), z.array(z.object({ month: Month, low: z.number(), high: z.number() }))).optional(),
  /** ADR-0047: the look-through years' reversion target authored per scenario (same shape as shadowReversion); absent = shadowReversion. */
  lookThroughNeutral: z.object({ monthsToNeutral: z.number().int().positive(), neutral: EnvSnapshot.partial() }).optional(),
});
export type Scenario = z.infer<typeof Scenario>;

// ───────────────────────────────────────────────────────────── decisions (32, five families; ADR-0048)

/** The five decision families (rationale is required per family changed); a path's family is its first segment. */
export const DecisionFamily = z.enum(["loans", "deposits", "treasury", "capital", "operations"]);
export type DecisionFamily = z.infer<typeof DecisionFamily>;
/**
 * The 32 decisions a player sees, at composite level: a composite's sub-fields (`.front`, `.target`, `.level`…) are DecisionPaths, not
 * DecisionIds. Four loan books × (growth investment, pricing, underwriting); five deposit products; treasury; capital; operations.
 */
const DECISION_IDS = [
  "loans.ci.growth", "loans.ci.pricing", "loans.ci.underwriting",
  "loans.cre.growth", "loans.cre.pricing", "loans.cre.underwriting",
  "loans.resi.growth", "loans.resi.pricing", "loans.resi.underwriting",
  "loans.consumer.growth", "loans.consumer.pricing", "loans.consumer.underwriting",
  "deposits.retailChecking.rate", "deposits.retailChecking.marketing",
  "deposits.retailMm.rate", "deposits.retailMm.marketing",
  "deposits.cd.rate", "deposits.cd.marketing",
  "deposits.commercialChecking.ecr",
  "deposits.commercialMm.rate", "deposits.commercialMm.marketing",
  "treasury.liquidityTarget", "treasury.securitiesMix", "treasury.ratePosition", "treasury.funding",
  "capital.dividend", "capital.buyback", "capital.issuance",
  "operations.expense", "operations.tech", "operations.branches", "operations.peopleAndFees",
] as const;
export type DecisionId = (typeof DECISION_IDS)[number];
/** Declared by an alias (not inferred) so the route table's declaration does not repeat the 32 literals at every use. */
export const DecisionId: z.ZodEnum<{ [K in DecisionId]: K }> = z.enum(DECISION_IDS);

/** Integer notch in [min, max]. */
const notch = (min: number, max: number) => z.number().int().min(min).max(max);
/** Value must be one of a discrete set (float-safe compare). */
const oneOf = <T extends z.ZodType<number>>(s: T, set: readonly number[]) =>
  s.refine((v) => set.some((x) => Math.abs(x - v) < 1e-9), { message: `must be one of ${set.join(", ")}` });

/** Retail and commercial money-market rate, as the two settings of one card: the rate on new money (front book) and on the existing base (back book); −2 Lag hard … +2 Lead hard (25bp a step). */
const frontBackRate = z.object({ front: notch(-2, 2), back: notch(-2, 2) });
/** One loan book's three decisions (loans.<book>.*). `growth` is an input: relationship-manager or loan-officer hiring (ci, cre, resi) or marketing (consumer) by notch. */
const loanBook = z.object({
  /** −3 Exit · −2 Shrink team (−10%) · −1 Attrition only (−5%) · 0 Hire with trend · +1 Add 10% · +2 Add 20% · +3 Add 35%; resi LO hiring and consumer marketing ×0.5…×2 on the same notch scale. */
  growth: notch(-3, 3),
  /** −2 Discount+ … 0 Follow … +2 Premium+ (25bp · σ_book a step; resi 12.5bp, card 50bp). */
  pricing: notch(-2, 2),
  /** Approval standards −2 Tight … 0 Standard … +2 Loose. `consumer` covers consumer + card. */
  underwriting: Box,
});

/**
 * The player's decision set: 32 decisions as notches / discrete choices, nested exactly as their dotted paths (`decisions.loans.ci.pricing`).
 * The TYPES AND GRIDS here win; the docs/models chapters give the economics and the loans/deposits/liquidity/rate-position/funding/capital/operations
 * decision pages the semantics. Personas, the status-quo twin, UI controls and the Expander all speak this shape; FineDecisions is what the engine
 * consumes. SimStart default = STANDING_POLICY.
 */
const DecisionsObject = z.object({
  loans: z.object({ ci: loanBook, cre: loanBook, resi: loanBook, consumer: loanBook }),
  deposits: z.object({
    /** Interest checking. rate: front = new money, back = existing base. marketing ×0.5, 0.75, 1, 1.25, 1.5 (acquisition only). */
    retailChecking: z.object({ rate: frontBackRate, marketing: notch(-2, 2) }),
    retailMm: z.object({ rate: frontBackRate, marketing: notch(-2, 2) }),
    /** CDs carry one rate (a CD reprices only at issue or renewal, so there is no back book). */
    cd: z.object({ rate: notch(-2, 2), marketing: notch(-2, 2) }),
    /** Commercial checking: the earnings-credit rate, −1 Defend margin · 0 Follow · +1 Grow · +2 Aggressive (25bp a step). */
    commercialChecking: z.object({ ecr: notch(-1, 2) }),
    /** Commercial money market: marketing ×0.75, 1, 1.25, 1.5 (treasury-management marketing). */
    commercialMm: z.object({ rate: frontBackRate, marketing: notch(-1, 2) }),
  }),
  treasury: z.object({
    /** Liquidity-coverage target (LCR-lite), standing 125%. */
    liquidityTarget: oneOf(Rate, [1.05, 1.15, 1.25, 1.35, 1.5]),
    /** Securities make-up of NEW purchases; the book's size is not a decision (it is the residual). */
    securitiesMix: z.object({
      type: z.enum(["ustLean", "neutral", "mbsLean"]),
      duration: z.enum(["short", "neutral", "long"]),
      accounting: z.enum(["afsLean", "neutral", "htmLean"]),
    }),
    /** Rate position: the notch is a target sensitivity (change in a year's NII for +100bp as a share of NII; −3 … +3 = −4.5% … +4.5%, 1.5pp apart) or "natural" (no overlay); the engine sizes the swaps. */
    ratePosition: z.object({
      target: z.union([notch(-3, 3), z.literal("natural")]),
      tenorYears: z.union([z.literal(2), z.literal(3), z.literal(5)]),
    }),
    funding: z.enum(["overnight", "balanced", "termed", "fortress"]),
  }),
  capital: z.object({
    /** Dividend per share, in steps of capitalPolicy.dpsStepUsdPerShare: −3 Suspend · −2 Cut two steps · −1 Cut one step · 0 Hold · +1 Raise one step · +2 Raise two steps. ONE-ROUND. */
    dividend: notch(-3, 2),
    buyback: z.object({
      /** Reported-CET1 buyback target 9.25–12.50% in 0.25% steps; null = Off. */
      cet1TargetRate: oneOf(Rate, Array.from({ length: 14 }, (_, i) => 0.0925 + i * 0.0025)).nullable(),
      /** true = pause buybacks while the outlook is negative; false = the explicit override (the risk officer warns). */
      pauseOnOutlook: z.boolean(),
      /** false = stay inside the conservation buffer; true = the explicit buffer-breach option (distributions post in full, the examiner opens a finding). */
      breachBuffer: z.boolean(),
    }),
    /** Common equity raise at month 1. ONE-ROUND. */
    issuance: oneOf(Usd, [0, 100e6, 250e6, 500e6, 1000e6]),
  }),
  operations: z.object({
    /** Expense management (the cost programme). ONE-ROUND. */
    expense: z.enum(["investAggressively", "invest", "hold", "modest", "aggressive", "deep"]),
    /** Technology: spend level + theme preset (Balanced 25×4; preset theme 55, others 15). */
    tech: z.object({
      level: z.enum(["min", "low", "base", "high", "max"]),
      preset: z.enum(["balanced", "digitalRetail", "commercialTm", "riskCompliance", "efficiencyData"]),
    }),
    /** Branch footprint change this round. */
    branches: oneOf(Rate, [-0.2, -0.1, 0, 0.05, 0.1]),
    /** Pay and fees: comp −1/0/+1 (−3/0/+3% pay; training ×0.5/1/1.5; RM and loan-officer attrition move too), fees −1/0/+1 (×0.90/1.00/1.10). */
    peopleAndFees: z.object({ comp: notch(-1, 1), fees: notch(-1, 1) }),
  }),
});
// An interface (not an alias) so declaration emit refers to `Decisions` by name; the route table's type is otherwise too long to serialize.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface Decisions extends z.infer<typeof DecisionsObject> {}
/** Typed by its inferred shape (the way `Predicate` is) so the route table's declaration stays small enough to emit. */
export const Decisions: z.ZodType<Decisions> = DecisionsObject;

const STANDING_BOOK = { growth: 0, pricing: 0, underwriting: 0 } as const;
const STANDING_FRONT_BACK = { front: 0, back: 0 } as const;
/**
 * The standing policy = the status-quo twin's decisions (11.3; replaces AUTOPILOT_LEVERS). Growth 0 = hire with trend / marketing ×1, Follow,
 * Standard, Follow/Follow, liquidity 125%, Neutral make-up, no rate overlay ("natural"), Balanced funding (50/30/20), dividend Hold, buyback 10.50% with
 * the outlook pause and inside the buffer, no raise, expense Hold, technology Base/Balanced. (The twin's own dividend rule — raise a step when payout < 35%
 * and CET1 ≥ 10.50%, cut a step below 9% — is the twin policy's, not this value's.)
 */
export const STANDING_POLICY: Decisions = {
  loans: { ci: { ...STANDING_BOOK }, cre: { ...STANDING_BOOK }, resi: { ...STANDING_BOOK }, consumer: { ...STANDING_BOOK } },
  deposits: {
    retailChecking: { rate: { ...STANDING_FRONT_BACK }, marketing: 0 },
    retailMm: { rate: { ...STANDING_FRONT_BACK }, marketing: 0 },
    cd: { rate: 0, marketing: 0 },
    commercialChecking: { ecr: 0 },
    commercialMm: { rate: { ...STANDING_FRONT_BACK }, marketing: 0 },
  },
  treasury: {
    liquidityTarget: 1.25 as Rate,
    securitiesMix: { type: "neutral", duration: "neutral", accounting: "neutral" },
    ratePosition: { target: "natural", tenorYears: 5 },
    funding: "balanced",
  },
  capital: { dividend: 0, buyback: { cet1TargetRate: 0.105 as Rate, pauseOnOutlook: true, breachBuffer: false }, issuance: 0 as Usd },
  operations: { expense: "hold", tech: { level: "base", preset: "balanced" }, branches: 0 as Rate, peopleAndFees: { comp: 0, fees: 0 } },
};
/**
 * Decisions that are one-round (owner M10; OR-15): at OPEN the draft is seeded from the prior effective decisions with these reset to their
 * STANDING_POLICY value (seedDecisionsForRound); the close fallback lastYearsPlan and the personas' home settings follow the same rule. Every other
 * decision stays where it was left (the dividend step is applied to the declared level, so the next round opens at Hold on the new level).
 */
export const ONE_ROUND_DECISIONS = ["capital.dividend", "capital.issuance", "operations.expense"] as const satisfies readonly DecisionId[];
/** The round-open draft decisions (DraftView.decisions, lastYearsPlan): the prior effective decisions with ONE_ROUND_DECISIONS reset (M10). */
export function seedDecisionsForRound(prior: Decisions): Decisions {
  return {
    ...prior,
    capital: { ...prior.capital, dividend: STANDING_POLICY.capital.dividend, issuance: STANDING_POLICY.capital.issuance },
    operations: { ...prior.operations, expense: STANDING_POLICY.operations.expense },
  };
}


// ───────────────────────────────────────────────────────────── provenance, rationale, forecasts

/** Owned = set by the seat (or its persona) directly; derived = filled by the Expander/autopilot/event. */
export const Provenance = z.object({
  kind: z.enum(["owned", "derived"]),
  source: z.enum(["player", "expander", "autopilot", "persona", "event", "facilitator"]),
  decisionId: DecisionId.optional(),
  sourceRef: z.string().optional(), // eventInstanceId, personaId…
  authoredBy: UserId.optional(), // captured, not reported
});
export type Provenance = z.infer<typeof Provenance>;
/** Wrap a fine-decision field with its provenance. */
export const prov = <T extends z.ZodType>(s: T) => z.object({ value: s, provenance: Provenance });
export type Provenanced<T> = { value: T; provenance: Provenance };

export const Objective = z.enum([
  "growNii", "growFranchise", "protectCapital", "reduceIrr", "improveLiquidity", "reduceConcentration",
  "manageCreditRisk", "improveEfficiency", "returnCapital", "satisfyRegulator", "defendValuation", "investInCapability",
]);
export type Objective = z.infer<typeof Objective>;

/** Required per decision family changed and per event response. */
export const Rationale = z.object({
  subject: z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("decisionFamily"), family: DecisionFamily }),
    z.object({ kind: z.literal("event"), eventInstanceId: EventInstanceId }),
  ]),
  objective: Objective,
  expected: z.object({
    kpi: KpiId,
    direction: Direction,
    magnitude: z.number().optional(), // in KPI_DEFS unit
    horizonRounds: z.number().int().min(1).max(4),
  }),
  text: z.string().min(1).max(400), // 1–2 sentences
  authoredBy: UserId.optional(),
});
export type Rationale = z.infer<typeof Rationale>;

/**
 * "Call the year" forecast (OD5-1, ADR-0026 §1): one per team per round, committed at round open, of the NO-CHANGE PLAN's
 * round-end value (the team's own round-start bank run one round on standing policy = the forecast twin, 11.3, M7h; not the
 * team's plan and not the status-quo twin that scores it). `subject` keeps its stored identifier "statusQuoTwin"; copy says
 * "no-change plan" (CP-3 UI_TERMS.noChangePlan). Executive: a numeric value (domain unit, decimal Rate). Guided: a band
 * (OD5-6), scored on direction and band. Levers cannot move the twin, so it is never re-locked; it is scored whatever plan
 * goes in (team, close default or rescue). Plan-level predictions stay in the per-family rationales (OD4-4).
 */
export const KPIForecast = z.object({
  kpi: z.enum(FORECAST_GATED_KPIS),
  round: RoundIndex,
  subject: z.literal("statusQuoTwin"),
  input: z.discriminatedUnion("format", [
    z.object({ format: z.literal("numeric"), value: z.number() }),
    z.object({ format: z.literal("band"), band: ForecastBand }),
  ]),
  committedAt: z.object({
    at: IsoDateTime,
    previewsRunBefore: z.number().int().nonnegative(), // masked previews rendered before the commit (evidence only)
  }),
  authoredBy: UserId.optional(),
});
export type KPIForecast = z.infer<typeof KPIForecast>;

// ───────────────────────────────────────────────────────────── events

/** Non-shock effects a choice can apply (plus any Shock). */
export const Effect = z.union([
  Shock,
  z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("decisionOverride"), decisionId: DecisionPath, value: DecisionValue, durationRounds: z.number().int().positive() }),
    z.object({ kind: z.literal("decisionConstraint"), constraint: DecisionConstraint }),
    z.object({ kind: z.literal("outflowMult"), mult: z.number() }),
    z.object({ kind: z.literal("uninsuredShift"), deltaRate: Rate, permanent: z.boolean() }),
    z.object({ kind: z.literal("depositRateAdjust"), books: z.array(BookId), deltaBp: Bp, durationMonths: z.number().int() }),
    z.object({ kind: z.literal("hotMoneyTag"), shareRate: Rate, beta: z.number() }),
    /** amountUsd, or `exposure: "ndfiSlice"` = sell the NDFI slice (EV-07 C; sets BankState.credit.ci.ndfiShareRate to 0; M6). */
    z.object({ kind: z.literal("assetSale"), bookId: BookId, amountUsd: Usd.optional(), exposure: z.literal("ndfiSlice").optional(), priceRate: Rate.optional() })
      .refine((e) => (e.amountUsd === undefined) !== (e.exposure === undefined), "assetSale: exactly one of amountUsd / exposure"),
    z.object({ kind: z.literal("assetPurchase"), bookId: BookId, amountUsd: Usd, priceRate: Rate, yieldUpliftBp: Bp.optional() }),
    z.object({ kind: z.literal("capitalRaise"), amountUsd: Usd }), // ADR-0095: the `discountRate` field is removed; the price is 08.2 E7 δ(I) for every raise
    z.object({ kind: z.literal("borrow"), bookId: z.enum(["fhlb", "dw"]), amountUsd: Usd, termMonths: z.number().int() }),
    /** ADR-0069 (21.9): `reliefRate` = the rate cut on the modified share (absent = 0.6), `reliefMonths` = how long it lasts (absent = 12). */
    z.object({ kind: z.literal("loanModification"), bookId: BookId, shareRate: Rate, extensionMonths: z.number().int(), reliefRate: Rate.optional(), reliefMonths: z.number().int().positive().optional() }),
    /** ADR-0069 (P5-D4): a card hedge as a relative move: the decision moves at most `maxStep` of its range toward neutral, `neverPast` stops it at neutral, for `durationRounds` (absent = the round). */
    z.object({ kind: z.literal("decisionMove"), decisionId: DecisionPath, toward: z.literal("neutral"), maxStep: z.number().positive(), neverPast: z.literal(true).optional(), durationRounds: z.number().int().positive().optional() }),
    z.object({ kind: z.literal("valuation"), adjustment: ValuationAdjustment.omit({ startMonth: true, sourceRef: true }) }),
    z.object({ kind: z.literal("indexShift"), index: z.enum(["customer", "employee"]), delta: z.number() }),
    /** Unused in the pilot: planning is deterministic (12.1). The content build rejects it. */
    z.object({ kind: z.literal("triggerOddsMult"), eventId: EventId, mult: z.number(), untilRound: RoundIndex.optional() }),
    /** EV-05 accept: the one deal covenant applies (DEAL_COVENANT, a posting rule; ContentParams.bid; ADR-0025, OD5-8a). The offer is priced by the engine (DealOffer), never here. Headline unaffected. */
    z.object({ kind: z.literal("dealAccept"), stockConsiderationRate: Rate, breaksIfCompositeAbove: CamelsRating }),
    /** EV-05 Negotiate / Market check lottery outcome: PI raised by stepVcRate (bid.negotiateStepVcRate / marketCheckStepVcRate). */
    z.object({ kind: z.literal("dealOfferRevise"), stepVcRate: Rate }),
    z.object({ kind: z.literal("kpiCommitment"), kpi: KpiId, horizonRounds: z.number().int() }),
    z.object({ kind: z.literal("closeFinding"), findingVariant: Finding.shape.variant }),
    z.object({ kind: z.literal("secondWave"), outflowPctRate: Rate, scope: z.enum(["uninsured", "all"]) }),
    /** EV-05 "Just say no", lagged branch: this bank's EV-04 F2 flag (P/TBV vs the peer median) reads `ptbvRatio` (GP eventCards.EV-04.ev05JustSayNoF2Ratio) at the next activist screen. */
    z.object({ kind: z.literal("activistFlagRelax"), flag: z.literal("F2"), ptbvRatio: z.number().positive() }),
    /** EV-04 "Settle": this bank's EV-05 bid threshold (`ptbvToPeerMedianRatio ≤ x`) relaxes to `ptbvRatio` (SS `valuation.bid.hflPtbvRatioSettled`). */
    z.object({ kind: z.literal("bidThresholdRelax"), ptbvRatio: z.number().positive() }),
  ]),
]);
export type Effect = z.infer<typeof Effect>;

/** Probabilistic lagged effect: branches are mutually exclusive; residual probability = nothing. */
export const LaggedEffect = z.object({
  delayMonths: z.number().int().nonnegative(),
  anchor: z.enum(["event", "roundStart", "roundEnd"]),
  condition: Predicate.optional(),
  /** `adverse` (ADR-0072): the author's mark that this branch is the bad outcome, so the card page names it without inferring from the effects; absent = not marked. */
  branches: z.array(z.object({ p: z.number().min(0).max(1), label: z.string(), effects: z.array(Effect), adverse: z.boolean().optional() })).min(1),
});
export type LaggedEffect = z.infer<typeof LaggedEffect>;

/**
 * Facts an event card may show (OD5-3, ADR-0026 §3): shock FACTS and trade-offs only, first-order on the round-start state
 * (the card's own effects, no behavioural response), computed by planRoundEvents. NEVER a score, value or price change
 * (EVENT_CARD_FORBIDDEN_KPIS). Unit is in the name. CET1 facts are masked until the team's forecast is committed.
 */
export const EventFactKey = z.enum([
  "depositOutflowUsd", "depositOutflowRate", "uninsuredShareAfterRate",
  "lcrLiteAfterRate", "fhlbCapacityRemainingUsd", "dwCapacityRemainingUsd", "cashBufferAfterUsd",
  "thisYearEarningsHitUsd", "chargeOffUsd", "provisionBuildUsd", "opexHitUsd", "realizedLossUsd",
  "creToTrbcAfterRate", "constructionToTrbcAfterRate",
  "cet1ReportedAfterRate", "cet1MarkedAfterRate",
  "niiLossUsd", // ADR-0042: the interest income a balance effect loses this year (12.4 E1's Σ term), a part of thisYearEarningsHitUsd
  "ciGrowthVsTrendRate", // ADR-0058: the bank's trailing-24-month C&I growth above the market's (the round-start trigger metric, frozen in the card's snapshot); EV-07's why-this-size line
]);
export type EventFactKey = z.infer<typeof EventFactKey>;
/** Masked on cards until the round's forecast commit (PREVIEW_GATED_KPIS rule, OD5-3). */
export const EVENT_GATED_FACT_KEYS = ["cet1ReportedAfterRate", "cet1MarkedAfterRate"] as const satisfies readonly EventFactKey[];
/** Never shown on an event card, in any form (OD5-3): the choice must be a judgment, not a reading test. */
export const EVENT_CARD_FORBIDDEN_KPIS = ["valueCreated", "price", "ptbv", "tbvps", "coe", "eps", "roe", "rotce"] as const satisfies readonly KpiId[];

export const EventChoice = z.object({
  id: z.string(), // "A".."D"
  label: z.string(),
  /** Plain-language trade-offs (content, digit-free; numbers come only from factKeys). */
  tradeOffs: z.array(z.string().max(200)).min(1).max(4),
  /** Which first-order facts this choice's card shows (OD5-3). */
  factKeys: z.array(EventFactKey),
  decisionOverrides: z.array(Effect), // decisionOverride / decisionConstraint only (validated in content build)
  effects: z.array(Effect),
  laggedEffects: z.array(LaggedEffect),
  supervisoryImpact: z.object({ component: z.enum(["C", "A", "M", "E", "L", "S"]).optional(), direction: z.enum(["improves", "neutral", "risk", "watch"]), note: z.string().optional() }),
  complexity: z.array(ComplexityLevel).optional(),
  /** The decisions this choice acts on, so a reviewer can object to a card answer where no decision override exists (a hedge: the rate position; a loan sale: the loan book). Absent or empty = the card changes no decision. */
  relatedDecisions: z.array(DecisionId).optional(),
});
export type EventChoice = z.infer<typeof EventChoice>;

/** Full event card schema (content.md EV-01..EV-07; seven cards, OD5-7). */
export const EventCard = z.object({
  id: EventId,
  title: z.string(),
  category: z.enum(["liquidity", "credit", "regulatory", "governance", "strategic", "macro"]),
  severity: z.number().int().min(1).max(3),
  priority: z.number().int(), // content; lower fires first under the per-bank cap. Pilot: EV-01 1, EV-06 2, EV-02 3, EV-07 4, EV-03 5, EV-05 6, EV-04 7
  trigger: z.object({
    kind: z.enum(["scheduled", "conditional", "scheduledOrConditional"]),
    when: Predicate.optional(),
    earliestRound: RoundIndex,
    cooldownRounds: z.number().int().nonnegative().optional(),
    oncePerGame: z.boolean(),
    maxTargets: z.number().int().positive().optional(),
    targetOrder: z.object({ metric: z.string(), dir: z.enum(["asc", "desc"]) }).optional(),
    /** Restrict targets to these seat kinds (EV-05 soft landing: ["human"], by P/TBV asc). Absent = all seats. */
    seatKinds: z.array(SeatKind).optional(),
    amplifier: z.object({ when: Predicate, mult: z.number() }).optional(),
  }),
  /**
   * Tiers (EV-01 base/severe, EV-07 T1–T3) and variants (EV-03 CRE/soft/BSA/horizontal review): first matching wins.
   * `priority` overrides the card's priority for this variant only, e.g. EV-03's "horizontal review"
   * cadence filler at 8 yields its slot to a bid (6) or an activist letter (7) and is then shown as a notice. Absent = card priority.
   */
  variants: z.array(z.object({
    id: z.string(),
    when: Predicate.optional(),
    severity: z.number().int().min(1).max(3).optional(),
    priority: z.number().int().optional(),
    shocks: z.array(Shock),
    factOverrides: z.record(z.string(), z.string()).optional(),
    /** Bank-level cards only (12.1 E4a): when the per-bank cap displaces this variant it is a candidate again next round (once), ahead of the rest; unmarked, it drops. Never applied at its default. */
    deferIfDisplaced: z.boolean().optional(),
  })).min(1),
  target: z.object({ scope: z.enum(["bank", "market"]), sympathy: z.object({ when: Predicate, outflowShareRate: Rate }).optional() }),
  timing: z.object({ phase: z.enum(["roundStart", "midRound"]), month: z.number().int().positive() }),
  facts: z.object({ narrative: z.array(z.string()), shockFactKeys: z.array(EventFactKey) }),
  shocks: z.array(Shock), // common to all variants
  choices: z.array(EventChoice).min(2),
  /**
   * What happens with no answer by the deadline. `label` is the short digit-free name the card shows ("If no answer:
   * …"); `choiceId` names the choice the default equals when it equals one (its effects must then equal that choice's; EV-07
   * "D Stay the course"), absent when the default is its own outcome (EV-01 "fund the outflow at the stressed spread").
   */
  default: z.object({
    label: z.string().min(1).max(80),
    choiceId: z.string().optional(),
    effects: z.array(Effect), laggedEffects: z.array(LaggedEffect), supervisoryImpact: EventChoice.shape.supervisoryImpact,
  }),
  rationaleRequired: z.boolean(),
  /** Live-surprise countdown default only (ADR-0015, 2–30 min, display-only per OD4-5). Planned events are due at round close. */
  responseDeadlineMinutes: z.number().int().positive().optional(),
  evidenceTags: z.array(z.object({ competency: Competency, tag: z.string() })),
  debriefPrompts: z.array(z.string()),
  anchor: z.string().optional(),
  /** ADR-0094 (CB12, W3): one plain, digit-free sentence saying what happened, as a reader outside the bank would see it (the press, analyst and judge event summaries). Absent = the summary falls back to the title and category. */
  publicLine: z.string().min(1).optional(),
}).refine((c) => c.default.choiceId === undefined || c.choices.some((x) => x.id === c.default.choiceId), "default.choiceId must name one of the card's choices");
export type EventCard = z.infer<typeof EventCard>;

/** A fired event for one seat (or market). */
export const EventInstance = z.object({
  instanceId: EventInstanceId,
  eventId: EventId,
  variantId: z.string(),
  seatId: SeatId.optional(), // absent ⇒ market-wide
  round: RoundIndex,
  firedMonth: Month,
  resolvedFacts: z.partialRecord(EventFactKey, z.number()), // shock facts (EventCard.facts.shockFactKeys), engine-supplied
  /** Per-choice first-order facts (EventChoice.factKeys), computed at planning from the round-start state (OD5-3). */
  choiceFacts: z.record(z.string(), z.partialRecord(EventFactKey, z.number())),
  status: z.enum(["pending", "responded", "defaulted"]),
  choiceId: z.string().optional(),
  /**
   * "An event reads the world once" (12.4): every Predicate metric, decision path and exposure base the card, its
   * variants, lagged conditions and scaledChargeOff drivers read, taken at planning on the receiving bank's round-start state
   * (the twin's own for a twin instance). Engine-written.
   */
  snapshot: z.object({ metrics: z.partialRecord(z.string(), z.number()), exposureUsdByBook: z.partialRecord(BookId, Usd) }).optional(),
});
export type EventInstance = z.infer<typeof EventInstance>;

// ───────────────────────────────────────────────────────────── personas & archetypes

/** AI competitor persona: deterministic policy over Decisions (same Expander as humans). */
export const Persona = z.object({
  id: PersonaId,
  name: z.string(), // Fortress, CRE Growth, Digital Challenger, Yield Reacher, Relationship Commercial, Efficiency Operator
  pilot: z.boolean(),
  blurb: z.string(),
  baseDecisions: Decisions,
  riskAppetite: StrategyStatement.shape.riskAppetite,
  /** The persona's story decisions (finale reveal; 11.4). No jitter: personas are deterministic (M7i). */
  signatureDecisions: z.array(DecisionId),
  /** @deprecated ADR-0048: a persona that keeps buying through a negative outlook carries `capital.buyback.pauseOnOutlook = false` in `baseDecisions`. Absent in data. */
  ignoresOutlookPause: z.boolean().optional(),
  /** Reactive rules, evaluated in order at round start on prior quarter-end state (§3b). */
  rules: z.array(z.object({ when: Predicate, adjust: z.array(z.object({ path: DecisionPath, op: z.enum(["set", "add", "min", "max"]), value: DecisionValue })) })),
  eventChoiceWeights: z.partialRecord(EventId, z.record(z.string(), z.number().nonnegative())),
  voice: z.object({ tone: z.string(), tagline: z.string() }).optional(), // AI narrative only
});
export type Persona = z.infer<typeof Persona>;

/** 03.5 (loans decision page §5/§7; OR-16): RM and loan-officer economics and the premium/discount adverse-selection multipliers. */
const LoansParamsObject = z.object({
  rm: z.object({
    startingHeadcountByBook: z.partialRecord(z.enum(["ci", "cre"]), z.number().int().positive()),
    loadedCostUsd: Usd, hiringCostShareRate: Rate, firstOutputMonth: z.number().int().nonnegative(), fullOutputMonth: z.number().int().positive(),
    addedRmProductivityRate: Rate, annualAttritionRate: Rate, annualAttritionRateByPayNotch: z.array(Rate).length(3).optional(), leaverBookShareRate: Rate, leaverRunoffMonths: z.number().int().positive(),
    depositsPerAddedRmUsd: Usd, depositBuildStartMonth: z.number().int().nonnegative(), depositBuildEndMonth: z.number().int().positive(),
    /** ADR-0069 (03.5 E5, P5-D2): hired RMs' commercial deposits are capped at this share of the twin's commercial deposit base, D = min(D_raw, ω·B_twin); absent = no cap. */
    marketDepthRate: Rate.optional(),
    /** Net team change vs trend per growth notch −2…+3 (index 0 = −2); the Exit notch (−3) stops hiring and runs the book off. */
    hiringRateByNotch: z.array(Rate).length(6),
    /** ADR-0072 (03.5 E8): per-book form of `fullOutputMonth` and `hiringCostShareRate`; a key present overrides the scalar for that book, absent = the scalar. */
    byBook: z.partialRecord(z.enum(["ci", "cre"]), z.object({ fullOutputMonth: z.number().int().positive().optional(), hiringCostShareRate: Rate.optional(),
      /** ADR-0094 (CB12, 03.5 E5): per-book form of `depositsPerAddedRmUsd`, whole dollars a hired RM brings; absent = the scalar (the pin `loans.rm.depositsPerAddedRm.<book>` stays the fallback until the engine adopts it). */
      depositsPerAddedRmUsd: Usd.optional() }).strict()).optional(),
    /** ADR-0072 (03.5 E2a/E4a/E8): a new hire's pricing concession in basis points off the book's rate while the hire ramps; absent = none. */
    newHirePricingConcessionBp: Bp.optional(),
    /** ADR-0072: a new hire's loss rate as a multiple of the book's, decaying to 1 over `newHireLossDecayMonths`; absent = 1 (no extra loss). */
    newHireLossMultiplier: z.number().positive().optional(),
    newHireLossDecayMonths: z.number().int().positive().optional(),
    /** ADR-0072 (M3): the rate concession in basis points on the commercial deposits a hire brings, held for `rateConcessionMonths`; absent = none. */
    rateConcessionBp: Bp.optional(),
    rateConcessionMonths: z.number().int().positive().optional(),
    /** OR-30.1 (03.5 E5b): the concession fades to this many basis points and holds while the dollar stays; absent = fades to zero. */
    rateConcessionFloorBp: Bp.optional(),
  }),
  lo: z.object({
    startingHeadcount: z.number().int().positive(), baseUsd: Usd, commissionRate: Rate, hiringCostUsd: Usd, fullOutputMonth: z.number().int().positive(),
    annualAttritionRate: Rate, annualAttritionRateByPayNotch: z.array(Rate).length(3).optional(), hiringRateByNotch: z.array(Rate).length(6),
  }),
  /** Marketing spend multiple of the consumer and card books by growth notch −2…+3 (index 0 = −2); the Exit notch (−3) spends nothing. ADR-0049. */
  consumerMarketingMultByNotch: z.array(z.number().nonnegative()).length(6).optional(),
  adverseSelection: z.object({ lossMultPerPremiumStep: z.number().positive(), lossMultPerDiscountStep: z.number().positive() }),
  /** Each loan book's rate index and its Follow spread over it (ci SOFR + 305bp, cre 5-year + 250bp, resi 10-year + 200bp, card prime + 900bp). */
  indexByBook: z.partialRecord(BookId, z.enum(["sofr", "treasury5y", "treasury10y", "prime"])),
  followSpreadOverIndexBpByBook: z.partialRecord(BookId, Bp),
});
export type LoansParams = z.infer<typeof LoansParamsObject>;
export const LoansParams: z.ZodType<LoansParams> = LoansParamsObject;

/** 02.1 (deposits decision page §5/§7): the front book. */
const DepositsParamsObject = z.object({
  frontBookMonths: z.number().int().positive(), migrationShareRate: Rate, leakReturnSpeedDivisor: z.number().positive(),
  baseLeakRatePerStepPerMonth: Rate, rateSensitivityByProduct: z.partialRecord(ProductId, z.number().nonnegative()),
});
export type DepositsParams = z.infer<typeof DepositsParamsObject>;
export const DepositsParams: z.ZodType<DepositsParams> = DepositsParamsObject;

/** 07.3 (operations decision page): the expense levels' run-rate change and customer-service points; invest aggressively +6% / +4 points. */
const OperationsParamsObject = z.object({
  expenseChangeRateByLevel: z.record(z.enum(["investAggressively", "invest", "hold", "modest", "aggressive", "deep"]), Rate),
  serviceIndexDeltaByLevel: z.record(z.enum(["investAggressively", "invest", "hold", "modest", "aggressive", "deep"]), z.number()),
});
export type OperationsParams = z.infer<typeof OperationsParamsObject>;
export const OperationsParams: z.ZodType<OperationsParams> = OperationsParamsObject;

const ExpanderParamsV2Shape = {
  loans: LoansParams.optional(),
  deposits: DepositsParams.optional(),
  operations: OperationsParams.optional(),
};

/**
 * Expander constants (11.1; expander_personas §1b–§1d; data gameplay_params `/contentParams/expander`, generated from
 * simstart `/opex`, model_params pins and the §1b constants). Every number the Expander uses that is not a model param:
 *  - marketingBaseUsd: M0 by loan family (BookId) and by deposit ProductId, plus "treasuryMgmt" (M0_tm).
 *  - techBaseUsd T0, trainingBaseUsd Tr0, compPerFteUsd; controllableOpexBaseUsd = SimStart controllable opex (comp +
 *    occupancy + other; tech, marketing and CDI excluded; 07.3 E3), scaled by FranchiseState.opexBalanceScale.
 *  - pricingSigmaByBook σ_p (loans.<book>.pricing); marketingMultipleClamp = the x bounds (11.1 E6; the only clamp: no s_eq clamp and no f̄).
 *  - spreadStepBp (25bp per notch, loan pricing and deposit rates); growthDeltaRateByNotch Δ(n) for n = −2…+3 (index 0 = −2); runoffRenewalRate ρ_p
 *    by family for the Exit notch (absent = 0). growthDeltaRateByNotch retires with the growth inversion (R2.1).
 *  - retail/commercial deposit marketing multipliers by notch (retail n = −2…+2; commercial n = −1…+2); depositProducts names which
 *    products the rate decisions move (the rest carry spread 0 and marketing 0).
 *  - securities / funding (old tables, retired by R2.3/R2.4: the residual rule, the treasury block of ContentParams): S* share, sleeves, funding table.
 *    feeScheduleMultByNotch, compChangeRateByNotch, trainingMultByNotch: operations.peopleAndFees.
 *  - tech: TI per level = mult·T0 + offsetUsd; preset weights (balanced 25 each; focus 55, others 15). operations.tech.
 *  - fteSavingsShareRate: fteDelta = −savings × share ÷ compPerFteUsd (expense). (the old raise price discount, `raiseDiscountRate`, is removed: every raise prices at δ(I) in capitalPolicy.issuance, 08.2 E7).
 *  - ADR-0048 optional blocks `loans`, `deposits`, `operations` (data authored with R2.1/R2.2/R2.5, whose oracles own the values): RM and loan-officer economics,
 *    front-book deposit rules, the expense levels. Absent until then.
 */
export const ExpanderParams = z.object({
  marketingBaseUsd: z.record(z.string(), Usd),
  techBaseUsd: Usd,
  trainingBaseUsd: Usd,
  compPerFteUsd: Usd,
  controllableOpexBaseUsd: Usd,
  pricingSigmaByBook: z.partialRecord(BookId, z.number().nonnegative()),
  marketingMultipleClamp: z.object({ min: z.number().positive(), max: z.number().positive() }),
  spreadStepBp: Bp,
  growthDeltaRateByNotch: z.array(Rate).length(6),
  runoffRenewalRateByBook: z.partialRecord(BookId, Rate),
  retailDepositMarketingMultByNotch: z.array(z.number().nonnegative()).length(5),
  commercialDepositMarketingMultByNotch: z.array(z.number().nonnegative()).length(4),
  depositProducts: z.object({ retailSpread: z.array(ProductId), commercialSpread: z.array(ProductId), ecr: z.array(ProductId), treasuryMgmtMarketing: ProductId }),
  /**
   * L9: S* = TA·(base + step·n); sleeves by duration choice — short = 100% UST at shortUstDurationYears; neutral = neutralSleeve
   * (the SimStart mix); long = longMbsWeightRate current-coupon MBS at longMbsDurationYears + the rest UST at longUstDurationYears.
   * newBuyAccounting sets the HTM share of ALL new buys {afsLean 0, neutral neutralHtmShareRate, htmLean htmLeanShareRate},
   * taken from the MBS part (capped at it); UST is always AFS.
   */
  securities: z.object({
    baseShareOfAssetsRate: Rate, shareStepPerNotchRate: Rate, shortUstDurationYears: z.number().positive(),
    longMbsWeightRate: Rate, longMbsDurationYears: z.number().positive(), longUstDurationYears: z.number().positive(),
    neutralSleeve: z.array(z.object({ bookId: z.enum(["ust_afs", "mbs_afs", "mbs_htm"]), durationYears: z.number().positive(), weightRate: Rate })).min(1),
    neutralHtmShareRate: Rate, htmLeanShareRate: Rate,
  }),
  funding: z.record(z.enum(["lean", "balanced", "termed", "fortress"]), z.object({
    shortfallMix: z.object({ fhlbShortRate: Rate, fhlbTermRate: Rate, brokeredRate: Rate }), bufferAboveCashFloorUsd: Usd, dwPrepledge: z.boolean(),
  })),
  feeScheduleMultByNotch: z.array(z.number().positive()).length(3),
  compChangeRateByNotch: z.array(Rate).length(3),
  trainingMultByNotch: z.array(z.number().nonnegative()).length(3),
  tech: z.object({
    levelSpend: z.record(z.enum(["min", "low", "base", "high", "max"]), z.object({ mult: z.number().nonnegative(), offsetUsd: Usd })),
    balancedWeightRate: Rate, focusWeightRate: Rate, otherWeightRate: Rate,
  }),
  fteSavingsShareRate: Rate,
  ...ExpanderParamsV2Shape,
});
export type ExpanderParams = z.infer<typeof ExpanderParams>;

/** One CRO memo condition (11.5): metric `m` cmp (`v` | ras limit index `ras` | data key `param`) + `off`; `kind` overrides the item kind. */
export const CroCondition = z.object({
  m: z.string(),
  cmp: z.enum(["lt", "le", "gt", "ge", "eq"]),
  v: z.number().optional(),
  ras: z.number().int().nonnegative().optional(),
  param: z.string().optional(),
  off: z.number().optional(),
  kind: z.enum(["riskAppetiteBreach", "camelsFlag", "pcaRisk", "concentration", "liquidity"]).optional(),
}).refine((c) => [c.v, c.ras, c.param].filter((x) => x !== undefined).length === 1, "exactly one of v / ras / param");
export type CroCondition = z.infer<typeof CroCondition>;

/** ContentParams.treasury (Gate 3b; docs/models 05–06), typed by its inferred shape so the route table's declaration stays small enough to emit. */
const TreasuryParamsObject = z.object({
    liquidity: z.object({
      targetGridRate: z.array(Rate).min(1), standingTargetRate: Rate, securitiesSoftBandOfAssetsRate: z.object({ minRate: Rate, maxRate: Rate }), bufferRule: z.string(),
      /** 06.3 E7-E8 (P4-D8): for `overshootQuarters` quarters after a run treasury holds the target + `overshootRate`; the overnight borrowing since the run is termed out within `termOutWithinMonths` through the `termOutMix` funding strategy. */
      afterRun: z.object({ overshootRate: Rate, overshootQuarters: z.number().int().positive(), termOutWithinMonths: z.number().int().positive(), termOutMix: z.enum(["overnight", "balanced", "termed", "fortress"]),
        /** 06.3 E7: a run is a deposit outflow of at least this share of deposits in a month (a 3% outflow of checking balances is a normal month). */
        runThresholdRate: Rate }),
    }),
    securities: z.object({
      typeUstWeightRate: z.object({ ustLean: Rate, neutral: Rate, mbsLean: Rate }), ustWeightFloorRate: Rate,
      ustTenor: z.object({ short: CurvePoint, neutral: CurvePoint, long: CurvePoint }),
      ustDurationYears: z.object({ short: z.number().positive(), neutral: z.number().positive(), long: z.number().positive() }),
      mbsDurationYears: z.number().positive(), htmMbsDurationYears: z.number().positive(),
      htmShareOfMbsRate: z.object({ afsLean: Rate, neutral: Rate, htmLean: Rate }),
      mbsSpreadToUst10yBp: Bp, mortgageSpreadToUst10yBp: Bp, htmYieldSpreadBp: Bp,
    }),
    ratePosition: z.object({
      notchSpacingRate: Rate, notches: z.array(z.number().int()).min(1), notionalStepUsd: Usd, capRateOfTotalAssets: Rate, retradeToleranceRate: Rate,
      swapSpreadToUstBp: Bp, floatingLegIndex: z.literal("SOFR"), tenorsYears: z.array(z.number().int().positive()).min(1), defaultTenorYears: z.number().int().positive(),
      floatingLegSensitivityWeightRate: z.number(), riskMeasure: z.literal("worseOfPlusMinus"), niiShockBp: Bp, eveShockBp: Bp,
    }),
    funding: z.object({
      mixes: z.record(z.enum(["overnight", "balanced", "termed", "fortress"]), z.object({ fhlbShortRate: Rate, fhlbTermRate: Rate, brokeredRate: Rate })),
      standing: z.enum(["overnight", "balanced", "termed", "fortress"]),
      overnightFhlbSpreadToFfBp: Bp, termFhlbSpreadToUst2yBp: Bp,
      prefundMonths: z.partialRecord(z.enum(["overnight", "balanced", "termed", "fortress"]), z.number().int().nonnegative()),
      surplusOrder: z.record(z.enum(["overnight", "balanced", "termed", "fortress"]), z.array(z.enum(["repayOvernightFhlb", "repayBrokeredAtMaturity", "holdCash"]))),
      waterfallOrder: z.array(z.string()), brokeredRestrictedBelowTier1Rate: Rate,
      /** ADR-0086 (CB4; N2, 06.1 E7a): the premium on brokered CDs, fed funds purchased and the discount window for a bank the market can see is weak, by public fact (the greatest applicable applies); `funding.weakness.*Bp` pins are the fallback. */
      weaknessSpreadBp: z.object({ consentOrder: Bp, belowWell: Bp, forcedRecap: Bp }).optional(),
    }),
  });
export type TreasuryParams = z.infer<typeof TreasuryParamsObject>;
export const TreasuryParams: z.ZodType<TreasuryParams> = TreasuryParamsObject;

/** Content parameters that are engine rules pinned by content (hashed into contentHash). */
export const ContentParams = z.object({
  taxRate: Rate, // 0.23 symmetric
  /** ADR-0069: thresholds the plain-words readings use. Absent keys = 0.0025, 50_000 and 0.05. `depositBetaMinPolicyMoveRate`: the smallest policy-rate move a deposit beta is read on; `practiceMinPartUsd`/`practiceMinPartBp`: the smallest part a practice sentence names. */
  /** ADR-0072: plain-words notes the limits page shows; `eveLooserThanRatingLine` takes {limit} and {line}. Absent = no note. */
  limitsNotes: z.object({ eveLooserThanRatingLine: z.string() }).optional(),
  /**
   * ADR-0079 (OR-29.3; 01.1 E5): in a mode listed in `appliesToModes`, at a base level with a row in `capBpByLevel`, the realised keyframes of the policy rate and the curve points are held within
   * these caps (bp) of the authored consensus: `ffRate` (policy rate and the 3-month point), `curve2y`, `curve10y` (the 5- and 10-year points; mortgage and MBS follow the 10-year's change).
   * Absent, or a mode or level without a row = no cap.
   */
  learningSurprise: z.object({
    appliesToModes: z.array(PlayMode).min(1),
    capBpByLevel: z.partialRecord(ComplexityLevel, z.object({ ffRate: z.number().nonnegative(), curve2y: z.number().nonnegative(), curve10y: z.number().nonnegative() })),
  }).optional(),
  readings: z.object({ depositBetaMinPolicyMoveRate: Rate.optional(), practiceMinPartUsd: Usd.optional(), practiceMinPartBp: Bp.optional() }).optional(),
  accrualBasis: z.literal("30/360"),
  autopilot: z.object({
    targetCet1Rate: Rate, // 0.105 (M5b; 08.2)
    buybackCapUsdPerQuarter: Usd, // 150M
    playerBuybackCapUsdPerQuarter: Usd, // 250M
    dividendPayoutRate: Rate, // 0.40 trailing EPS
    dpsCutBelowCet1Rate: Rate, // 0.09
    /**
     * 08.2 E10 outlook pause (M9): at each quarter-end ΔU = max(unemployment now, the highest on the published consensus
     * path to the round end) − the lowest of the last lookbackQuarters quarter-ends; negative outlook ⇔ ΔU ≥ unemploymentRiseRate;
     * buybacks with FineDecisions.capital.buyback.pauseOnOutlook pause from the next month 1 until resumeQuarters calm quarter-ends.
     */
    outlookPause: z.object({ unemploymentRiseRate: Rate, lookbackQuarters: z.number().int().positive(), resumeQuarters: z.number().int().positive() }).optional(),
    /** 08.2 E1 (ADR-0048): the twin's dividend rule — raise one DPS step when the last four quarters' dividends are under raiseBelowPayoutRate of earnings and CET1 ≥ the target; cut one step below cutBelowCet1Rate. */
    twinDividend: z.object({ raiseBelowPayoutRate: Rate, cutBelowCet1Rate: Rate }),
  }),
  /**
   * 08.2 capital decisions (Gate 3a; simstart `/capitalPolicy`): the dividend step, the cut premium's length (four quarters; its size is `valuation.priceModel.premiaBp`), the own-target
   * window and the raise discount δ(I) = discountBaseRate + discountSlope × (raise ÷ market value).
   * `autopilot.playerBuybackCapUsdPerQuarter` and `dividendPayoutRate` are unread by the redesigned model (one $150M cap; DPS steps); R2.1 removes them.
   */
  capitalPolicy: z.object({
    dpsStepUsdPerShare: UsdPerShare, premiumQuarters: z.number().int().positive(),
    ownTargetLookbackQuarters: z.number().int().positive(),
    issuance: z.object({ discountBaseRate: Rate, discountSlope: z.number() }),
    /** 08.2 E6 (ADR-0055, P4-D1): the month of a quarter the dividend is declared and paid in, and the buyback's share of the quarter by month (sums to 1). Absent = declared, paid and bought in month 1. */
    distributionSchedule: z.object({
      dividendDeclaredMonthOfQuarter: z.number().int().min(1).max(3), dividendPaidMonthOfQuarter: z.number().int().min(1).max(3), buybackShareByMonthOfQuarter: z.array(Rate).length(3),
    }).optional(),
  }),
  /**
   * The SimStart facts the rate-level rules anchor on, derived from the SimStart pack (ADR-0055): the nonaccrual loans (04.3 S3's baseline), DDA's share of all deposits and each market
   * deposit product's share of the market's balances (02.1 E1a's weights of the average deposit rate; 02.2 E1). On the params, not the pack, so a preview's stand-in pack reads the same.
   */
  simStartMarket: z.object({ nplUsd: Usd, ddaShareOfDepositsRate: Rate, depositWeightByProduct: z.record(ProductId, Rate) }).optional(),
  /** 04.3 S2–S3 (P4-R6; simstart `/credit/cycleEarnings`): the stress-year earnings responses read by fees (07.2) and opex (07.3). Absent = none. */
  cycleEarnings: z.object({
    feeDragPerUnemploymentPointRate: Rate, cyclicalFeeLines: z.array(z.string()), workoutCostRateOfExcessNplAnnual: Rate,
  }).optional(),
  /**
   * Treasury decisions (Gate 3b; gameplay `/contentParams/treasury`, docs/models 05–06): the liquidity-target grid and buffer rule, the securities
   * make-up, the rate-position scale and swap rules, and the funding mixes, surplus orders and waterfall.
   */
  treasury: TreasuryParams,
  valuation: z.object({
    requiredCapitalRate: Rate, // 0.105
    coeMinusGFloorRate: Rate, // 0.04
    ptbvMax: z.number(), // 3.0
    priceShockDecayMonths: z.number().int(), // 12
    eveEquityBasis: z.enum(["scoringDate", "fixed"]),
    tsrConvention: z.literal("compoundAtCoe"),
    /**
     * The Gate 4 price model (P4-D10; 10.1–10.2): P = book × a fair multiple with growth on a normalised return, which the market closes a third of the way a quarter.
     * `coeInterceptRate` is c₀, solved so SimStart prices at the published $62 (I22). Premia read visible facts only: no premium for a CAMELS rating or an MOU (R3).
     */
    priceModel: z.object({
      coeInterceptRate: Rate,
      growthBaseRate: Rate, growthTrendRate: Rate, growthPassThroughRate: z.number(), growthBandRate: Rate, growthLookbackMonths: z.number().int().positive(),
      rotceForwardWeightRate: Rate, rotceHistoryMonths: z.number().int().positive(),
      gapClosedPerQuarterRate: Rate,
      floorPtbv: z.number(),
      /** The product whose reference rate is the marginal funding rate retained capital earns (R4; 10.1 E5). */
      retainedCapitalRateRef: z.string(),
      premiaBp: z.object({ dividendCut: Bp, suspension: Bp, enforcement: Bp, rateRiskCap: Bp, totalCap: Bp }),
      enforcementFadeQuarters: z.number().int().positive(),
      /** ADR-0069 (10.1 E4′ option (d), P5-D1): how the securities book is referenced in the price model; absent = today's reading. */
      securitiesReference: z.enum(["optionAdjusted", "coupon"]).optional(),
      /** ADR-0072 (10.1 E4′): the option cost read in E4′ for every MBS lot in both readings; absent = the book's 107bp gap (chapter 10 E13). */
      securitiesOptionCostBp: Bp.optional(),
      /** ADR-0092 (CB10, 10.1 E4′, Q3): the market MBS tenor, in years, the N3 carry strip reads the securities book's funding term at (a market tenor, never the bank's own lot durations); absent = no strip (today's reading). No data value yet. */
      marketMbsTenorYears: z.number().positive().optional(),
      /** ADR-0072 (10.1 E5a, M10): how the price reads one-time costs: excluded = reduce capital once after tax and add back to the core; absent = inCore (today's reading). */
      oneOffOpex: z.enum(["excluded", "inCore"]).optional(),
    }),
    /** 10.3 / 10.4 E1: the terminal value's weight in the score (1 = full); `dialEnabled` swaps it for the fallback 2/3 market price, 1/3 terminal weight; `runRateMonths` is the look-through's last months its return and growth are read from (X4.4); `inFlightCapPp` (E4.5, OR-21) caps the franchise line (capability in flight) at that many points of the bank's wealth at T, the surplus carried uncounted. */
    terminal: z.object({ weightRate: Rate, dialEnabled: z.boolean(), dialTerminalWeightRate: Rate, runRateMonths: z.number().int().positive(), inFlightCapPp: z.number().nonnegative(),
      /** ADR-0068 (10.3 E8′): `inFlightHaircutMaxRate`: the most of the franchise beyond the cap that is credited: h = max × min(1, max(0, spread) ÷ inFlightFullSpreadPp), spread in percentage points (round-start forward return less cost of equity, ×100). Both keys or neither; if either is absent h = 0, so nothing beyond the cap counts (OR-21). */
      inFlightHaircutMaxRate: Rate.optional(),
      /** ADR-0068: the spread, in percentage points, at which the credit beyond the cap reaches `inFlightHaircutMaxRate` (see there; both keys or neither). */
      inFlightFullSpreadPp: z.number().positive().optional() }),
    premia: z.object({
      /**
       * Thin-capital premium (OD4-2; 10.2): slope1 × max(0, threshold1 − K) +
       * slope2 × max(0, threshold2 − K), K in pp. `measure`:
       *  - "horizonMeanQuarterEnd" (pilot): K = the CAPITAL RECORD, the mean REPORTED CET1 over every quarter-end of the
       *    look-through horizon being valued (final score: 16 played + 8 look-through = 24; per round r: 4r played + that
       *    round's 8; an in-play/shadow month-end price: completed quarter-ends + the current month-end; before the first
       *    quarter-end K = current CET1). One price function everywhere (display, buybacks, issuance, scoring). I34.
       *  - "pointInTime": K = reported CET1 at the valuation date (scoring unit tests only).
       * Pilot 0.105 / 70 / 0.09 / 25 (M5b). threshold1 is anchored to the autopilot: K_auto(G7-H) 10.64% − 0.13pp,
       * rounded to the L12 grid (re-anchor, as content, if the engine's K_auto moves > 3bp). SimStart CET1 11.22% ≥ 10.50% ⇒
       * premium 0, price $62.00. K rule: BankState.capitalRecord (10.2 E1).
       */
      capital: z.object({ threshold1Rate: Rate, slope1BpPerPp: z.number(), threshold2Rate: Rate, slope2BpPerPp: z.number(), measure: z.enum(["pointInTime", "horizonMeanQuarterEnd"]) }),
      creConcentration: z.object({ thresholdRate: Rate, bpPer25Pp: z.number() }),
      wholesale: z.object({ thresholdRate: Rate, bpPer5Pp: z.number() }),
      uninsured: z.object({ thresholdRate: Rate, bpPer5Pp: z.number() }),
      eve: z.object({ thresholdRate: Rate, bpPerPp: z.number() }),
    }),
    terminalTtcBlend: z.number(), // 0.5 trend / 0.5 TTC
    /**
     * Valuation keys (simstart `/valuation`). baseCoeRate = COE₀ (0.1079 = /checks/coe published, the oracles' COE0): compounds
     * distributions (10.4), converts VC to SimStart dollars (B = W_auto ÷ (1 + COE₀)^τ) and prices the bid. simStartShares =
     * SimStart shares outstanding (the $M display and "per SimStart share"). securitiesMarketYield: @deprecated:
     * the securities market yield has one home, MarketState.referenceRates of the book's products (01.2; 10.1 y_p).
     * normalizedProvision.trendLoanGrowthRate: the reserve-build term ACL% × g × loans (simstart `normalizedProvisionRule`).
     */
    baseCoeRate: Rate,
    simStartShares: Shares,
    securitiesMarketYield: z.partialRecord(BookId, z.object({ reference: z.enum(["curve5y", "mbsYield"]), spreadBp: Bp })).optional(),
    normalizedProvision: z.object({ trendLoanGrowthRate: Rate }),
  }),
  /**
   * EV-05 takeover bid (OD4-1; ADR-0025; 10.5). Pilot values in comments; PI bounded to [0.005, 0.015] and
   * recalibrated to the observed q75 of human-seat VC after the pilot (content change).
   */
  bid: z.object({
    premiumVcRate: Rate, // PI 0.0075
    hflPtbvRatioToMedian: z.number().positive(), // 0.95 × median ptbv of all six seats (HFL eligibility)
    hflPtbvRatioSettled: z.number().positive(), // 1.00 if the seat settled with the activist (EV-04 C)
    arbTargetRate: Rate, // 0.97: price moves up to 97% of the offer (display; decays over valuation.priceShockDecayMonths)
    adviserOpexHitUsd: Usd, // 4,000,000 on every choice, booked the month after the bid
    /**
     * Closing = the approval check = bid month + approvalLagMonths (pilot 6): the DEAL_COVENANT lifts at closing or at a
     * break (OD5-8a).
     */
    approvalLagMonths: z.number().int().positive(), // 6
    breakProbability: Rate, // 0.7 if composite > breaksIfCompositeAbove at the approval check (stream event:EV-05:approval)
    negotiateStepVcRate: Rate, // 0.005
    marketCheckStepVcRate: Rate, // 0.0075
    leakNmdRate: Rate, // 0.02 (market check, no bid)
    closeCallRate: Rate, // ε_close 0.001: |DC| ≤ this share of W_auto reads as a close call (10.5)
  }),
  capital: z.object({
    minimums: z.object({ cet1Rate: Rate, tier1Rate: Rate, trbcRate: Rate, leverageRate: Rate.optional() }), // leverage 4% (09.3)
    /** PCA significantly-undercapitalized lines and the critically-undercapitalized tangible-equity line (09.3 E1). */
    pcaSignificantly: z.object({ cet1Rate: Rate, tier1Rate: Rate, trbcRate: Rate, leverageRate: Rate }).optional(),
    pcaCriticalTangibleEquityRate: Rate.optional(),
    wellCapitalized: z.object({ cet1Rate: Rate, tier1Rate: Rate, trbcRate: Rate, leverageRate: Rate }),
    ccbTiers: z.array(z.object({ bufferAtMostRate: Rate, maxPayoutRate: Rate })), // ≤2.5/60 … ≤0.625/0
    aociOptOut: z.boolean(),
    offBalanceSheetRwaUsd: Usd,
    /**
     * RWA inputs beyond product risk weights (08.1; simstart `/statics`, `/capital`, conventions `rwa`, `dtaSplit`).
     * staticRiskWeightRate: weight per balance-sheet static item (goodwill/CDI are deducted, so 0). The DTA splits into an
     * ACL temporary-difference part (ACL × taxRate) at dtaAclRiskWeightRate (2.5) and the rest at staticRiskWeightRate.dta.
     * Nonaccrual loans take the product weight × CreditPdParams.nonaccrualRiskWeightMult where the product's creditPd ref
     * carries one, on a 100% base. ACL above aclCapRate × RWA leaves Tier 2 and RWA (deductionsUsd.aclExcessRwa);
     * the NOL DTA is deducted (deductionsUsd.dtaNol); the 25% threshold deduction (dtaExcess) stays 0 in the pilot.
     */
    rwa: z.object({ staticRiskWeightRate: z.partialRecord(StaticItemId, Rate), dtaAclRiskWeightRate: Rate }),
    /**
     * Capital stack (08.1; simstart conventions `capitalStack`, `leverage`): Tier 1 = CET1 (no AT1 in the pilot);
     * TRBC = Tier 1 + Σ balances of `bookIds` + min(ACL + unfundedCommitmentReserveUsd, aclCapRate × RWA).
     */
    tier2: z.object({ bookIds: z.array(BookId), aclCapRate: Rate, unfundedCommitmentReserveUsd: Usd }),
  }),
  liquidity: z.object({
    cashFloorRate: Rate, // 1.6% prior month-end TA
    fhlbCapacityCapRate: Rate, // 25% TA
    ffpLineRate: Rate, // 2% TA
    l2CapRatio: z.number(), // 2/3 of L1
    l2HaircutRate: Rate, // h₂ (06.3 E1): 0.15, SS /liquidity/l2HaircutRate
    wholesaleStressSpreadBp: Bp, // +50
    severeRunFhlbDay1ShareRate: Rate, // 0.5
    lcrLiteMinimumRate: Rate, // 1.0: the regulatory floor on liquidity stress coverage (P2 warns a looser own limit)
    /**
     * LCR-lite run-off (06.3 E2; M7a): by insured / uninsured / hot money, not by product. simstart
     * /liquidity/lcrLite. Optional until the WP06b content build fills this block from data.
     */
    lcrLite: z.object({
      insuredDepositRunRate: Rate, uninsuredDepositRunRate: Rate, hotMoneyRunRate: Rate, fhlbShortRunRate: Rate, maturingWholesaleRunRate: Rate,
      commitmentsDrawRate: Rate, commitmentsToLoansRate: Rate, loanInflowRate: Rate, fhlbTermNewMonths: z.number().int().positive(), brokeredNewMonths: z.number().int().positive(),
    }).optional(),
  }),
  /** IRR metrics (05.5 E1–E2): shock sizes and the 12-month repricing weights of S. simstart /irr. */
  irr: z.object({ niiShockBp: Bp, eveShockBp: Bp, repricingWeights: z.record(z.string(), Rate) }).optional(),
  supervisory: z.object({
    thresholds: z.record(z.enum(["C", "A", "M", "E", "L", "S"]), z.array(z.object({ metric: z.string(), cutoffs: z.array(z.number()).length(4), higherIsBetter: z.boolean() }))),
    weights20: z.object({ C: z.number().int(), A: z.number().int(), M: z.number().int(), E: z.number().int(), L: z.number().int(), S: z.number().int() }), // 5/5/3/2/3/2
    upgradeQuarters: z.number().int(), // 2
    /** @deprecated an MOU caps L1–L3 at Trend (09.2 E4, M5), not by an asset-growth cap. */
    mouGrowthCapRate: Rate.optional(),
    mouExitQuarters: z.number().int(), // 4: lifts after four quarter-ends at composite ≤ 2 (M5)
    forcedRecap: z.object({ targetCet1Rate: Rate, priceToTbv: z.number() }),
    /**
     * 09.1 E2–E4 modifiers (M5): M = mBaseRating; M ≥ distributionsOverEarningsMinRating when four-quarter distributions
     * exceed earnings AND CET1 < the autopilot target; event notches capped at notchCapRating; the L +1 modifier lasts
     * lModifierMonths after a run; findings map to A or M.
     */
    modifiers: z.object({
      mBaseRating: CamelsRating, distributionsOverEarningsMinRating: CamelsRating, notchCapRating: CamelsRating,
      /** @deprecated 09.1 E10 replaces the timed L notch. */
      lModifierMonths: z.number().int().nonnegative().optional(), findingComponent: z.partialRecord(Finding.shape.variant, z.enum(["A", "M"])),
      /** ADR-0047: M notches when quarter-end reported CET1 sits belowOwnTargetBp under the bank's own target or within nearMinimumBp of the regulatory minimum; capped at minRating. */
      mNotch: z.object({ belowOwnTargetBp: Bp, nearMinimumBp: Bp, minRating: CamelsRating }).optional(),
      /** ADR-0068 rev. F17.5c (09.1 E11): M notches one (never past notchCapRating) when a self-set limit is breached at `quarterEnds` of the last `lookbackQuarterEnds` quarter-ends, or `limits` of them at the newest. */
      mBreach: z.object({ quarterEnds: z.number().int().positive(), lookbackQuarterEnds: z.number().int().positive(), limits: z.number().int().positive() }).optional(),
    }).optional(),
    /** ADR-0047: a CCB payout-cap breach opens a capitalDistribution finding; it escalates after `escalateAfterQuarters` and closes after `closesAfterCleanQuarters` clean ones. */
    ccbBreach: z.object({ escalateAfterQuarters: z.number().int().positive(), closesAfterCleanQuarters: z.number().int().positive() }).optional(),
    /** 08.2 E4: under an MOU, dividends need approval: ≤ maxPayoutOfTrailingNiRate of trailing-4 NI and only while CET1 ≥ minCet1Rate. */
    mouDividend: z.object({ maxPayoutOfTrailingNiRate: Rate, minCet1Rate: Rate }).optional(),
    /** 06.2 E3: FHLB capacity × this at composite ≥ 4. */
    fhlbCapacityMultAtComposite4: z.number().positive().optional(),
    /**
     * 09.1 E9 (P4-D4): E rates on the last four quarters' ROA, `roa4qBandsRate` the cut-offs of ratings 1, 2, 3 (below the last = 4); a loss quarter among the four rates at least `lossQuarterRating`;
     * 5 when the four quarters lost more than `rating5LossRateOfAssets4q` of assets and CET1 is under the own target. E moves at most `maxDownNotchesPerQuarter` worse a quarter and one
     * notch better only on the `upgradeAfterQuarters`-th consecutive better quarter-end.
     */
    earningsRule: z.object({
      roa4qBandsRate: z.array(Rate).length(3), lossQuarterRating: CamelsRating, rating5LossRateOfAssets4q: Rate,
      maxDownNotchesPerQuarter: z.number().int().positive(), upgradeAfterQuarters: z.number().int().positive(),
    }),
    /**
     * 09.1 E10 (P4-D8): after a deposit run L is at least `ratingFloor` for `minQuarterEnds` quarter-ends, then steps up one notch a quarter-end once cover was at the liquidity target at
     * the last `upgradeCoverageAtTargetQuarterEnds` quarter-ends and wholesale funding is under `upgradeWholesaleShareOfLiabilitiesBelowRate` of liabilities.
     */
    liquidityAfterRun: z.object({
      ratingFloor: CamelsRating, minQuarterEnds: z.number().int().positive(), upgradeCoverageAtTargetQuarterEnds: z.number().int().positive(),
      upgradeWholesaleShareOfLiabilitiesBelowRate: Rate,
    }),
  }),
  /**
   * Event scheduling (ADR-0015, OD5-7): no cards before firstEventRound (pilot 2 = none in R1); at most maxPerBankPerRound
   * (pilot 2) and, from firstEventRound, at least minPerBankPerRound (pilot 1) per bank per round; over the cap the lowest
   * EventCard.priority fires and the rest are displaced (a displaced once-per-game card may fire next round).
   */
  events: z.object({ firstEventRound: RoundIndex, maxPerBankPerRound: z.number().int().min(1), minPerBankPerRound: z.number().int().min(0) })
    .refine((e) => e.minPerBankPerRound <= e.maxPerBankPerRound, "minPerBankPerRound must be ≤ maxPerBankPerRound"),
  /**
   * "Call the year" forecast scoring slots (OD5-1/OD5-6; ADR-0026 §1; 13.1). Values are gameplay data pins.
   *  - bands: per forecast KPI, the four guided bands as Δ vs last year's value (noChangeBaseline, 13.1) in bp, in ForecastBand order, contiguous
   *    (down has lowerBp null, upLot has upperBp null; each upper = the next lower). Also used to classify numeric forecasts.
   *  - hitToleranceBp: a numeric forecast "hits" when |forecast − twin actual| ≤ tolerance.
   */
  forecast: z.object({
    bands: z.record(z.enum(FORECAST_GATED_KPIS), z.array(z.object({ band: ForecastBand, lowerBp: z.number().nullable(), upperBp: z.number().nullable() })).length(4))
      .refine((b) => sortedEntries(b).every(([, rows]) => rows.every((r, i) => r.band === ForecastBand.options[i]
        && (i === 0 ? r.lowerBp === null : r.lowerBp !== null && r.lowerBp === rows[i - 1]?.upperBp)
        && (i === 3 ? r.upperBp === null : r.upperBp !== null && (r.lowerBp === null || r.upperBp > r.lowerBp)))), "bands must be down/flat/upLittle/upLot, contiguous"),
    hitToleranceBp: z.record(z.enum(FORECAST_GATED_KPIS), z.number().positive()),
  }),
  /**
   * Preview range method (OD5-8c; 13.2; cp2 preview). Range = [min, max] of the point
   * run and ONE extra value per sensitivity (one at a time); confidence tier from width ÷ toleranceByKpi: ≤
   * tierWidthMultiples.high → high, ≤ .medium → medium, else low. KPIs without a tolerance get no tier (null; P6 shows the point and delta only).
   * Pilot: 6 sensitivities (rates ±50bp, rivals ±1 notch, credit defaults ×1.25 / ×0.8) = point + 6 = 7 runs (ADR-0022 cost).
   * credit.mode: "run" = a full 12-month run with realized default rates × defaultMult (CECL scenario unchanged);
   * "analytic" = the ADR-0022 FALLBACK if the preview bench fails: no run, NCO and provision of the point run × defaultMult
   * and ROTCE recomputed from them (first-order exact over 12 months); the preview then makes 1 + 4 runs.
   */
  preview: z.object({
    sensitivities: z.array(z.discriminatedUnion("kind", [
      z.object({ kind: z.literal("rates"), shiftBp: Bp }),                     // consensus path shifted in parallel (FF + curve)
      z.object({ kind: z.literal("rivals"), attractivenessNotch: z.number() }), // every rival's attractiveness index shifted
      z.object({ kind: z.literal("credit"), defaultMult: z.number().positive(), mode: z.enum(["run", "analytic"]) }), // realized defaults × mult
    ])).min(1).max(6),
    tierWidthMultiples: z.object({ high: z.number().positive(), medium: z.number().positive() }).refine((t) => t.high < t.medium, "high < medium"),
    toleranceByKpi: z.partialRecord(KpiId, z.number().positive()),
  }),
  /**
   * Score display (OD5-2; ADR-0026 §2): $/share first, pp beside it, $M optional. Tier floors on valueCreatedRate
   * (behindTwin < steward floor ≤ topQuartile floor ≤ strong floor); |Δ| ≤ tieBandRate shows as "=" to participants.
   * Floors set by the 10.6 rule (owner M10: no single click reaches topQuartile or strong; values in gameplay data).
   */
  scoreDisplay: z.object({
    tierFloorsRate: z.object({ steward: Rate, topQuartile: Rate, strong: Rate }).refine((t) => t.steward <= t.topQuartile && t.topQuartile <= t.strong, "tier floors must ascend"),
    tieBandRate: Rate,
  }),
  /** Expander constants: see ExpanderParams. */
  expander: ExpanderParams,
  /**
   * CRO memo checks as data (11.5): K1–K13 in pillarOrder; each check's objection / warn / info is a list of
   * alternatives (OR) of condition lists (AND). A condition compares metric `m` (a KpiId, optionally `.low` = the preview
   * range's low end or `.roundDelta`, or a memo-internal measure named in 11.5 §4) with `v`, with the check's risk-appetite
   * limit `ras[i]` (a team's own limit, default from `ras[i].default`), or with the data value at key `param`, plus `off`.
   */
  croMemo: z.object({
    pillarOrder: z.array(z.enum(["capital", "liquidity", "credit", "rateRisk", "earnings", "supervisory"])),
    eventRiskDirections: z.array(z.string()),
    checks: z.array(z.object({
      id: z.string().regex(/^K\d{1,2}$/),
      pillar: z.enum(["capital", "liquidity", "credit", "rateRisk", "earnings", "supervisory"]),
      kind: z.enum(["riskAppetiteBreach", "camelsFlag", "pcaRisk", "concentration", "liquidity"]),
      ras: z.array(z.object({ kpi: KpiId, default: z.number(), min: z.number(), max: z.number() })),
      objection: z.array(z.array(z.lazy(() => CroCondition))),
      warn: z.array(z.array(z.lazy(() => CroCondition))),
      info: z.array(z.array(z.lazy(() => CroCondition))),
    })),
  }).optional(),
  /** ADR-0047: the value basis of the decision attribution's value-created rows (look-through twin per lever, or reported-only with one give-back row). Absent = lookThrough. */
  /** ADR-0072 (M8): `splitRounds` = how many of the most recent earlier rounds get their own attribution leg (`carriedByRound`); older rounds pool into one leg. Absent = 3. */
  attribution: z.object({ valueBasis: z.enum(["lookThrough", "reportedOnly"]), splitRounds: z.number().int().positive().optional() }).optional(),
  pins: z.record(z.string(), z.number()), // h, λ, ε, δ, κ, α, m_marg, burnout cap… (documentation mirror)
});
export type ContentParams = z.infer<typeof ContentParams>;

/**
 * Fictional starting bank calibrated to a peer band (pilot: Occam Court Bancshares, $25B). The calibration report is a
 * separate, non-hashed artifact. initMarket recomputes every derived snapshot (capital, liquidity, irr, kpis) from books + statics.
 */
export const ArchetypePack = z.object({
  id: ArchetypeId,
  name: z.string(),
  version: SemVer,
  peerBand: z.object({ minAssetsUsd: Usd, maxAssetsUsd: Usd, rules: z.array(z.string()) }),
  calibration: z.object({ bsMixWindow: z.string(), betaWindow: z.string(), creditAnchor: z.string() }),
  products: z.array(ProductDef),
  /** Bank-level models (fees, opex, capability) — not per product. */
  bankModels: z.array(ModelRef),
  simStart: BankState, // month 0, seatId placeholder "template"; built from docs/spec simstart_v3 (WP08a)
  referenceRates: z.record(z.string(), Rate), // ProductId → market reference rate at SimStart
  /** ADR-0088: A0 (07.3 E15) when `simStart` is not SimStart: a preview's implied pack holds the round-start bank there and carries the true A0 here; absent in a content pack. */
  startAssessmentUsd: Usd.optional(),
  simStartChecks: KpiSnapshot, // I22 expectations (e.g. cet1Reported 0.1122, price 62.00)
  checkTolerances: KpiSnapshot,
});
export type ArchetypePack = z.infer<typeof ArchetypePack>;

/** Everything content-side; contentHash = sha256 of canonical JSON of this object. */
export const ContentPack = z.object({
  version: SemVer,
  params: ContentParams,
  archetypes: z.array(ArchetypePack),
  scenarios: z.array(Scenario),
  events: z.array(EventCard),
  personas: z.array(Persona),
  /**
   * Guided level (ADR-0023; OR-6, ADR-0048): per family, the focus decisions open in rounds 0–`openingThroughRound` (`opening`; one decision) and the
   * ones that open with the later rounds (`later`; may be empty). Every other decision sits at STANDING_POLICY. Each id must belong to its family.
   */
  guided: z.object({
    openingThroughRound: RoundIndex,
    focusDecisions: z.record(DecisionFamily, z.object({ opening: z.array(DecisionId).min(1), later: z.array(DecisionId) })),
    /** P4-D12: a `later` decision that opens in this round instead of the round after `openingThroughRound`. */
    opensInRound: z.partialRecord(DecisionId, RoundIndex).optional(),
    /** P4-D12: decisions a guided round also opens in any round the bank shows a capital need (the preview's lowest quarter-end CET1 under the own target by the M-notch distance, a regulator gate live, or a stress card due). */
    unlockOnCapitalNeed: z.array(DecisionId).optional(),
    /** P4-D12: a guided round moves the decision at most this many grid steps from where the round began. */
    stepLimit: z.partialRecord(DecisionId, z.number().int().positive()).optional(),
  }).refine((g) => sortedEntries(g.focusDecisions).every(([fam, f]) => [...f.opening, ...f.later].every((id) => id.startsWith(`${fam}.`))), "guided focus decision must belong to its family"),
});
export type ContentPack = z.infer<typeof ContentPack>;

// ───────────────────────────────────────────────────────────── engine config & market

/** Pinned per cohort (program run): same inputs ⇒ same outputs (I15). */
export const EngineConfig = z.object({
  engineVersion: SemVer,
  contentHash: Sha256Hex,
  seed: z.number().int().min(0).max(0xffffffff),
  cadenceMonths: z.union([z.literal(3), z.literal(6), z.literal(12)]),
  rounds: z.number().int().min(1).max(12),
  shadowYears: z.number().int().min(0).max(3), // 2
  noiseScale: z.number().min(0), // 0 in scored play
  complexity: ComplexityLevel,
  mode: PlayMode,
  /** The cohort's pinned ranking (OD5-8b; 10.6; absent = valueVsTwin): resolveRound passes it to scoring's rankSeats. */
  ranking: z.lazy(() => Ranking).optional(),
});
export type EngineConfig = z.infer<typeof EngineConfig>;

/**
 * Named RNG substreams. No RNG state is stored: every draw site derives a fresh sfc32 from
 * rngFor(config.seed, stream, key) (cp2), keyed e.g. ["persona", round, seatId] or
 * ["event", round, eventId, seatId]. Replays, checkpoints and counterfactuals therefore draw identically.
 */
export const RngStream = z.enum(["event", "noise", "persona", "tiebreak"]);
export type RngStream = z.infer<typeof RngStream>;

/**
 * Public market information as of the last released round-end (what every bank "knows").
 * Persona policies, the Expander and the browser preview read ONLY this (+ own BankState).
 */
export const PublishedMarket = z.object({
  asOfRound: RoundIndex,
  asOfMonth: Month,
  env: EnvSnapshot,
  referenceRates: z.record(z.string(), Rate), // ProductId → reference rate
  /** Consensus env path for the upcoming round (len = cadenceMonths), from Scenario.consensusKeyframes. */
  consensusPath: z.array(EnvSnapshot).min(1),
  /** Per product: each seat's STOCK share at round end, B_j,p ÷ Σ_seats B_p (14.2). Input to the 11.1 growth inversion. */
  shares: z.record(z.string(), z.record(z.string(), Rate)),
  /**
   * Per seat: ONE total attractiveness index A_j = round-end-balance-weighted mean of that seat's final-month logit utilities
   * over all products with a logitShare ref (14.2). Per-product rival utilities are NOT published (ADR-0019 §4).
   */
  attractivenessIndex: z.record(z.string(), z.number()),
  /**
   * Public per-seat information after each released round (ADR-0019 §4): reported KPIs (PUBLIC_KPIS
   * subset), posted rate sheet (ProductId → posted rate), league rank and Value Created.
   * Never decisions or rationales. Seat kind (AI or human) is NOT here: it is revealed only at the finale's aiReveal stage (OD5-5).
   */
  peers: z.array(z.object({
    seatId: SeatId,
    kpis: KpiSnapshot,
    rateSheet: z.record(z.string(), Rate),
    leagueRank: z.number().int().positive().nullable(),    // null before R1 is released
    valueCreatedRate: Rate.nullable(),                     // null before R1 is released
    /**
     * Activist input: Σ dividends per share paid since SimStart, accumulated by the publisher each released round
     * (prior value + that round's QuarterRecord.dividendsUsd ÷ sharesOutstanding at round end); 0 at SimStart.
     */
    cumulativeDpsUsdPerShare: UsdPerShare,
    /** (price + cumulativeDpsUsdPerShare) ÷ SimStart price − 1, simple (not compounded); null before R1 is released. */
    tsrSinceSimStartRate: Rate.nullable(),
  })),
  /**
   * 08.2 E10 (M9): the round-end COPY of MarketState.outlook.paused, for display (news, results, the P4 brief) and policy text.
   * The buyback posting never reads it: step 12 reads the in-round MarketState.outlook. Absent = false.
   */
  outlookPaused: z.boolean().optional(),
  /**
   * 08.2 E10 (M11): the released round's quarter-ends — unemployment, ΔU over its recent low (consensus included) and
   * the pause state set there (it zeroes the twins' and cautious AI banks' buyback of the next quarter's month 1). Written by
   * publishMarket from MarketState.outlook; the results, news and debrief read it. Absent = no quarter-end yet.
   */
  outlookHistory: z.array(z.object({ quarterEndMonth: Month, unemploymentRate: Rate, deltaUnemploymentRate: Rate, paused: z.boolean() })).optional(),
});
export type PublishedMarket = z.infer<typeof PublishedMarket>;

export const SeatState = z.object({
  seatId: SeatId,
  kind: SeatKind,
  personaId: PersonaId.optional(),
  /** Neutral bank name for every seat (never reveals AI or persona; ADR-0019 §4). */
  displayName: z.string(),
  bank: BankState,
});
export type SeatState = z.infer<typeof SeatState>;

/** Shared market: env, exogenous reference rates, share state, seats, RNG. */
export const MarketState = z.object({
  marketId: MarketId,
  config: EngineConfig,
  scenarioId: ScenarioId,
  month: Month,
  round: RoundIndex,
  phase: z.enum(["preRound", "inRound", "awaitingEventResponse", "roundComplete", "shadow", "final"]),
  env: EnvSnapshot,
  /** ProductId → market REFERENCE rate = the deposit-beta lag state (no lever offset; 01.3). Loans: exogenous (I27). */
  referenceRates: z.record(z.string(), Rate),
  /** Snapshot published at the last round end (policy/preview inputs). */
  published: PublishedMarket,
  shares: z.record(z.string(), z.record(z.string(), Rate)), // ProductId → SeatId → share
  seats: z.array(SeatState).min(1).max(8),
  events: z.array(EventInstance),
  scheduledShocks: z.array(z.object({ month: Month, seatId: SeatId.optional(), shock: Shock, sourceRef: z.string() })),
  /**
   * 08.2 E10 (M9): the in-round SOURCE of the outlook pause, once per market. Written at step 15 of a quarter-end month; a
   * round-end quarter-end (and SimStart) is evaluated at the next round's open, once that round's consensusPath is published,
   * before month 1's step 12. Step 12 reads `paused` for the month-1 buyback of the next quarter.
   * Absent = no quarter-end yet (calm).
   */
  outlook: z.object({ unemploymentQuarterEnds: z.array(Rate), calmQuarters: z.number().int().nonnegative(), paused: z.boolean() }).optional(),
});
export type MarketState = z.infer<typeof MarketState>;

// ───────────────────────────────────────────────────────────── decisions

/** Explicit securities trade (goldens, events, analyst level). Executive level uses the securities-make-up policy only. */
export const SecuritiesTrade = z.object({
  monthOffset: z.number().int().nonnegative(),
  bookId: z.enum(["ust_afs", "mbs_afs", "mbs_htm"]),
  side: z.enum(["buy", "sell"]),
  amountUsd: Usd, // fair value
  durationYears: z.number().positive().optional(),
  selector: z.enum(["proRata", "largestLoss", "largestGain", "all"]).optional(),
});

/**
 * Fully resolved fine decisions for one seat and round (Expander output; engine input).
 * Everything is a POLICY the engine evaluates month by month / quarter by quarter on prior
 * period-end state (I28) — never pre-computed dollar schedules. Field semantics: expander_personas.md §1b.
 * Funding plug order is an engine rule (I33, PLUG_BOOKS), not a decision.
 */
const FineDecisionsObject = z.object({
  loans: z.array(z.object({
    productId: ProductId,
    /** Marketing spend as an ANNUAL rate ($/yr); drives logit utility x = spend ÷ the status-quo spend (14.1). */
    marketingUsd: prov(Usd),
    /** Present only for Runoff (notch −3): originations = rate × trend originations (ρ_ci 0.5, else 0). */
    runoffRenewalRate: prov(Rate).optional(),
    spreadOverReferenceBp: prov(Bp),
    /**
     * ADR-0048 (R2.1): RM hiring (ci, cre; resi uses loHiringRate) as the net team change vs the trend team, a share of the current headcount (03.5);
     * the book's rate index and the spread over it (a loan's rate is index + spread; spreadOverReferenceBp is the old single-reference form, retired by R2.1).
     */
    rmHiringRate: prov(Rate).optional(),
    loHiringRate: prov(Rate).optional(),
    indexId: z.enum(["sofr", "treasury5y", "treasury10y", "prime"]).optional(),
    spreadOverIndexBp: prov(Bp).optional(),
    underwritingBox: prov(Box),
    minCreditScore: prov(z.number().int()).optional(), // v1
    collectionsStyle: prov(z.enum(["highService", "moderate", "aggressive"])).optional(), // v1
  })),
  deposits: z.array(z.object({
    productId: ProductId,
    /** Posted-rate offset vs content reference rate (DDA ignored; floor 0.05%). */
    rateSpreadVsReferenceBp: prov(Bp),
    /** ADR-0048 (R2.2): the rate on new money (front book) and on the existing base (back book) for non-maturity products; CDs carry the front rate only. rateSpreadVsReferenceBp is the old single rate (retired by R2.2). */
    rateSpreadFrontBp: prov(Bp).optional(),
    rateSpreadBackBp: prov(Bp).optional(),
    marketingUsd: prov(Usd), // annual rate ($/yr)
    ecrSpreadBp: prov(Bp).optional(), // commercial only
    monthlyFeeUsd: prov(Usd).optional(), // v1
    minBalanceUsd: prov(Usd).optional(), // v1
  })),
  /** ADR-0048 (R2.3): the liquidity-coverage target (LCR-lite) the buffer is sized to; absent = no buffer rule (the old funding buffers apply). */
  liquidity: z.object({ targetLcrRate: prov(Rate) }).optional(),
  funding: z.object({
    /** Shortfall mix weights (sum to 1): ≤30d FHLB / term FHLB 1–3y / brokered 12m. FFP is never in the mix. */
    shortfallMix: prov(z.object({ fhlbShortRate: Rate, fhlbTermRate: Rate, brokeredRate: Rate })),
    bufferAboveCashFloorUsd: prov(Usd),
    /** Emitted by the Expander (Fortress, EV-01 A) but display-only in the pilot: no mechanical effect (M7j); real in v1. */
    dwPrepledge: prov(z.boolean()),
    /** ADR-0048 (R2.4): months of the plan's need pre-funded in month 1 (Fortress), and what a surplus does, in order. */
    prefundMonths: prov(z.number().int().nonnegative()).optional(),
    surplusOrder: prov(z.array(z.enum(["repayOvernightFhlb", "repayBrokeredAtMaturity", "holdCash"]))).optional(),
  }),
  securities: z.object({
    targetShareOfAssetsRate: prov(Rate),
    /** ADR-0048 (R2.3): the make-up of new purchases: UST/MBS weights (UST at least the floor), the Treasury tenor sleeve, and the held-to-maturity share of the MBS part. The size is the residual. */
    mix: prov(z.object({
      typeWeights: z.object({ ustRate: Rate, mbsRate: Rate }), durationSleeve: z.enum(["short", "neutral", "long"]), htmShareOfMbsRate: Rate, minUstShareRate: Rate,
    })).optional(),
    /** New-buy sleeve (weights sum to 1). Sells come from AFS only, pro rata by lot. */
    newBuys: prov(z.array(z.object({ bookId: z.enum(["ust_afs", "mbs_afs", "mbs_htm"]), durationYears: z.number().positive(), weightRate: Rate })).min(1)),
    trades: prov(z.array(SecuritiesTrade)).optional(),
  }),
  hedges: z.object({
    /**
     * Target net swap notional (+ pay-fixed / − receive-fixed); Δ vs outstanding executed at m1. ADR-0048 (R2.3): it records the engine's solve of
     * targetNiiSensitivityRate and stays the Fine fixture path for goldens (GUESS).
     */
    targetPayFixedNotionalUsd: prov(Usd),
    /** ADR-0048 (R2.3): the rate position: the target change in a year's NII for +100bp as a share of NII; absent = natural (no overlay). The engine sizes the swaps. */
    targetNiiSensitivityRate: prov(Rate).optional(),
    tenorYears: prov(z.number().int().positive()),
  }),
  capital: z.object({
    /**
     * 08.2 E1: DPS_q = payout·max(0, EPS4_{q−1})/4; sticky ⇒ DPS_q ≥ the last DPS declared under the SAME payout policy
     * (BankState.dpsReferencePolicy; a policy change resets it) while CET1_{q−1} ≥ stickyMinCet1Rate. holdDps ("hold", M7k):
     * DPS_q = the last declared DPS, then the CCB, MOU and covenant limits. ADR-0048 (R2.1): `dpsUsdPerShare` is the declared amount per share
     * (a step from the last level; the payout fields retire) and `respectCcbCap` false = the explicit buffer-breach option.
     */
    dividend: prov(z.object({
      payoutRate: Rate, sticky: z.boolean(), stickyMinCet1Rate: Rate.optional(), holdDps: z.boolean().optional(),
      dpsUsdPerShare: UsdPerShare.optional(), respectCcbCap: z.boolean().optional(),
    })),
    /**
     * BB_q = min(cap, max(0, CET1_{q−1} − target·RWA_{q−1})); `fixed` is for goldens/fixtures only. pauseOnOutlook (M9, 08.2 E10):
     * the buyback is 0 while MarketState.outlook.paused (the in-round engine state; PublishedMarket.outlookPaused is only its
     * round-end copy); the Expander sets it from the `capital.buyback.pauseOnOutlook` decision (true = pause; false = the explicit override, the CRO memo K12
     * warns). `breachBuffer` true = the explicit buffer-breach option (08.2). Absent = false.
     */
    buyback: prov(z.discriminatedUnion("mode", [
      z.object({ mode: z.literal("off") }),
      z.object({ mode: z.literal("cet1Target"), cet1TargetRate: Rate, capUsdPerQuarter: Usd, pauseOnOutlook: z.boolean().optional(), breachBuffer: z.boolean().optional() }),
      z.object({ mode: z.literal("fixed"), usdPerQuarter: Usd, pauseOnOutlook: z.boolean().optional(), breachBuffer: z.boolean().optional() }),
    ])),
    /** Common issuance at m1 at (1 − discount) × prior month-end engine price. */
    issuanceUsd: prov(Usd),
  }),
  operations: z.object({
    /**
     * The round's NEW expense programme: its achieved run-rate change c̃ = controllableOpexChangeRate[level] × ρ^k (07.3 E2a, M10;
     * k = cut programs already in FranchiseState.opexPrograms). The opex model applies the 50%/100% phase-in and compounds it with
     * earlier programs (the opex model knows the month).
     */
    controllableOpexChangeRate: prov(Rate),
    /** Restructuring charge = restructuringChargeMultByLevel × annual savings (savings = −change × expander.controllableOpexBaseUsd × opexBalanceScale; cuts only); posted by the opex model in the program's first month. */
    oneTimeChargeUsd: prov(Usd),
    fteDelta: prov(z.number().int()),
    serviceIndexDelta: prov(z.number()),
    techInvestUsdByTheme: prov(z.partialRecord(TechTheme, Usd)),
    branchesDelta: prov(z.number().int()),
    compChangeRate: prov(Rate),
    trainingUsd: prov(Usd),
    feeScheduleMult: prov(z.number().positive()),
    atmCountTarget: prov(z.number().int().nonnegative()).optional(), // v1
    serviceLevelByArea: prov(z.record(z.string(), Rate)).optional(), // v1
  }),
  /** Expander diagnostics surfaced in preview (e.g. growth target unattainable under the marketing clamp). */
  flags: z.array(z.object({ kind: z.literal("targetUnattainable"), decisionId: DecisionId, achievableGrowthRate: Rate })),
});
// An interface (not an alias) so declaration emit refers to `FineDecisions` by name; the route table's type is otherwise too long to serialize.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface FineDecisions extends z.infer<typeof FineDecisionsObject> {}
/** Typed by its inferred shape (like `Decisions` and `Predicate`) so the route table's declaration stays small enough to emit. */
export const FineDecisions: z.ZodType<FineDecisions> = FineDecisionsObject;

export const EventResponse = z.object({
  eventInstanceId: EventInstanceId,
  choiceId: z.string(),
  rationale: Rationale,
  source: Provenance.shape.source,
});
export type EventResponse = z.infer<typeof EventResponse>;

/** Deterministic CRO memo (solo mode) from limit breaches and CAMELS flags; hash must be acknowledged. */
export const CroMemo = z.object({
  memoHash: z.string(),
  items: z.array(z.object({
    kind: z.enum(["riskAppetiteBreach", "camelsFlag", "pcaRisk", "concentration", "liquidity"]),
    /** ADR-0049: the decisions behind the item (its drivers), so the web needs no table of its own; absent in memos stored before. */
    decisionIds: z.array(DecisionId).optional(),
    kpi: KpiId.optional(),
    projected: z.number().optional(),
    limit: z.number().optional(),
    severity: z.enum(["info", "warn", "objection"]),
    text: z.string(),
  })),
});
export type CroMemo = z.infer<typeof CroMemo>;

/**
 * How a submission came to be effective (the api's `decision_submission.source`): 'team' the signed submit, 'solo' the solo
 * memo acknowledgement, the close sources 'deadline_attested' | 'default_carry_forward' | 'facilitator_rescue', and the AI
 * seats' 'persona' | 'autopilot'.
 */
export const SubmissionSource = z.enum(["team", "deadline_attested", "default_carry_forward", "facilitator_rescue", "persona", "autopilot", "solo"]);
export type SubmissionSource = z.infer<typeof SubmissionSource>;

/** A seat's round submission: the decision set (what the player sees) + fully resolved fine decisions + governance. */
export const DecisionSet = z.object({
  seatId: SeatId,
  round: RoundIndex,
  /** ADR-0048: the 32-decision set; a stored submission carries its `schemaVersion` (v2 code opens no v1 data). */
  schemaVersion: z.literal(2),
  decisions: Decisions,
  fine: FineDecisions,
  eventResponses: z.array(EventResponse),
  rationales: z.array(Rationale),
  forecasts: z.array(KPIForecast), // the round's twin forecast (OD5-1); empty if none was committed
  /** ≤140-char "our thesis this year", required only when no decision family changed (passive-team evidence). */
  thesis: z.string().max(140).nullable(),
  /** Set by the api from the effective submission's source when a round locks; absent on a decision built outside it (evidence 4.2 reads it). */
  submissionSource: SubmissionSource.optional(),
  signoff: z.object({
    ceo: UserId.optional(),
    croAttestation: z.object({ by: UserId.optional(), objections: z.array(z.string()) }).optional(),
    /** CRO objections are advisory; overriding one (or a 'decline' stance) needs this note (evidence; ADR-0019 §3). */
    ceoOverrideNote: z.string().min(20).max(600).optional(),
    croMemoAckHash: z.string().optional(), // solo mode
  }),
});
export type DecisionSet = z.infer<typeof DecisionSet>;

// ───────────────────────────────────────────────────────────── postings, attribution, facts

export const Driver = z.enum([
  "volume", "rateIndex", "spread", "betaLag", "mix", // NII bridge
  "origination", "paydown", "prepay", "maturity", "default", "chargeOff", "recovery", "provision",
  "fee", "opex", "tax", "mtm", "realizedGain", "swapCarry", "dividend", "buyback", "issuance",
  "fundingPlug", "depositFlow", "eventOneOff", "reclass",
]);
export type Driver = z.infer<typeof Driver>;
export const Cause = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("decision"), decisionId: DecisionId }),
  z.object({ kind: z.literal("event"), eventInstanceId: EventInstanceId, choiceId: z.string().optional() }),
  z.object({ kind: z.literal("env") }),
  z.object({ kind: z.literal("market"), note: z.string().optional() }), // competitor-driven share moves
  z.object({ kind: z.literal("contractual") }),
  z.object({ kind: z.literal("supervisory") }),
  z.object({ kind: z.literal("autopilot") }),
]);
export type Cause = z.infer<typeof Cause>;

/**
 * Double-entry posting, amount > 0, rounded once here. Σdebits = Σcredits per month (I1).
 * Performance (ADR-0022): postings are AGGREGATED per (seat, month, account pair, book, driver, cause); vintageId is
 * set only where an identity needs it (e.g. charge-offs). Attribution needs nothing finer.
 */
export const Posting = z.object({
  id: PostingId,
  month: Month,
  seatId: SeatId,
  debit: AccountId,
  credit: AccountId,
  amountUsd: Usd.refine((v) => v > 0),
  driver: Driver,
  cause: Cause,
  bookId: BookId.optional(),
  vintageId: VintageId.optional(),
});
export type Posting = z.infer<typeof Posting>;

export const RollForward = z.object({
  subject: z.string(), // book id, "acl", "cet1", "aoci"
  beginUsd: Usd,
  flowsUsd: z.partialRecord(Driver, Usd),
  endUsd: Usd,
});
/** Per seat per round: NII bridge, roll-forwards, attribution by cause, vs-autopilot deltas. */
export const Attribution = z.object({
  niiBridge: z.object({ priorUsd: Usd, volumeUsd: Usd, rateIndexUsd: Usd, spreadUsd: Usd, betaLagUsd: Usd, mixUsd: Usd, currentUsd: Usd }),
  rollForwards: z.array(RollForward),
  byCause: z.array(z.object({
    cause: Cause, niUsd: Usd, cet1Usd: Usd,
    /**
     * The cause's effect on each KPI it moves, in that KPI's own KPI_DEFS unit (nim +0.0006 = +6bp; rotce, cet1* decimal rates): the KPI's actual
     * round-end value minus its value in the run with only this cause removed (the same removal that yields niUsd and cet1Usd), so the
     * causes of a KPI sum to its round move up to interaction. A KPI the cause leaves unchanged is absent. Read by GxWhy (screens §1.5).
     */
    kpiDeltas: KpiSnapshot,
    /**
     * ADR-0053: what `niUsd` is made of: the cause's postings by statement line (the effect on pre-tax income, "Provision", "Net charge-offs", "Interest income: …") and the tax on them, so a
     * cause's "includes $X + $Y" names every part and the parts sum to `niUsd` (rounding in `taxUsd`). Absent in results stored before.
     */
    lines: z.array(z.object({ lineId: z.string(), usd: Usd })).optional(), taxUsd: Usd.optional(),
  })),
  vsAutopilot: KpiSnapshot, // actual − counterfactual autopilot
  /**
   * What the market did to the status-quo twin this year, in the units the player reads (F9.1 #24, additive): the realised policy-rate move, how far the twin's
   * average yield on earning assets and its average cost of interest-bearing liabilities moved from the prior year-end (the repricing that sets NIM), and its charge-off rate.
   */
  marketDrivers: z.object({ policyRateChangeBp: z.number(), /** ADR-0052: how much of `policyRateChangeBp` the cards' market-wide rate shocks made (the rest is the scenario's own path). */ policyRateCardBp: z.number().optional(), assetYieldChangeBp: z.number(), fundingCostChangeBp: z.number(), ncoRateChangeBp: z.number(),
    /**
     * ADR-0053: the twin's NIM move split into what each part contributed to the margin, in bp of NIM, summing to `changeBp` (the market row of the NIM attribution): the repricing of earning assets
     * (`assetYieldBp`), the repricing of interest-bearing funding at its prior weight in the balance sheet (`fundingCostBp`, negative when funding got dearer), the change in how much of
     * the balance sheet is interest-bearing funding (`mixBp`) and the rest (`otherBp`: swaps, timing). Credit losses are not a margin line: `ncoRateChangeBp` is the NCO row's driver.
     */
    nim: z.object({ changeBp: z.number(), assetYieldBp: z.number(), fundingCostBp: z.number(), mixBp: z.number(), otherBp: z.number() }).optional() }).optional(),
  /**
   * Where the year missed what the preview showed for the plan as signed (F9.1 #22, additive), per KPI in its own unit and on the one basis every screen shows (a rate is the
   * year-end month annualised, a stock the year-end value; F11.1 A): `expected` = the plan on the published consensus path with no card, `surprise` = the same plan on the
   * path the year realised, less that, `cards` = the played year less the realised-path plan (the cards, and the human rivals' plans the preview holds at standing);
   * expected + surprise + cards = actual. `market` (the F9.1 name) carries the same number as `surprise` for results stored before it: "the market" now means only what the market
   * did to the status-quo twin (`DecisionAttribution`'s market row), so a reader takes `surprise ?? market`.
   */
  expectation: z.array(z.object({ kpi: KpiId, expected: z.number(), surprise: z.number().optional(), market: z.number(), /** ADR-0068 (ruling 11): what the rivals' plans did to this reading; with it, expected + rivals + surprise + cards = actual. Absent = `cards` still carries it (today it mixes rivals and cards; F17.5a separates them). */ rivals: z.number().optional(), cards: z.number(), /** `cards` is always cardsArrived + cardsAnswer, never including `residual`. ADR-0068 rev (F19.0): the card's arrival at its usual outcome, and the team's answer against that outcome; both on the signed plan and the realised path; cardsArrived + cardsAnswer = cards. Absent = only `cards` is known. */ cardsArrived: z.number().optional(), cardsAnswer: z.number().optional(), /** ADR-0068 rev (F20.0): what the four named legs do not explain: the year as it played less the engine's re-run with every card at its answer (zero when the re-run reproduces the year). expected + rivals + surprise + cardsArrived + cardsAnswer + residual = actual; `cards` is always cardsArrived + cardsAnswer; `residual` is never inside `cards`; a reader summing to `actual` without `residual` is short by it. Absent = none computed. */ residual: z.number().optional(), actual: z.number(), /** ADR-0053: the question this row answers. */ basis: z.string().optional(), /** ADR-0074: the year's average over the forecast window (13.1 §2; a decimal rate, as `expected`/`actual`), expected on the signed plan and as played, for nim and ncoRate; absent = not computed. */ expectedAvg: z.number().optional(), actualAvg: z.number().optional() })).optional(),
  /**
   * ADR-0059: the same three legs for the terminal value the preview showed ("value at the end of year N", $/share, `terminalPriceUsdPerShare`): expected = the preview's run on the consensus path and its two
   * look-through years, surprise = the same plan on the path the year realised, cards = what the cards did, actual = the played year's look-through; expected + surprise + cards = actual. Absent in results stored before.
   */
  expectationTerminal: z.object({
    expected: UsdPerShare, surprise: UsdPerShare, /** ADR-0068: the rivals' leg, as in `expectation[].rivals`: expected + rivals + surprise + cards = actual; absent = inside `cards`. */ rivals: UsdPerShare.optional(), cards: UsdPerShare, /** Always cardsArrived + cardsAnswer; `residualUsdPerShare` is never inside it. ADR-0068 rev (F19.0): the card split, as in `expectation[].cardsArrived/.cardsAnswer` (cardsArrived + cardsAnswer = cards), per share. */ cardsArrivedUsdPerShare: UsdPerShare.optional(), cardsAnswerUsdPerShare: UsdPerShare.optional(), /** ADR-0068 rev (F20.0): the residual leg per share, as in `expectation[].residual`. */ residualUsdPerShare: UsdPerShare.optional(), actual: UsdPerShare, basis: z.string(),
    /** ADR-0068 rev (F19.0): what the year's surprise was, realised minus consensus at year-end, so Results can say "rates came in 100bp above the consensus, 75bp of it the card's". `cardPolicyRateBp` is the card's share of `policyRateBp`. */
    surpriseDrivers: z.object({ policyRateBp: z.number(), tenYearBp: z.number(), unemploymentPp: z.number(), cardPolicyRateBp: z.number() }).optional(),
    /** ADR-0080: each answered card's own dollar effect on the year's share price (`priceUsdPerShare`) and on the terminal value (`terminalUsdPerShare`), the card rows of the leg `cards` sums; absent = not computed. */
    perCard: z.array(z.object({ eventInstanceId: EventInstanceId, priceUsdPerShare: UsdPerShare, terminalUsdPerShare: UsdPerShare })).optional(),
    /** ADR-0064 (R1): the status-quo twin's terminal value per share on the same three legs (consensus path; the realised path less that; the cards' defaults less that), so the year bridge can state a "vs twin" miss; expected + surprise + cards = actual. */
    twin: z.object({ expected: UsdPerShare, surprise: UsdPerShare, rivals: UsdPerShare.optional(), /** Always cardsArrived + cardsAnswer; never includes the residual. */ cards: UsdPerShare, cardsArrivedUsdPerShare: UsdPerShare.optional(), cardsAnswerUsdPerShare: UsdPerShare.optional(), residualUsdPerShare: UsdPerShare.optional(), actual: UsdPerShare }).optional(),
  }).optional(),
});
export type Attribution = z.infer<typeof Attribution>;

/**
 * Engine fact: raw number in DOMAIN units (rate = decimal fraction). The ai packet builder converts it
 * to a presentation PacketFact (cp4) — the only place ×100 / display formatting happens.
 */
export const Fact = z.object({
  id: FactId,
  round: RoundIndex,
  month: Month.optional(),
  seatId: SeatId.optional(),
  /** Assigned by the engine (it knows what is published vs private vs counterfactual). */
  visibility: Visibility,
  kpi: KpiId.optional(), // set when subject is a KPI (drives label/polarity/aliases via KPI_DEFS)
  /** "outlook" (owner M11): the market outlook turned negative or calm at a quarter-end (08.2 E10; subject "outlookPaused", value 1/0, unit count). */
  kind: z.enum(["kpi", "delta", "rank", "event", "breach", "supervisory", "attribution", "forecastError", "valuation", "outlook"]),
  subject: z.string(), // KpiId, EventId, book…
  value: z.number(),
  unit: z.enum(["usd", "usdPerShare", "rate", "bp", "index", "rating", "multiple", "count"]),
  comparedTo: z.object({ label: z.enum(["prior", "autopilot", "peerMedian", "forecast", "limit", "target"]), value: z.number() }).optional(),
  evidenceTags: z.array(z.string()).optional(),
  refs: z.array(z.string()).optional(), // posting ids / metric ids
});
export type Fact = z.infer<typeof Fact>;

// ───────────────────────────────────────────────────────────── scoring, invariants, results

/**
 * The premium rows of 10.2 E2 and the kind of each: standing premia sit inside the fair multiple and move through the market's partial adjustment; event premia are public, dated, and
 * price at once (10.1 E11). `eve` is the rate-risk row. No row reads a CAMELS rating or an MOU (R3).
 */
export const PREMIUM_KINDS = { capital: "standing", creConcentration: "standing", wholesale: "standing", uninsured: "standing", eve: "standing", dividend: "event", enforcement: "event", event: "event" } as const;

/** Price decomposition (10.1). */
export const ValuationBreakdown = z.object({
  tbvRequiredUsd: Usd, excessUsd: Usd, shortfallUsd: Usd, marksUsd: Usd,
  /** NI_core (10.1 E5, OR-30.22 (1): retained capital at the rate it earns at the margin: the funding rate while wholesale funding covers it, else the new-purchase core yield); `rotceCoreRate` = ROTCE_f = NI_core ÷ TBV_req; `gRate` = g (E7); `coeRate` = standing cost of equity + event premia. */
  niCoreUsd: Usd, rotceCoreRate: Rate, gRate: Rate, coeRate: Rate,
  premiaBp: z.object({ capital: Bp, creConcentration: Bp, wholesale: Bp, uninsured: Bp, eve: Bp, dividend: Bp.default(0 as Bp), enforcement: Bp.default(0 as Bp), event: Bp }),
  /** ADR-0052: the capital record K behind the capital premium (10.2 E1), so the bridge can say what the surcharge is for. Absent in results stored before. */
  capitalRecordRate: Rate.optional(),
  /** μ_m: the market's multiple of required capital in the price (10.1 E10; ADR-0054). */
  ptbvRequired: z.number(),
  /** ADR-0054, absent in results stored before: ROTCE_n (E6); μ*₀ the fair multiple at the standing cost of equity and μ*₁ with the event premia (E8); Xval (E9: excess, less the shortfall as dilution); the floor's top-up (E12). */
  rotceNormRate: Rate.optional(), ptbvFair: z.number().optional(), ptbvFairWithEvents: z.number().optional(), xvalUsd: Usd.optional(), floorUsd: Usd.optional(),
  /** 10.3 E1: NormProv, the normalised provision inside NI_core (absent in results stored before); the terminal value's credit line reads its change. */
  normProvUsd: Usd.optional(),
  /** B: loans + deposits (gross balances) the growth of E7 reads; the balance history's newest value. */
  balancesUsd: Usd.optional(),
  priceUsdPerShare: UsdPerShare,
  /** True while the accepted bid's one covenant (DEAL_COVENANT) applies. The price is NEVER locked to the offer (OD4-1). */
  underDealCovenants: z.boolean(),
});
export type ValuationBreakdown = z.infer<typeof ValuationBreakdown>;

/** The eight named lines between the market price at the round end and the terminal value (10.3 E6), in the order they are applied. */
export const TERMINAL_LINES = ["marketLag", "premiumsReleased", "historyAveraging", "creditCarried", "franchiseCarried", "growth", "capital", "floor"] as const;
export type TerminalLine = (typeof TERMINAL_LINES)[number];

/**
 * Value Created bridge vs the autopilot twin (10.4): steps sum to valueCreatedRate within 0.0001 (0.01pp).
 * Each COE-premium step names the decisions that move its input (capital record premium ← capital.dividend/buyback; CRE ← loans.cre.*;
 * wholesale ← treasury.funding and the loan growth decisions; uninsured ← the deposit rate decisions; EVE ← treasury.securitiesMix/ratePosition).
 * "interaction" is the unexplained residual.
 */
export const ValueBridgeStep = z.object({
  /** ADR-0054: `growth` (g_LT) and `terminalLine` (one 10.3 E6 line, named by `line`) are new; `lookThroughNormalization` and `shadowCure` are @deprecated, no longer written. */
  step: z.enum(["coreEarnings", "requiredCapitalGrowth", "excessShortfallAndDistributions", "distributions", "sharesRetired", "capital", "marks", "coePremium", "lookThroughNormalization", "shadowCure", "growth", "terminalLine", "interaction"]),
  premium: z.enum(["capital", "creConcentration", "wholesale", "uninsured", "eve", "dividend", "enforcement", "event"]).optional(), // coePremium only
  line: z.enum(TERMINAL_LINES).optional(), // terminalLine only
  rate: Rate, // contribution to valueCreatedRate (0.01 = 1pp)
  usdPerShare: UsdPerShare,
  decisionIds: z.array(DecisionId),
  /** ADR-0052, coePremium steps only: what the premium is for, in plain words, with the sign named (a surcharge costs the bank value against its twin, a release gives it back). */
  cause: z.string().optional(),
  /** ADR-0069 (P5-D8), coePremium steps only: the premium in basis points on the seat's bank and on its twin, so the web does not parse the figure out of `cause`. Absent = not given. */
  premiumBp: z.object({ you: Bp, twin: Bp }).optional(),
});
export type ValueBridgeStep = z.infer<typeof ValueBridgeStep>;

/**
 * Deal call (OD4-1; ADR-0025; 10.5): shown to acceptors AND rejectors of an EV-05 offer; never part of the
 * headline or rank. Per share, on the look-through basis of the headline, at the scoring date:
 *   W_offer = D_pre + Offer × (1 + COE)^τ  (D_pre = the team's own distributions up to and incl. the bid month, compounded at COE);
 *   DC$ = W_offer − W_team;  dealCallRate = DC$ / W_auto = vcOfferRate − vcTeamRate  (I36; pre-bid distributions cancel).
 * Display (10.4): participants see DC in the SAME SimStart dollars as the headline,
 *   dealCallDisplayUsdPerShare = DC$ ÷ (1 + COE₀)^τ = dealCallRate × Scorecard.valueCreatedBaseUsdPerShare;
 *   dealCallUsdPerShare (scoring-date dollars) is the I36 identity value and may appear only as "worth ${W_offer} at the end
 *   of the look-through" explanation, never as the headline deal-call dollars.
 * Sign: DC > 0 ⇒ the offer was worth more than the bank as run. verdict: |dealCallRate| ≤ 0.001 → close; otherwise
 * accepted & DC > 0 → acceptSaved, accepted & DC < 0 → acceptCost, rejected & DC > 0 → rejectCost, rejected & DC < 0 → rejectSaved.
 * The sign is shown and discussed, never scored by itself (rubric 2.4 scores the stated standalone estimate).
 */
export const DealCall = z.object({
  decision: z.enum(["accepted", "rejected", "defaulted"]),
  offeredRound: RoundIndex,
  offerUsdPerShare: UsdPerShare,
  offerWealthUsdPerShare: UsdPerShare, // W_offer
  teamWealthUsdPerShare: UsdPerShare, // W_team (= the headline's terminal wealth)
  autopilotWealthUsdPerShare: UsdPerShare, // W_auto (the actual twin, not the projection)
  preBidDistributionsUsdPerShare: UsdPerShare, // D_pre
  vcOfferRate: Rate,
  vcTeamRate: Rate, // = Scorecard.valueCreatedRate
  dealCallUsdPerShare: UsdPerShare, // DC$ at the scoring date (I36 identity)
  dealCallDisplayUsdPerShare: UsdPerShare, // DC$ ÷ (1 + COE₀)^τ: SimStart dollars, the unit of valueCreatedUsdPerShare (shown)
  dealCallRate: Rate, // DC_pp / 100
  verdict: z.enum(["acceptSaved", "acceptCost", "rejectSaved", "rejectCost", "close"]),
  standaloneEstimateUsdPerShare: UsdPerShare.nullable(),
  /** ADR-0041: the choice taken (accept / negotiate / reject …; `decision` stays accepted | rejected) and the price first offered, before any negotiation. Absent in results stored before. */
  choiceId: z.string().optional(),
  originalOfferUsdPerShare: UsdPerShare.optional(),
});
export type DealCall = z.infer<typeof DealCall>;

export const Scorecard = z.object({
  seatId: SeatId,
  round: RoundIndex,
  valueCreatedRate: Rate, // OFFICIAL headline: W_team ÷ W_auto − 1 = (1 + lookThroughTsrRate) ÷ (1 + autopilotTsrRate) − 1 (10.4; 0.01 = 1pp)
  /**
   * Display equivalent of the headline (OD5-2; ADR-0019 §6; 10.4): the look-through wealth gap per SimStart
   * share, in SimStart ("today's") dollars = (W_team − W_auto) ÷ (1 + COE₀)^τ = valueCreatedRate × valueCreatedBaseUsdPerShare.
   * W = terminal look-through wealth per ORIGINAL (SimStart) share (never the current share count); COE₀ = SimStart COE
   * (10.79%); τ = years from SimStart to this scorecard's scoring date. Shown FIRST, with the pp figure beside it; never ranks.
   */
  valueCreatedUsdPerShare: UsdPerShare,
  /**
   * Conversion base B = W_auto ÷ (1 + COE₀)^τ: the status-quo twin's look-through wealth per SimStart share in SimStart dollars,
   * computed per seat and per scorecard (round) from the seat's own twin; scenario-dependent. NOT the SimStart price ($62):
   * flat golden 1pp = $0.660 (R1) / $0.670 (R2) / $0.679 (R3) / $0.686 = $35.2M (final).
   */
  valueCreatedBaseUsdPerShare: UsdPerShare,
  /** Optional $M display (OD5-2; tooltips/debrief): valueCreatedUsdPerShare × SimStart shares outstanding (51.25M). Never ranks. */
  valueCreatedUsd: Usd,
  /**
   * Reported-only VC (no look-through), shown once on the Scorecard; look-through give-back = this − valueCreatedRate.
   * = SeatRoundResult.reportedWealthUsdPerShare ÷ .valueTwinRoundEnd.reportedWealthUsdPerShare − 1 (10.4).
   */
  reportedOnlyValueCreatedRate: Rate,
  /**
   * ADR-0042: why the look-through moved the score, the 10.4 bridge run from the round end to the horizon: each step moves its terminal input
   * from the round-end valuations (the seat's, `valueTwinRoundEnd.valuation`) to the look-through ones, for the seat and its twin together, and
   * `rate` is the step's move in W_team ÷ W_auto; the steps sum to valueCreatedRate − reportedOnlyValueCreatedRate within 0.0001. Absent in results stored before.
   */
  lookThroughGiveBack: z.array(ValueBridgeStep).optional(),
  /**
   * ADR-0047: the score split in SimStart $/share, each vs the twin (the same discount as valueCreatedUsdPerShare): price + capital returned (dividends,
   * buyback effect) = reportedOnly; reportedOnly + lookThroughAdjustment = valueCreatedUsdPerShare within $0.005. roundEnd = this bank's round-end price and the
   * round's whole-dollar distributions. Absent in results stored before.
   */
  components: z.object({
    priceVsTwinUsdPerShare: UsdPerShare, capitalReturnedVsTwinUsdPerShare: UsdPerShare, dividendsVsTwinUsdPerShare: UsdPerShare, buybackEffectVsTwinUsdPerShare: UsdPerShare,
    reportedOnlyUsdPerShare: UsdPerShare, lookThroughAdjustmentUsdPerShare: UsdPerShare,
    roundEnd: z.object({ priceUsd: UsdPerShare, dividendsUsd: Usd, buybacksUsd: Usd }),
    /**
     * ADR-0053: what the status-quo twin paid out in the round, `paidUsd` its dividends and buybacks together, and `payoutBlockedBy` the rules that held a payout of its own, so "cash returned
     * vs twin" has its cause: the twin paid less because a rule held it (the regulator's status, the outlook pause, a capital minimum, the conservation buffer), or more because the seat's own
     * choices held the seat's. Absent when the twin is the seat's run or the result was stored before.
     */
    /**
     * ADR-0053: the year's price move of this bank and of its twin on the one basis of `priceVsTwinUsdPerShare` (SimStart $/share: the raw move × the score's scale), so "your price fell $X, your
     * twin's $Y" and "−$Z vs twin" read together: Z = (X − Y) + `startGapUsdPerShare` (where this bank stood against its twin before the year). Absent when the prior prices were not kept.
     */
    priceMoves: z.object({ youUsdPerShare: UsdPerShare, twinUsdPerShare: UsdPerShare, startGapUsdPerShare: UsdPerShare }).optional(),
    /**
     * ADR-0059: the share counts behind "cash returned vs twin" (it is cumulative since SimStart, not this year's): `buybackEffectVsTwinUsdPerShare` = price × (twinShares − youShares) ÷ twinShares,
     * so a twin that has retired more shares than this bank makes it negative. `simStartShares` is where both began. Absent in results stored before.
     */
    shares: z.object({ youShares: Shares, twinShares: Shares, simStartShares: Shares }).optional(),
    /** ADR-0069 (P5-D7): the month of the bid and what the year's payout paid before it and from it (whole dollars). Absent = no bid, or a result stored before. */
    bidMonth: z.object({ month: Month, paidBeforeUsd: Usd, paidFromUsd: Usd }).optional(),
    /**
     * ADR-0059: what one dollar of wealth per share at the horizon is worth in the score's SimStart dollars = valueCreatedBaseUsdPerShare ÷ the twin's look-through wealth, so a gap printed at the horizon
     * (terminal value you vs twin, or the bridge in horizon dollars) × this = the headline `valueCreatedUsdPerShare`, and rate × valueCreatedBaseUsdPerShare is the same figure. Absent in results stored before.
     */
    horizonToStartDollarRate: z.number().optional(),
    /** ADR-0096: the factor k that turns a year-end dollar per twin share into today's dollars per share held at the start. Absent in results stored before. */
    todayDollarFactor: z.number().optional(),
    twin: z.object({ dividendsUsd: Usd, buybacksUsd: Usd, paidUsd: Usd, payoutBlockedBy: z.array(z.object({ reason: z.string(), affects: z.enum(["dividend", "buyback", "both"]), text: z.string() })) }).optional(),
  }).optional(),
  lookThroughTsrRate: Rate,
  autopilotTsrRate: Rate,
  valuation: ValuationBreakdown,
  valueBridge: z.array(ValueBridgeStep),
  dealCall: DealCall.nullable(), // null unless this seat received an EV-05 offer
  camels: CamelsState,
  supervisoryStatus: SupervisoryStatus,
  pca: PcaStatus,
  ccb: z.object({ bufferRate: Rate, maxPayoutRate: Rate, eligibleRetainedIncomeUsd: Usd }),
  gateRankedLast: z.boolean(), // composite ≥ 3
  customerIndex: z.number(),
  employeeIndex: z.number(),
  rank: z.number().int().positive(), // headline rank (value vs twin, regulator gate); buildScorecard emits 1, resolveRound assigns it with scoring's rankSeats over all seats (10.6)
  /** Optional weighted blend (OD5-8b; facilitator option): null unless the cohort's ranking mode is weightedBlend. */
  blend: z.object({ score: z.number(), rank: z.number().int().positive() }).nullable(),
});
export type Scorecard = z.infer<typeof Scorecard>;

/**
 * Ranking (OD5-8b, ADR-0026 §8b). Default = value vs twin with the regulator gate (composite ≥ 3 ranks last). Optional
 * facilitator option weightedBlend (pinned at cohort create): each component is z-scored across the market's seats
 * (value = valueCreatedRate; customers = customerIndex; employees = employeeIndex; regulators = −camels composite), then
 * weighted (percent weights summing to 100; pilot 50/20/15/15); the regulator gate still ranks gated banks last.
 */
export const RankingMode = z.enum(["valueVsTwin", "weightedBlend"]);
export type RankingMode = z.infer<typeof RankingMode>;
export const BlendWeights = z.object({ value: z.number().int().min(0), customers: z.number().int().min(0), employees: z.number().int().min(0), regulators: z.number().int().min(0) })
  .refine((w) => w.value + w.customers + w.employees + w.regulators === 100, "blend weights must sum to 100");
export type BlendWeights = z.infer<typeof BlendWeights>;
export const Ranking = z.discriminatedUnion("mode", [
  z.object({ mode: z.literal("valueVsTwin") }),
  z.object({ mode: z.literal("weightedBlend"), weights: BlendWeights }),
]);
export type Ranking = z.infer<typeof Ranking>;

export const InvariantCheck = z.object({
  id: z.string().regex(/^I\d{1,2}$/),
  passed: z.boolean(),
  month: Month.optional(),
  seatId: SeatId.optional(),
  magnitude: z.number().optional(),
  detail: z.string().optional(),
});
export const InvariantReport = z.object({ ok: z.boolean(), checks: z.array(InvariantCheck) });
export type InvariantReport = z.infer<typeof InvariantReport>;

export const StatementSet = z.object({
  incomeStatement: z.object({
    interestIncomeUsd: z.partialRecord(BookId, Usd),
    interestExpenseUsd: z.partialRecord(BookId, Usd),
    swapNetUsd: Usd,
    feeIncomeUsd: z.record(z.string(), Usd),
    opexUsd: z.record(z.string(), Usd),
    provisionUsd: Usd,
    securitiesGainsUsd: Usd,
    pretaxUsd: Usd,
    taxUsd: Usd,
    netIncomeUsd: Usd,
  }),
  balanceSheet: z.object({
    booksUsd: z.partialRecord(BookId, Usd),
    staticItemsUsd: z.partialRecord(StaticItemId, Usd),
    aclUsd: Usd,
    equity: Equity,
    totalAssetsUsd: Usd,
  }),
});

// ───────────────────────────────────────────────────────────── transparency programme (ADR-0047; all consumers optional)

/**
 * ADR-0047: one product's period output (Bank › Books, context strips, the pack). Dollars are whole numbers; `yieldRate` = the period's interest ÷ average
 * balance, annualized. Only the groups that apply to the product's side are present (loans, deposits, funding, securities).
 */
export const ProductLine = z.object({
  productId: ProductId, bookId: BookId, label: z.string(), side: z.enum(["asset", "liability"]),
  balanceUsd: z.number(),
  fairValueUsd: z.number().optional(), unrealizedUsd: z.number().optional(), accounting: z.enum(["AFS", "HTM"]).optional(),
  rateType: z.enum(["fixed", "floating", "administered"]),
  couponRate: Rate, yieldRate: Rate, /** ADR-0068: the product's interest in the period; absent = no reading (no period elapsed). */ interestUsd: z.number().optional(), fixedShareRate: Rate,
  /** Balance by next reset or maturity (a non-maturity deposit by its behavioural assumption). */
  repricingUsd: z.object({ m0to3: z.number(), m3to12: z.number(), y1to3: z.number(), y3to5: z.number(), y5plus: z.number(), nonSensitive: z.number() }),
  durationYears: z.number().optional(),
  originationsUsd: z.number().optional(), runoffUsd: z.number().optional(), ncoUsd: z.number().optional(), aclUsd: z.number().optional(), nonaccrualUsd: z.number().optional(), boxNotch: z.number().int().optional(),
  betaRate: Rate.optional(), realizedBetaRate: Rate.optional(), uninsuredUsd: z.number().optional(), uninsuredShareRate: Rate.optional(), inRunScope: z.boolean().optional(), averageLifeYears: z.number().optional(), netFlowUsd: z.number().optional(),
  maturesUsd: z.object({ d0to30: z.number(), m1to12: z.number(), later: z.number() }).optional(), capacityUsd: z.number().optional(), pledgedUsd: z.number().optional(),
});
export type ProductLine = z.infer<typeof ProductLine>;

const AlmBuckets = ["m0to3", "m3to12", "y1to3", "y3to5", "y5plus", "nonSensitive"] as const;
const AlmBucketVector = z.array(z.number()).length(AlmBuckets.length); // in `buckets` order
const AlmShock = z.object({ deltaUsd: z.number(), rate: Rate });
/**
 * ADR-0047: the ALM view (05.5 E2's table, the extra NII/EVE shocks): repricing gap by bucket, NII sensitivity at ±100/±200 (rate = Δ12m NII ÷ NII),
 * EVE at ±200 (rate = ΔEVE ÷ equity), duration of equity and the deposit betas. Merges engine §H `AlmReport` and screens §5.2.
 */
export const AlmSnapshot = z.object({
  asOfMonth: Month,
  buckets: z.tuple([z.literal("m0to3"), z.literal("m3to12"), z.literal("y1to3"), z.literal("y3to5"), z.literal("y5plus"), z.literal("nonSensitive")]),
  gap: z.object({
    assetsUsd: AlmBucketVector, liabilitiesUsd: AlmBucketVector, swapsUsd: AlmBucketVector, gapUsd: AlmBucketVector, cumulativeGapUsd: AlmBucketVector, cumulativeGapToAssetsRate: AlmBucketVector,
  }),
  niiSensitivity: z.object({ minus200: AlmShock, minus100: AlmShock, plus100: AlmShock, plus200: AlmShock }),
  eve: z.object({ minus200: z.object({ deltaUsd: z.number(), rateOfEquity: Rate }), plus200: z.object({ deltaUsd: z.number(), rateOfEquity: Rate }) }),
  durationOfEquityYears: z.number(),
  /**
   * ADR-0061 (F14.1): every live swap: its direction, notional, fixed rate, maturity, mark (fair value), the year's carry at today's SOFR (positive = received) and the change in the worse-side
   * EVE (the `eve200` KPI, a share of equity) when it runs off. Absent on a snapshot stored before.
   */
  swaps: z.array(z.object({
    id: z.string(), direction: z.enum(["payFixed", "receiveFixed"]), notionalUsd: Usd, fixedRate: Rate, startMonth: Month, maturityMonth: Month, markUsd: Usd, carryUsdPerYear: z.number(), eveRunOffRate: Rate,
  })).optional(),
  depositBetas: z.array(z.object({ productId: ProductId, label: z.string(), balanceUsd: z.number(), postedRate: Rate, betaRate: Rate, /** ADR-0068: absent = no reading (the policy rate has moved under 25bp). */ realizedBetaRate: Rate.optional() })),
  blendedIbBetaRate: Rate,
  /**
   * ADR-0053: the policy-rate move since SimStart (bp) a `depositBetas[].realizedBetaRate` divides by. At 0 no rate has moved and nothing has been passed through: the realised beta reads 0 here
   * only because it is undefined, and `betaRate` (the modelled through-the-cycle beta) is the figure to quote.
   */
  policyMoveBp: z.number().optional(),
  position: z.enum(["assetSensitive", "liabilitySensitive", "neutral"]),
});
export type AlmSnapshot = z.infer<typeof AlmSnapshot>;

/** ADR-0047: the inputs of the KPI formulas (so "where does this number come from" can show them); a key is present when its KPI is shown. */
export const KpiInputKey = z.enum([
  "niiUsd", "avgEarningAssetsUsd", "avgAssetsUsd", "avgTceUsd", "netIncomeUsd", "opexUsd", "feeIncomeUsd", "cet1Usd", "markedCet1Usd", "rwaUsd", "tier1Usd", "trbcUsd", "leverageAssetsUsd",
  "hqlaUsd", "netOutflow30dUsd", "loansUsd", "depositsUsd", "uninsuredDepositsUsd", "wholesaleUsd", "ncoUsd", "avgLoansUsd", "aclUsd", "nplUsd", "creUsd", "constructionUsd", "aociAfsUsd", "htmMarkUsd",
  "sharesOutstanding", "tbvUsd", "epsUsdPerShare", "dpsUsdPerShare", "coeRate", "excessCapitalUsd",
]);
export const KpiInputs = z.partialRecord(KpiInputKey, z.number());
export type KpiInputs = z.infer<typeof KpiInputs>;

/** ADR-0047: the priced look-through years from a preview (10.3–10.4 on the preview's own full-market end state): wealth vs the status-quo twin's, on the consensus path. */
export const LookThroughEstimate = z.object({
  valueCreatedRate: Rate, valueCreatedUsdPerShare: UsdPerShare, reportedOnlyValueCreatedRate: Rate,
  /** valueCreatedRate − reportedOnlyValueCreatedRate (the identity Scorecard uses). */
  giveBackRate: Rate,
  terminalPriceUsdPerShare: UsdPerShare,
  basis: z.literal("consensus"),
  /** ADR-0065 (R1): the plan's score on the published low and high (±1 sigma) consensus band paths, each against the twin run on the same path (`baselines.twinOnBands`); the min and max by rate, so a screen says 'range on the published low and high paths'. Absent = no range. */
  low: z.object({ valueCreatedRate: Rate, valueCreatedUsdPerShare: UsdPerShare }).optional(),
  high: z.object({ valueCreatedRate: Rate, valueCreatedUsdPerShare: UsdPerShare }).optional(),
});
export type LookThroughEstimate = z.infer<typeof LookThroughEstimate>;

/**
 * ADR-0064: `cardAnswers` is the effect of the team's own card answers against the cards' default answers, measured on the no-change plan (the no-change plan with the team's answers minus the no-change plan with the defaults);
 * from F16.1 the `carried` row is the no-change plan with the defaults minus the twin, so market + carried + Σ decision + cardAnswers + interaction still sums to actual. Distinct from `Attribution.expectation[].cards`,
 * which is what the year's cards did against the realised-path plan.
 */
const AttributionKey = z.union([z.enum(["market", "carried", "interaction", "cardAnswers"]), z.object({ decision: z.string() })]);
/**
 * ADR-0047 (OR-9): where the year's KPI move came from, by single-decision twins. twin(prior) + market + carried + Σ decision + cardAnswers + interaction = actual, per KPI.
 * A decision key is the DecisionPath string ("loans.cre.underwriting"); labels come from the decision catalog.
 */
/** ADR-0068: one row's measures (the KPI deltas and the value created), defined once: `rows[]` adds a `key`, `carriedRows[]` a `path`. */
const AttributionMeasures = z.object({
  kpiDeltas: KpiSnapshot,
    valueCreatedRate: Rate.optional(), valueCreatedUsdPerShare: UsdPerShare.optional(), reportedOnlyValueCreatedRate: Rate.optional(),
    /**
     * ADR-0059: what the row's `valueCreatedUsdPerShare` is made of, in the same score dollars, so a capital decision's score carries its reason: the round-end price, the cash paid out compounded
     * (`distributionsUsdPerShare`) and the look-through lines (`terminalLines`, 10.3 E6: `capital` is the held-back or paid-out capital priced at the look-through, `franchiseCarried` the earnings in flight,
     * …). price + distributions + Σ terminalLines = valueCreatedUsdPerShare. Absent in results stored before.
     */
    valueParts: z.object({ priceUsdPerShare: UsdPerShare, distributionsUsdPerShare: UsdPerShare, terminalLines: z.partialRecord(z.enum(TERMINAL_LINES), UsdPerShare) }).optional(),
});
export type AttributionMeasures = z.infer<typeof AttributionMeasures>;
export const DecisionAttribution = z.object({
  headlineKpis: z.array(KpiId),
  /** ADR-0053: the question the rows answer ("your year against your twin's year, each on its year-end value"). */
  basis: z.string().optional(),
  rows: z.array(z.object({ key: AttributionKey }).extend(AttributionMeasures.shape)), // key first, as before
  /**
   * ADR-0068: the earlier rounds' decisions split out of the `carried` row, one row per decision path (the twin plan with that path at the decisions in force, less the twin), and what the
   * paths do together beyond their sum. Σ carriedRows + carriedInteraction = the `carried` row exactly; the `rows` identity is unchanged. Absent = not split.
   */
  carriedRows: z.array(AttributionMeasures.extend({ path: z.string() })).optional(),
  carriedInteraction: AttributionMeasures.optional(),
  /** ADR-0072: each `carriedRows` path split by the round the decision was made in; the legs sum to the path's row. Absent = not split. */
  carriedByRound: z.record(z.string(), z.array(AttributionMeasures.extend({
    round: z.number().int().nonnegative(),
    /** ADR-0072: present only on the pooled leg: the first round it covers (the leg's `round` is the last). */
    fromRound: RoundIndex.optional(),
    /** ADR-0072: the decision's leaf value in force for that leg; absent = unknown. */
    value: DecisionValue.optional(),
  }))).optional(),
  /** actual − (the plan with that one decision reverted to the no-change value). */
  revertOne: z.array(z.object({ decision: z.string(), kpiDeltas: KpiSnapshot })).optional(),
  /** ADR-0096: for each answered non-default card, the played year's KPI readings less the same year with that card withheld. Absent = not computed. */
  cardWithheld: z.array(z.object({ eventInstanceId: z.string(), kpiDeltas: KpiSnapshot })).optional(),
  /** Per statement line (book ids, "fee.<k>", "opex.<k>", "provision", …): this seat's and the twin's year dollars and the rows between them. */
  lineAttribution: z.array(z.object({ lineId: z.string(), youUsd: z.number(), twinUsd: z.number(), /** ADR-0053: `youUsd` − `twinUsd`, the gap the rows explain (they sum to it exactly): the line against the twin's year, never against last year. */ gapUsd: z.number().optional(), rows: z.array(z.object({ key: AttributionKey, deltaUsd: z.number() })) })).optional(),
});
export type DecisionAttribution = z.infer<typeof DecisionAttribution>;

/** ADR-0047: what each draft decision setting did, in plain labels (worker-only; not a route). Gated KPIs are masked by the web before it reads `kpis`. */
export const PreviewTrace = z.object({
  draftVersion: z.number().int().nonnegative(),
  decisions: z.array(z.object({
    decisionId: z.string(), label: z.string(), fromLabel: z.string(), toLabel: z.string(),
    /** The fine-decision diff vs the no-change plan. */
    settings: z.array(z.object({ label: z.string(), scope: z.array(ProductId), baseUsd: z.number().optional(), from: z.union([z.number(), z.string()]), to: z.union([z.number(), z.string()]), unit: z.enum(["bp", "rate", "usd", "notch", "text"]) })),
    /** Year sums, |Δ| ≥ $50k. */
    postings: z.array(z.object({ step: z.string(), lineId: z.string(), deltaUsd: z.number() })),
    /** Horizon-end balance Δ by product or book. */
    books: z.array(z.object({ id: z.string(), deltaUsd: z.number() })),
    /**
     * ADR-0053: the same horizon-end change summed over each balance-sheet line (the account the postings name: "Money market deposits"), so a posting line, which is the whole account over every
     * step, reads against its own total and not a single product's `books` row. The postings of a line over all steps sum to its row here (the books' identity).
     */
    bookLines: z.array(z.object({ lineId: z.string(), deltaUsd: z.number() })).optional(),
    lines: z.array(z.object({ lineId: z.string(), deltaUsd: z.number() })),
    /** The single-decision twin minus the no-change plan. */
    kpis: KpiSnapshot,
    /** ADR-0063: why the step moved the price as it did, in words, when the figures alone mislead (a dividend raise is worth about nothing: cash instead of price; a cut costs the market's signal). */
    reason: z.string().optional(),
    /** ADR-0063: the mechanism for a lower price when the plan grows less ("slower growth lowers the growth the market pays for"). */
    later: z.string().optional(),
    /** ADR-0075: one plain sentence per previewed KPI this decision moved (the single-decision run against the no-change plan), worded by the engine from its own figures; absent = no sentence for that KPI. */
    because: z.partialRecord(KpiId, z.string()).optional(),
    /**
     * ADR-0077: this decision's three-year value alone, the single-decision run's look-through value against the no-change plan (the headline's measure, `lookThrough.valueCreatedUsdPerShare`), and `laterUsdPerShare` its two look-through years' part:
     * `valueUsdPerShare` minus the year-end share price move (`kpis.price`). Rows plus the interaction sum to the plan's `lookThrough.valueCreatedUsdPerShare`. Absent while the price is gated.
     */
    valueUsdPerShare: z.number().optional(), laterUsdPerShare: z.number().optional(),
    /** ADR-0077 addendum (additive): the cash this decision's single-decision run pays out as buybacks over the window beyond the no-change plan's, in dollars, and the shares it retires, in millions (the no-change plan's share count less the run's); absent when it buys nothing back. */
    payoutUsd: z.number().optional(), sharesDeltaMillions: z.number().optional(),
  })),
  interaction: z.object({ lines: z.array(z.object({ lineId: z.string(), deltaUsd: z.number() })), kpis: KpiSnapshot, /** ADR-0077: what the decisions do together beyond their sum, in the same two legs (the plan's value minus the rows'). */ valueUsdPerShare: z.number().optional(), laterUsdPerShare: z.number().optional() }),
  /** ADR-0053: the settings the answered cards hold in the no-change plan (their rows are in the baseline, so a draft that leaves them is "nothing changed"): the decision, where the card holds it, and the card rows. */
  held: z.array(z.object({ decisionId: z.string(), label: z.string(), toLabel: z.string(), by: z.array(z.string()) })).optional(),
  /** ADR-0049: the year's level of each statement line and the horizon-end balance of each product or book, under the no-change plan and under the draft (the Statements view's two columns). */
  levels: z.object({
    noChange: z.object({ lines: z.array(z.object({ lineId: z.string(), usd: z.number() })), books: z.array(z.object({ id: z.string(), usd: z.number() })) }),
    draft: z.object({ lines: z.array(z.object({ lineId: z.string(), usd: z.number() })), books: z.array(z.object({ id: z.string(), usd: z.number() })) }),
  }).optional(),
});
export type PreviewTrace = z.infer<typeof PreviewTrace>;

/**
 * ADR-0047: the Market Outlook page (P11): realised env to the last released month and the published consensus with its ±1σ range, 36 months ahead.
 * Built from Scenario.consensusKeyframes + consensusBands, never from `keyframes`. The loan-demand, default-rate and deposit-growth series are the 02.1 E1,
 * 03.1 E1, 04.1 E1–E2 model outputs evaluated on the consensus env (engine §G `derived`, folded into `series`).
 */
export const MarketOutlookSeriesId = z.enum([
  "policyRate", "ust2y", "ust10y", "mortgageRate", "unemployment", "gdpGrowth", "cpi", "hpi", "creIndex", "officeIndex", "officeVacancy", "depositMarketGrowth",
  "loanDemand.ci", "loanDemand.cre", "loanDemand.resi", "loanDemand.consumer", "loanDemand.card",
  "defaultRate.ci", "defaultRate.cre", "defaultRate.resi", "defaultRate.consumer", "defaultRate.card",
]);
export const MarketOutlook = z.object({
  asOfRound: RoundIndex, asOfMonth: Month, horizonMonths: z.number().int().positive(),
  /** content.md owns the wording. */
  honestyNote: z.string(),
  /** The last released month: the `realised` arrays stop here. */
  realisedThroughMonth: Month,
  series: z.array(z.object({
    id: MarketOutlookSeriesId, label: z.string(), unit: z.enum(["rate", "index"]),
    realised: z.array(z.object({ month: Month, value: z.number() })),
    /** Quarter-ends, 12–36 months ahead of asOfMonth. */
    consensus: z.array(z.object({ month: Month, point: z.number(), low: z.number(), high: z.number() })),
  })),
  /**
   * ADR-0059: the signal behind "pause buybacks on a negative outlook" (08.2 E10), its definition and its current state at the last quarter-end, so no screen shows the pause before it is explained:
   * `readingRate` = the higher of that quarter-end's unemployment and the consensus path from it, `lowestRecentRate` = the lowest of the last `lookbackQuarters` quarter-ends,
   * `triggerRate` = lowest + `riseTriggerRate`; the signal is ON from `readingRate ≥ triggerRate` until `resumeQuarters` calm quarter-ends. `text` is the one sentence every screen prints.
   * Absent where the pack has no outlook rule or no quarter-end has been read.
   */
  pauseSignal: z.object({
    riseTriggerRate: Rate, lookbackQuarters: z.number().int().positive(), resumeQuarters: z.number().int().positive(),
    quarterEndMonth: Month, readingRate: Rate, lowestRecentRate: Rate, triggerRate: Rate, paused: z.boolean(), text: z.string(),
    /** ADR-0083: the calm quarter-ends in a row so far (the count the pause's restart waits on, `resumeQuarters`); 0 while the rise is at or over the trigger. Absent = not counted (results stored before). */
    calmQuarters: z.number().int().nonnegative().optional(),
  }).optional(),
});
export type MarketOutlook = z.infer<typeof MarketOutlook>;

/**
 * ADR-0091 (CB9, Drivers programme): the business drivers a decision rests on, for one period (a quarter, or a year summed or taken at year-end by the reader), seat or twin. Every field is optional:
 * absent = not computed (a result stored before CB9 prints "-", never 0). Flows are over the period, stocks at its end. Teams are keyed `ci`, `cre`, `resi` (the three relationship teams);
 * `byProduct` records are keyed by product id. Produced by the engine from the closed state and the decisions in force; nothing here is an input.
 */
export const BusinessDrivers = z.object({
  /** Relationship-manager and loan-officer teams: headcount and seats at work (hired and ramped) at period end, hires and leavers over the period, and what a banker produced (new loans, whole dollars, per seat at work). */
  teams: z.object({
    ci: z.object({ headcountCount: z.number(), seatsAtWorkCount: z.number(), hiresCount: z.number(), leaversCount: z.number(), productionPerBankerUsd: Usd.optional() }),
    cre: z.object({ headcountCount: z.number(), seatsAtWorkCount: z.number(), hiresCount: z.number(), leaversCount: z.number(), productionPerBankerUsd: Usd.optional() }),
    resi: z.object({ headcountCount: z.number(), seatsAtWorkCount: z.number(), hiresCount: z.number(), leaversCount: z.number(), productionPerBankerUsd: Usd.optional() }),
  }).optional(),
  /** Commercial deposits the added relationship managers bring over the period (03.5 E5). */
  rmDepositsAddedUsd: Usd.optional(),
  /** Marketing spend over the period by product, and the new balances or originations it bought (the flow above the status-quo spend's), whole dollars. */
  marketingUsdByProduct: z.record(z.string(), Usd).optional(),
  marketingFlowUsdByProduct: z.record(z.string(), Usd).optional(),
  /** Market share by product at period end (a rate of the market; a seat's own, never a rival's). */
  shareRateByProduct: z.record(z.string(), Rate).optional(),
  /** Technology: spend over the period and the capability stock at period end by theme, the capability index (1 = the status-quo stock) and what the stock earns (fee income and operating cost saved over the period). */
  techSpendUsdByTheme: z.partialRecord(TechTheme, Usd).optional(),
  techStockUsdByTheme: z.partialRecord(TechTheme, Usd).optional(),
  capabilityIndex: z.number().optional(),
  capabilityEffect: z.object({ feeUsd: Usd, efficiencyUsd: Usd }).optional(),
  /** Branches open at period end, branches opened and still maturing, and the deposits the branches serve at period end. */
  branchCount: z.number().optional(),
  branchesOpeningCount: z.number().optional(),
  branchDepositsUsd: Usd.optional(),
  /** Pay: the pay notch in force (integer, 0 = market) and the service index it feeds (the customer index; 1 = the SimStart level). */
  payNotch: z.number().optional(),
  serviceIndex: z.number().optional(),
  /** Operating expense over the period by line (the SimStart opex line keys), whole dollars. */
  opexUsdByLine: z.record(z.string(), Usd).optional(),
});
export type BusinessDrivers = z.infer<typeof BusinessDrivers>;

/**
 * ADR-0092 (CB10): per-product balances a driver-history year carries beside its `BusinessDrivers`, for the years that have no product lines (the pre-game backcast years, `SimStartPack.driverHistory`):
 * the loan and deposit balances at the year's end by product id, and the year's originations by product id where known (consumer, card). Whole dollars; absent = not computed (the table prints "-", never 0).
 */
export const DriverYearProducts = z.object({
  balanceUsdByProduct: z.record(z.string(), Usd).optional(),
  originationsUsdByProduct: z.record(z.string(), Usd).optional(),
  /** ADR-0094 (CB12): the book each product id above belongs to, so a year with no product lines is read by book without the naming rule; absent = read by the naming rule. */
  bookIdByProduct: z.record(z.string(), BookId).optional(),
});
export type DriverYearProducts = z.infer<typeof DriverYearProducts>;

export const PeriodReport = z.object({
  periodEndMonth: Month,
  granularity: z.enum(["month", "quarter"]),
  statements: StatementSet,
  kpis: KpiSnapshot,
  /** ADR-0047: per-product output, the ALM view and the formula inputs for the period (absent in results stored before). */
  products: z.array(ProductLine).optional(),
  alm: AlmSnapshot.optional(),
  kpiInputs: KpiInputs.optional(),
  /** ADR-0091 (CB9): the drivers behind this period (seat and twin alike); absent in results stored before. */
  businessDrivers: BusinessDrivers.optional(),
});

/**
 * One seat's look-through run (10.3–10.4): W = terminalPriceUsdPerShare +
 * distributionsCompoundedUsdPerShare (dividends compounded at valuation.baseCoeRate to the scoring month, per share outstanding
 * at payment); tsrRate = W ÷ P₀ − 1 with P₀ = the SimStart price (ArchetypePack.simStartChecks.price), cumulative from
 * SimStart. Hence VC = W_team ÷ W_auto − 1 = (1 + tsr_team) ÷ (1 + tsr_auto) − 1 exactly.
 */
export const LookThroughResult = z.object({
  shadowMonths: z.number().int(),
  /** The price the score counts (10.4 E1): (1 − w) · the market price at the round end + w · the terminal value; the market price alone where no terminal value was run (`shadowMonths` 0). */
  terminalPriceUsdPerShare: UsdPerShare,
  tsrRate: Rate,
  distributionsCompoundedUsdPerShare: UsdPerShare,
  /** The market price decomposition at the round end (10.1; the bank's own `valuation` at T). */
  valuation: ValuationBreakdown,
  /**
   * ADR-0054 (10.3), absent where no terminal value was run: P_T (`marketPriceUsdPerShare`), V_T ÷ sh_T (`terminalValueUsdPerShare`), the eight lines between them (E6, per share; they sum to
   * V_T ÷ sh_T − P_T exactly), the composition of the terminal value (E7: core franchise + capital gap + rate mark + floor = V_T ÷ sh_T exactly), and the look-through return and growth behind it.
   */
  marketPriceUsdPerShare: UsdPerShare.optional(),
  terminalValueUsdPerShare: UsdPerShare.optional(),
  lines: z.object({ marketLag: z.number(), premiumsReleased: z.number(), historyAveraging: z.number(), creditCarried: z.number(), franchiseCarried: z.number(), growth: z.number(), capital: z.number(), floor: z.number() }).optional(),
  /** ADR-0063: for each line, the direction its sign means in words ("losses in the pipeline: fewer than the market expects"), and for a line a reader misreads, why ("capital above your target is worth what it earns, not more"). */
  lineDirections: z.partialRecord(z.enum(TERMINAL_LINES), z.string()).optional(),
  lineReasons: z.partialRecord(z.enum(TERMINAL_LINES), z.string()).optional(),
  composition: z.object({ coreFranchise: z.number(), capital: z.number(), marks: z.number(), floor: z.number() }).optional(),
  rotceLookThroughRate: Rate.optional(),
  growthLookThroughRate: Rate.optional(),
  /** ADR-0062 (E4.5, OR-21), 10.3 E8: the franchise line's gain beyond the cap ("beyond the cap, not counted"), $/share at T; in no line, no composition part and not in `terminalValueUsdPerShare`. Absent in results stored before. */
  franchiseBeyondCapUsdPerShare: UsdPerShare.optional(),
  /** ADR-0087 (CB5), 10.3 E8: the franchise line's rise before the in-flight cap, $/share at T, so a twin's can be shown beside the plan's. Absent = not computed. */
  franchiseRawUsdPerShare: UsdPerShare.optional(),
  /** sh_T: the shares behind the per-share figures above. */
  sharesOutstanding: Shares.optional(),
  /** ADR-0086 (CB4; 10.3 E5): the standing premia (bp) the terminal was priced with, from the LT₁₂ window (min(K_T, K_LT) in the capital row), and K_LT, the capital record over that window; the value bridge reads them, so the premium cause line quotes what priced the terminal. Absent where no terminal value was run. */
  standingPremiaBp: z.object({ capital: Bp, creConcentration: Bp, wholesale: Bp, uninsured: Bp, eve: Bp }).optional(),
  capitalLookThroughRate: Rate.optional(),
});
export type LookThroughResult = z.infer<typeof LookThroughResult>;

export const SeatRoundResult = z.object({
  seatId: SeatId,
  monthly: z.array(PeriodReport),
  quarterly: z.array(PeriodReport),
  postings: z.array(Posting),
  attribution: Attribution,
  facts: z.array(Fact),
  scorecard: Scorecard, // buildScorecard's OUTPUT: engine callers pass a placeholder in (testing: makeSeatRoundResult) and replace it
  lookThrough: LookThroughResult,
  autopilotLookThrough: LookThroughResult,
  /**
   * Reported wealth at the round end, no look-through (10.4): round-end price + distributionsPvUsdPerShare ×
   * (1 + baseCoeRate)^(month/12), the LookThroughResult W convention at the round-end month.
   */
  reportedWealthUsdPerShare: UsdPerShare,
  /**
   * The two status-quo twins at round end (11.3; M7h). VALUE twin: this seat on autopilot since SimStart,
   * carried round to round (W_auto, the $/share base B, the deal call, reported-only VC, I38). FORECAST twin: the seat's own
   * round-start bank, one round on autopilot (the "call the year" target; R1 = the value twin; kpis are the 13.1 round-window measures).
   */
  valueTwinRoundEnd: z.object({
    kpis: KpiSnapshot, reportedWealthUsdPerShare: UsdPerShare,
    /** ADR-0042: the twin's round-end price decomposition (10.1, priced on its round-end bank); the look-through give-back bridge reads it. */
    valuation: ValuationBreakdown.optional(),
    /** ADR-0047: the twin's shares and the dividend it paid per SimStart share (Scorecard.components reads them). */
    sharesOutstanding: Shares.optional(), dividendsUsdPerShare: UsdPerShare.optional(),
    /** ADR-0053: what the twin paid in the round in dollars and the rules that held a payout of its own (absent: the twin is the seat's own run, or a result stored before). */
    distributions: z.object({ dividendsUsd: Usd, buybacksUsd: Usd, blockedBy: z.array(z.object({ reason: z.string(), affects: z.enum(["dividend", "buyback", "both"]), text: z.string() })) }).optional(),
  }),
  forecastTwinRoundEnd: z.object({ kpis: KpiSnapshot }),
  /** ADR-0053: the prices the year's moves start from, this bank's and its status-quo twin's at the prior year-end (`Scorecard.components.priceMoves` reads them). */
  priorPrice: z.object({ youUsdPerShare: UsdPerShare, twinUsdPerShare: UsdPerShare, youSharesOutstanding: Shares.optional(), twinSharesOutstanding: Shares.optional() }).optional(),
  /**
   * "Call the year" scoring hooks (OD5-1/OD5-6; ADR-0026 §1; 13.1): one row per FORECAST_GATED_KPI. twinActual = the FORECAST
   * twin's value (forecastTwinRoundEnd.kpis): nim and ncoRate are round-window measures (sum over the round's months, annualized,
   * ÷ mean earning assets or mean loans), cet1Marked the round-end value (13.1); noChangeBaseline = the same measure on the
   * previous window (R1: the SimStart trailing year; the "copy last year" call; skill is measured against it) — the ONE definition of
   * "last year": CP-3 ForecastStatus.noChangeBaseline (shown, band centre) is filled by the same function (13.1). actualBand classifies twinActual − baseline with ContentParams.forecast.bands; a
   * numeric forecast is classified the same way, so directionHit / bandHit exist for both formats. Human seats only.
   * scored = false only when no forecast was committed this round (excludedReason 'notCommitted'); the plan's source
   * (team, close default, rescue) does not matter because the plan cannot move the twin.
   */
  forecastErrors: z.array(z.object({
    kpi: z.enum(FORECAST_GATED_KPIS),
    format: ForecastFormat.nullable(),
    forecastValue: z.number().nullable(),       // numeric format only
    forecastBand: ForecastBand.nullable(),      // band format, or the band a numeric forecast falls in
    twinActual: z.number(),
    noChangeBaseline: z.number(),
    actualBand: ForecastBand,
    directionHit: z.boolean().nullable(),       // sign of (forecast − baseline) vs (twinActual − baseline), flat band = no change
    bandHit: z.boolean().nullable(),
    absErrorBp: z.number().nullable(),          // numeric only: |forecastValue − twinActual| in bp
    noChangeAbsErrorBp: z.number(),             // |noChangeBaseline − twinActual| in bp (skill reference)
    withinTolerance: z.boolean().nullable(),    // numeric only: absErrorBp ≤ ContentParams.forecast.hitToleranceBp
    scored: z.boolean(),
    excludedReason: z.enum(["notCommitted"]).nullable(),
    /** ADR-0041: the second reading beside bandHit — did the call beat "same as last year" (13.1)? Absent when not scored. */
    beatNoChange: z.boolean().optional(),
    /** ADR-0042: the edges of `forecastBand` as a move vs noChangeBaseline in bp (ContentParams.forecast.bands; null = open-ended). Absent when no band was called. */
    bandLowBp: z.number().nullable().optional(),
    bandHighBp: z.number().nullable().optional(),
    /** ADR-0053: the question this row answers, for the screen to print beside the number ("the no-change plan's own move over the round, against last year's value"). */
    basis: z.string().optional(),
  })),
  riskAppetiteBreaches: z.array(z.object({ kpi: KpiId, limit: z.number(), actual: z.number(), /** ADR-0080: the quarter-end months at which the reading was beyond the limit; absent = not recorded. */ quarterEnds: z.array(Month).optional() })),
  /**
   * Per-family rationale check (10.4): own-bank one-at-a-time revert runs on the realized path — human
   * seats only, 12 months, no look-through (same mechanism as the CRO memo revert). kpiDeltas = actual − reverted.
   * The part not explained by the single reverts is reported as "interaction". Empty for AI/autopilot seats.
   */
  familyReverts: z.array(z.object({ family: DecisionFamily, kpiDeltas: KpiSnapshot })),
  /** ADR-0047: the year's change by single-decision twins (human seats), and the round-end ALM view. */
  decisionAttribution: DecisionAttribution.optional(),
  alm: AlmSnapshot.optional(),
});
export type SeatRoundResult = z.infer<typeof SeatRoundResult>;

/** Output of resolving one round for the whole market. */
export const RoundResult = z.object({
  marketId: MarketId,
  round: RoundIndex,
  startMonth: Month,
  endMonth: Month,
  engineVersion: SemVer,
  contentHash: Sha256Hex,
  env: z.array(EnvSnapshot),
  events: z.array(EventInstance),
  seats: z.array(SeatRoundResult),
  marketFacts: z.array(Fact),
  invariants: InvariantReport,
  stateDigest: Sha256Hex, // determinism check (I15)
});
export type RoundResult = z.infer<typeof RoundResult>;

// ───────────────────────────────────────────────────────────── preview

/**
 * Point + range + confidence tier for a previewed KPI (OD5-8c; method = ContentParams.preview): low/high = min/max over the
 * point run and the sensitivity runs; confidence null when the KPI has no tolerance; drivers = the sensitivity kinds whose own
 * move is at least half the range width, named only when the tier is not high (13.2 E3). Gated KPIs are hidden until the forecast commit.
 */
export const PreviewValue = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("shown"), point: z.number(), low: z.number(), high: z.number(), confidence: ConfidenceTier.nullable(), drivers: z.array(z.enum(["rates", "rivals", "credit"])),
    /** ADR-0042, lcrLite only: the plan's lowest quarter-end value in the window (06.2; where a risk-appetite breach counts), when a quarter-end fell in it. ADR-0064: for `eve200` rows it carries economic value of equity's lowest quarter-end (the basis the own-limit test uses). */
    quarterEndLow: z.number().optional(),
  }),
  z.object({ status: z.literal("gated"), reason: z.literal("forecastRequired") }),
]);
export type PreviewValue = z.infer<typeof PreviewValue>;
/** One run of the status-quo twin at round open: its round-end KPIs and its wealth per share, reported and look-through (ADR-0043; ADR-0064 reuses the shape for the band paths). */
const StatusQuoTwinBaseline = z.object({ kpis: KpiSnapshot, reportedWealthUsdPerShare: UsdPerShare, lookThroughWealthUsdPerShare: UsdPerShare });
/**
 * Everything the preview (browser Web Worker) and the CRO memo need — built server-side by
 * buildPreviewInput (cp2) from MarketState. Own bank + PublishedMarket only: no seed, no other
 * seats' state, no scheduled shocks, no true scenario path. Served as-is by GET …/preview-context.
 */
/** ADR-0072: one risk-limit change, one entry per measure and round: `from` is the line at the start of the round, `to` the line the team set. */
export const LimitChange = z.object({ kpi: KpiId, round: RoundIndex, from: z.number(), to: z.number() });
export type LimitChange = z.infer<typeof LimitChange>;

/** ADR-0085: `riskyChoices[].rateRisk`, named so the contract's inferred route types stay short. */
const RateRiskShape = z.object({
  eve200: z.object({ from: z.number(), to: z.number() }).optional(), equityDurationYears: z.object({ from: z.number(), to: z.number() }).optional(),
  /** ADR-0061: the swaps the answer adds at year-end net of the card unanswered: the signed notional (positive = pay-fixed) and the tenor of the newest swap, so a hedge option prints what it trades. */
  hedge: z.object({ notionalUsd: z.number(), tenorYears: z.number() }).optional(),
  /** ADR-0085: the income sensitivity (net interest income change if rates rise 1 point, as a share of income), card unanswered → answered, beside `eve200`. */
  niiSensitivity: z.object({ from: z.number(), to: z.number() }).optional(),
  /** ADR-0085: set on a card hedge (a `decisionMove`): how far the bank's rate position was from neutral before the card, in target notches (never negative), and the most notches the card moves it (05.4 E8). */
  cardHedge: z.object({ notchesFromNeutral: z.number().nonnegative(), maxStepNotches: z.number().positive() }).optional(),
});
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- a named interface keeps the inferred route types short
export interface RateRiskView extends z.infer<typeof RateRiskShape> {}
export const PreviewInput = z.object({
  config: EngineConfig.omit({ seed: true }),
  round: RoundIndex,
  seatId: SeatId,
  bank: BankState,
  published: PublishedMarket,
  products: z.array(ProductDef),
  /** ArchetypePack.bankModels (fees, opex, capability): the Expander reads OpexParams (L13) from here, as PolicyInput. */
  bankModels: z.array(ModelRef),
  params: ContentParams,
  /** PREVIEW_GATED_KPIS until the team's round forecast is committed, then [] for the rest of the round (OD5-1: no re-lock). */
  gatedKpis: z.array(KpiId),
  /** ADR-0072 (M9): the limit changes the team made, for the memo's limit-change slot; absent = none. */
  limitChanges: z.array(LimitChange).optional(),
  /**
   * Planned event instances for this seat this round (card projection lives in the API), the answered ones (`status` "responded") included from ADR-0051: the run
   * reads them as the resolve does (a lagged effect finds its instance), and a card option's projected supervisory steps are read off them. Never includes a held live surprise (ADR-0015).
   */
  pendingEvents: z.array(EventInstance),
  /** ADR-0051: the shocks the answered cards (`pendingEvents` with status "responded") schedule, as `MarketState.scheduledShocks` carries them; absent = none (an input from before). Never a scenario shock. */
  scheduledShocks: MarketState.shape.scheduledShocks.optional(),
  /** What the browser cannot derive (01.1 §3, 01.3 E1, 11.5 K13): the server sets it, the preview and the memo read it; absent = anchors at the round-start env, K13 silent. */
  anchors: z.object({
    /** e₀: the archetype's complete SimStart env. */
    baselineEnv: EnvSnapshot,
    /** Each product's SimStart reference rate (01.3 E1's start rate). */
    startReferenceRates: z.record(ProductId, Rate),
    /** ADR-0088: A0, the deposit-insurance assessment SimStart pays a year (07.3 E15), from the true SimStart bank, which a preview cannot derive from the round-start bank; absent = derived from `bank`. */
    startAssessmentUsd: Usd.optional(),
    /** ADR-0068: the plain title of each pending card, so the memo can name a card without an id (the CRO memo receives only this input). */
    cardTitles: z.record(EventInstanceId, z.string()).optional(),
    /** Event answers whose card marks them a supervisory risk or watch (`choiceId` "default" = the card's no-answer outcome). */
    riskyChoices: z.array(z.object({
      instanceId: EventInstanceId, choiceId: z.string(),
      /** ADR-0042: the CAMELS component and note the card's `supervisoryImpact` names for the option (absent = none named). */
      component: EventChoice.shape.supervisoryImpact.shape.component, note: z.string().optional(),
      /**
       * ADR-0053: the limits the option's projected year breaches (the no-change plan with the card answered): `from` the same reading with the card unanswered, `already` when that reading breached too
       * (then the card is not the cause), `own` when the limit is the team's saved one, else the default.
       */
      ownLimits: z.array(z.object({ kpi: KpiId, projected: z.number(), /** ADR-0064: the lowest projected quarter-end reading of the plan's year, the basis the resolve's own-limit test uses (`projected` is the year-end reading); absent = not carried. */ quarterEndLow: z.number().optional(), limit: z.number(), from: z.number().optional(), already: z.boolean().optional(), own: z.boolean() })).optional(),
      /** ADR-0053: the main rate-risk readings the option moves (economic value at +200bp as a share of equity, and the equity's duration in years), card unanswered → answered. */
      rateRisk: z.custom<RateRiskView>((v) => RateRiskShape.safeParse(v).success).optional(),
      /**
       * ADR-0064 (R5): the draft's year-end NIM and share price (`from`) and the same plan with this option answered (`to`), on the same path and basis as the preview's score row;
       * the `{from,to}` convention of `rateRisk.eve200`. Absent = not priced.
       */
      // Pin (F16.0): the unit of the NIM and share-price fields is Rate (decimal) and UsdPerShare, as every other NIM and price field in CP-1.
      kpis: z.object({
        nim: z.object({ from: Rate, to: Rate }).optional(),
        price: z.object({ from: UsdPerShare, to: UsdPerShare }).optional(),
        /**
         * ADR-0070 (F24.0): the plan's worth if it runs on (the look-through value per share): `from` the usual outcome's (the card unanswered), `to` this option's, so the score effect is `to - from`.
         * The figure the score counts. Absent = not computed.
         */
        lookThrough: z.object({ fromUsdPerShare: UsdPerShare, toUsdPerShare: UsdPerShare, /** ADR-0087 (CB5): the plan's worth with the card withheld (no card), for the card page's "no card" line. Absent = not computed. */ withoutCardUsdPerShare: UsdPerShare.optional() }).optional(),
        /** ADR-0092 (CB10): the plan's year-end KPI snapshot with the card withheld (no card), the same for every option of the card, so the card page prints each answer's change against no card. Absent = not computed. */
        noCardYear: KpiSnapshot.optional(),
      }).optional(),
      /**
       * ADR-0068 rev (F22.0, OR-25(7)): a card option with a chance event states the odds and prices both branches: `label` is the plain-words odds and outcome ("a one-in-two chance of a $40M outflow"),
       * `withUsdPerShare` the share price if it happens, `withoutUsdPerShare` if it does not, on the same path and basis as `kpis.price`. Absent = the option has no chance event.
       * Pin (F22.0): `probability` is a decimal 0 to 1, as every other probability in CP-1.
       * ADR-0069 (P5-D7): `lookThrough` is the same pair on the look-through basis, beside the year-end pair, never replacing it.
       */
      /** ADR-0080: the option moves the sensitivity (S) rating of the plan's year; `ratingBefore` the rating with the card unanswered, `ratingAfter` with this option. Absent = not computed. */
      changes: z.boolean().optional(), ratingBefore: CamelsRating.optional(), ratingAfter: CamelsRating.optional(),
      chance: z.object({ probability: z.number().min(0).max(1), label: z.string(), /** ADR-0072: true when the event is the bad outcome (the card's branch mark); absent = not marked. */ adverse: z.boolean().optional(), withUsdPerShare: UsdPerShare, withoutUsdPerShare: UsdPerShare, lookThrough: z.object({ withUsdPerShare: UsdPerShare, withoutUsdPerShare: UsdPerShare }).optional() }).optional(),
    })),
    /**
     * ADR-0066 (R1): the scenario's published ±1 sigma consensus band as two full paths, so the browser preview can run the plan on them for the score range; absent = no range.
     * Pin (F16.0c): the path shape is the same `EnvSnapshot[]` (min 1) as `PublishedMarket.consensusPath`, one entry per month of the consensus horizon.
     */
    consensusBandPaths: z.object({ low: z.array(EnvSnapshot).min(1), high: z.array(EnvSnapshot).min(1) }).optional(),
    /** ADR-0047: the scenario's reversion for the look-through years (lookThroughNeutral when authored, else shadowReversion). */
    shadowReversion: Scenario.shape.shadowReversion.optional(),
    /** ADR-0047 amendment: the played env of every month 0 … the round start (index = month); the credit drivers' lag reads it. Absent = the straight line from baselineEnv to the round-start env. */
    envHistory: z.array(EnvSnapshot).optional(),
  }).optional(),
  /**
   * ADR-0042: the decisions the player can move this round (a guided round opens only its focus decisions) and the first later round that opens
   * the rest; the memo's decision line names a held decision as set by the standing policy. Absent = every decision is open.
   */
  openDecisionIds: z.array(DecisionId).optional(),
  decisionsOpenRound: RoundIndex.optional(),
  /** ADR-0047: every other seat's bank and the plan it plays (AI seats on their policy, human seats at their standing plan), so the preview runs the full market. Absent = held rivals. */
  rivals: z.array(z.object({ seatId: SeatId, kind: SeatKind, personaId: PersonaId.optional(), bank: BankState, plan: DecisionSet })).optional(),
  /** ADR-0047: the decision-independent runs, done once per seat per round at OPEN: the no-change plan's point (and sensitivity runs, look-through) and the status-quo twin's wealth. */
  baselines: z.object({
    /** `pointYearEnd` (ADR-0053): the same run's year-end month KPIs, the basis the results and the expectation strip read (`point` is the window's). */
    noChange: z.object({ point: KpiSnapshot, pointYearEnd: KpiSnapshot.optional(), bySensitivity: z.array(KpiSnapshot).optional(), lookThrough: LookThroughEstimate.optional() }),
    statusQuoTwin: StatusQuoTwinBaseline,
    /**
     * ADR-0064 (R1): the status-quo twin run on the published low and high (±1 sigma) consensus band paths at round open, the same entry shape as `statusQuoTwin`, so the preview can state a score range
     * against the twin on each path. The plan's own band runs are the existing `noChange.bySensitivity` rows; only the twin's wealth was not carried. Absent = no range.
     */
    twinOnBands: z.object({ low: StatusQuoTwinBaseline, high: StatusQuoTwinBaseline }).optional(),
  }).optional(),
  /** ADR-0091 (CB9): probe one step beyond the draft: the decision, and the direction along its option order (1 = toward the later option, -1 = toward the earlier). The result carries `nextStep`; absent = no probe. */
  nextStep: z.object({ decisionId: z.union([DecisionId, DecisionPath]) /* ADR-0092: a composite decision's leaf path is also accepted */, direction: z.union([z.literal(1), z.literal(-1)]) }).optional(),
});
export type PreviewInput = z.infer<typeof PreviewInput>;

export const PreviewResult = z.object({
  seatId: SeatId,
  round: RoundIndex,
  horizonMonths: z.number().int().positive(),
  kpis: z.partialRecord(KpiId, PreviewValue),
  /** Plan minus the no-change plan (the autopilot plan on the seat's own bank and path); label "vs the no-change plan" (UI_TERMS.noChangePlan; never "vs your twin"). No valueCreated entry: Value Created is never previewed (13.2 E4 is internal; screens P6). */
  deltasVsAutopilot: z.partialRecord(KpiId, PreviewValue),
  /** 1 + number of sensitivities actually RUN (credit in "analytic" mode is not a run); pilot 7, fallback 5 (budget evidence; ADR-0022). */
  runs: z.number().int().min(1).max(7),
  croMemo: CroMemo,
  issues: z.array(DomainIssue), // validation findings (not thrown)
  /** ADR-0047: the look-through estimate of the draft and of the no-change plan (consensus path; "if the market goes as expected"). Gated with the other PREVIEW_GATED_KPIS. */
  lookThrough: LookThroughEstimate.optional(),
  lookThroughNoChange: LookThroughEstimate.optional(),
  /** ADR-0047: "exact" = every rival on the plan it will play; "humanRivalsHeld" = human rivals held at their standing plan (facilitated cohorts). */
  rivalsMode: z.enum(["exact", "humanRivalsHeld"]).optional(),
  /** ADR-0047: the draft's horizon-end per-product output and ALM view. */
  horizon: z.object({ products: z.array(ProductLine), alm: AlmSnapshot }).optional(),
  kpiInputs: KpiInputs.optional(),
  trace: PreviewTrace.optional(),
  /**
   * ADR-0075: the draft's share-price move against the no-change plan at the horizon end, split into its causes (10.1 E7-E12): the earnings the market capitalises (ROTCE_n at the same growth and cost of equity), the growth it pays for (g),
   * the capital held (surplus, marks, required capital), the risk premium (cost of equity) and everything else (the market's partial adjustment, shocks, the floor, shares); the five sum to the headline price move exactly. Absent while the price is gated.
   */
  priceBridge: z.object({ earningsUsdPerShare: z.number(), growthUsdPerShare: z.number(), capitalUsdPerShare: z.number(), riskPremiumUsdPerShare: z.number(), otherUsdPerShare: z.number() }).optional(),
  /**
   * ADR-0075: the draft's move in economic value of equity (the `eve200` reading at the horizon end, a share of equity) against the no-change plan, by where it comes from (05.5 E1, each run on its own worse side): loans, securities, deposits and swaps,
   * and the rest (the other balance lines, and any difference between this reading and the stored one); the five sum to the headline move exactly. Absent while `eve200` is gated.
   */
  eveBridge: z.object({ loansRate: z.number(), securitiesRate: z.number(), depositsRate: z.number(), swapsRate: z.number(), otherRate: z.number(),
    /** ADR-0080: the balance behind each cause at the horizon end, whole dollars, the no-change plan (`from`) and the draft (`to`); absent = not carried. */
    balanceUsd: z.object({ loans: z.object({ from: Usd, to: Usd }), securities: z.object({ from: Usd, to: Usd }), deposits: z.object({ from: Usd, to: Usd }) }).optional(),
  }).optional(),
  /**
   * ADR-0077: the expense decision's cost programme against the no-change plan, from the engine's own run of that decision alone over the plan year and the two look-through years; present only when the draft's expense decision differs from the no-change plan's.
   * `chargeUsd` the one-off restructuring charge, before tax; `chargeAfterTaxUsd` what it takes out of capital; `savingsByYearUsd` the operating cost the programme saves in years 1 to 3 at the share realised after the savings creep back (07.3 E10), the one-off charge excluded;
   * `netSavingsByYearUsd` (additive, optional; ADR-0077 addendum) the same three years net of the fee income and the service-deposit margin the programme loses, the charge excluded: the row `paybackYears` is computed on;
   * `paybackYears` when the programme's cumulative pre-provision profit against the no-change plan turns positive, charge included and service and fee losses netted (interpolated within the year; null = not within the three years); `capitalHitBp` the after-tax charge over the opening risk-weighted assets
   * (as bp of the CET1 ratio) and `capitalHitUsdPerShare` over the shares; `serviceDepositLossUsd` the deposits the programme has lost against the no-change plan at the end of year 3; `lookThroughLine` the engine-worded sentence on how the price treats the charge.
   */
  costProgramme: z.object({
    chargeUsd: z.number(), chargeAfterTaxUsd: z.number(), savingsByYearUsd: z.tuple([z.number(), z.number(), z.number()]), netSavingsByYearUsd: z.tuple([z.number(), z.number(), z.number()]).optional(), paybackYears: z.number().nullable(),
    capitalHitBp: z.number(), capitalHitUsdPerShare: z.number(), serviceDepositLossUsd: z.number(), lookThroughLine: z.string(),
  }).optional(),
  /**
   * ADR-0053: the draft's KPIs at the horizon-end month, the basis the expectation strip and the round's results read (`kpis` for NIM, NCO, ROTCE and the efficiency ratio are the window's
   * averages, which the ranges widen), and its move against the no-change plan on that same basis. A gated KPI is masked as in `kpis`.
   */
  yearEnd: z.partialRecord(KpiId, PreviewValue).optional(),
  yearEndDeltasVsNoChange: z.partialRecord(KpiId, PreviewValue).optional(),
  /** ADR-0091 (CB9): the drivers at the horizon-end year for the draft and for the no-change plan; absent = not computed. */
  yearEndDrivers: z.object({ draft: BusinessDrivers, noChange: BusinessDrivers }).optional(),
  /** ADR-0091 (CB9): the probe one step beyond the draft (`PreviewInput.nextStep`): the stepped option's label, its value per share and year-end KPIs (the same bands as `yearEnd`) and its year-end drivers. Absent = no probe asked or none possible. */
  nextStep: z.object({ decisionId: z.union([DecisionId, DecisionPath]), toLabel: z.string(), valueUsdPerShare: UsdPerShare, kpis: z.partialRecord(KpiId, PreviewValue), businessDrivers: BusinessDrivers }).optional(),
  /** ADR-0053: what the no-change plan holds fixed, in words: "with your card answers; before the year's surprises" (the answered cards' rows are in the baseline). */
  basis: z.string().optional(),
  /**
   * ADR-0068 rev (F19.0): the rate position's reading as a structure, so the desk does not parse the trace sentence: what the plan traded and what it wanted (whole dollars of notional, the signed net pay-fixed notional change this year (the delta the plan trades and the delta the target wanted), not the resulting position), and why it traded less than it wanted
   * (`band` = already inside the band, `cap` = the size cap, `noIncome` = no income to hedge, `roundsToZero` = under the smallest trade, `capped` = trimmed by the cap). Absent = no reading; no `cause` = traded what it wanted.
   */
  ratePosition: z.object({ /** ADR-0068 rev (F20.0): true when the draft has the same added and ended swaps as the no-change plan, including when both trade (e.g. both trimmed to the cap); `tradedUsd`/`wantedUsd` are the net notional only (the engine compares; the desk cannot, it only sees the round-start book). Absent = not compared. */ sameAsNoChange: z.boolean().optional(), tradedUsd: Usd, wantedUsd: Usd, cause: z.enum(["band", "cap", "noIncome", "roundsToZero", "capped", "pastNeutral"]).optional() }).optional(),
});
export type PreviewResult = z.infer<typeof PreviewResult>;

/** Competency evidence item (team-level in pilot, facilitator-reviewed). */
export const EvidenceItem = z.object({
  seatId: SeatId,
  round: RoundIndex,
  competency: Competency,
  tag: z.string(),
  signal: z.enum(["forecastCalibration", "strategyConsistency", "reportedVsLookThrough", "riskAppetiteBreach", "eventResponse", "rationaleVsActual", "croObjection", "dealCall", "unattestedSubmission", "thesisLine"]),
  score: z.number().min(-1).max(1).optional(),
  factIds: z.array(FactId),
});
export type EvidenceItem = z.infer<typeof EvidenceItem>;

// ───────────────────────────────────────────────────────────── coach content

/** Concept card (coach content pack; served to UI and to the coach tool). */
export const ConceptCard = z.object({
  id: ConceptCardId,
  version: z.number().int().min(1),
  title: z.string(),
  pillar: z.enum(["Returns", "Growth", "Capital", "Liquidity", "Risk", "All"]),
  complexity: z.array(ComplexityLevel),
  decisionIds: z.array(DecisionId),
  metricIds: z.array(KpiId),
  summary: z.string().max(600),
  explainer: z.string(),
  whyItMatters: z.string(),
  misconceptions: z.array(z.string()).min(2),
  socraticPrompts: z.array(z.string()).min(2),
  hintLadder: z.tuple([z.string(), z.string(), z.string()]), // → HintLevel 0, 1, 2
});
export type ConceptCard = z.infer<typeof ConceptCard>;

// ───────────────────────────────────────────────────────────── program, debrief, finale, glossary, assessment

export type ComplexityLevel = z.infer<typeof ComplexityLevel>;
/**
 * Workshop ease-in (OD5-6; ADR-0023): a program option pinned at cohort create.
 *  - guidedR1 (facilitated default): Round 1 (and the R0 practice quarter) at guided; every decision from R2 ("new powers").
 *  - guidedR2 (OR-6): Rounds 0–2 at guided (one focus decision per family); every decision from R3. ContentPack.guided.focusDecisions widens by round.
 *  - off: the program's base complexity every round (executive cohorts).
 *  - guidedThroughout: guided every round (broad-staff cohorts).
 * A program whose base complexity is already `guided` is guided every round, whatever the option.
 * EngineConfig.complexity stays the program's base level: guided vs executive is an API rule (editable decisions), not an engine path.
 */
export const EaseIn = z.enum(["guidedR1", "guidedR2", "off", "guidedThroughout"]);
export type EaseIn = z.infer<typeof EaseIn>;
/** The complexity a round is played at (round 0 = the R0 practice quarter). */
export function complexityForRound(base: ComplexityLevel, easeIn: EaseIn, round: number): ComplexityLevel {
  if (base === "guided" || easeIn === "guidedThroughout") return "guided";
  if (easeIn === "guidedR1" && round <= 1) return "guided";
  if (easeIn === "guidedR2" && round <= 2) return "guided";
  return base;
}
/** Forecast input format for a round's complexity (OD5-6): guided → band picker, every other level → numeric. */
export function forecastFormatFor(level: ComplexityLevel): ForecastFormat {
  return level === "guided" ? "band" : "numeric";
}

/**
 * The ONE deal covenant (OD5-8a; ADR-0025 §3; 08.2 E3): from the month after an EV-05
 * acceptance until CLOSING (bid month + bid.approvalLagMonths, pilot 6) or a break, buybacks are off and DPS is frozen at the
 * last declared quarterly DPS (the CCB and an MOU can still cut it); at closing it lifts and buybacks resume at the next
 * quarterly buyback date. No forced deposit outflow, no growth band, no index hits. Applied by 08.2 as a POSTING rule at each
 * quarterly distribution date from DealOffer.covenantStatus = "pending" (buybacks 0, DPS = last declared), shown as a draft notice,
 * never a LeverConstraint. G8 pins its headline effect at ≈ 0 (−0.01 to −0.04pp).
 */
export const DEAL_COVENANT = { buybacks: "off", dividend: "frozenDps" } as const;

/**
 * Debrief picks (OD5-5; ADR-0026 §5): after each release the console auto-picks up to three stories from the released
 * round, human seats only, deterministic (scoring selectDebriefPicks, cp2). Picks are taken in DEBRIEF_PICK_KINDS order;
 * a seat already picked is skipped for a later kind when another eligible seat exists; metric ties → lower SeatId.
 * A kind with no eligible seat yields no pick (e.g. no events in R1 → at most two picks).
 */
export const DEBRIEF_PICK_KINDS = ["forecastMiss", "lookThroughGiveBack", "divergentEventChoice"] as const;
export const DebriefPickKind = z.enum(DEBRIEF_PICK_KINDS);
export type DebriefPickKind = z.infer<typeof DebriefPickKind>;
export const DEBRIEF_PICK_RULES: Readonly<Record<DebriefPickKind, string>> = {
  forecastMiss:
    "Largest twin-forecast miss among scored forecasts: numeric rounds max over the three KPIs of absErrorBp ÷ hitToleranceBp; band rounds max |band index(forecastBand) − band index(actualBand)|.",
  lookThroughGiveBack:
    "Largest look-through give-back = reportedOnlyValueCreatedRate − valueCreatedRate on this round's scorecard; only if > 0.",
  divergentEventChoice:
    "Among events delivered to ≥ 2 human seats this round, the seat whose choice (a default counts as its own choice) was taken by the fewest of those seats; ties → the event with more recipients, then lower EventCard.priority.",
};
export const DebriefPick = z.object({
  kind: DebriefPickKind,
  round: RoundIndex,
  seatId: SeatId,
  metric: z.number(), // the rule's ranking value (unit per rule; shown only through factIds)
  eventInstanceId: EventInstanceId.nullable(), // divergentEventChoice only
  factIds: z.array(FactId).min(1),
});
export type DebriefPick = z.infer<typeof DebriefPick>;

/**
 * Finale recognitions (OD5-5): three UNRANKED recognitions, human seats only, shown before the rank. Ties are shared
 * (every tied seat is named). A seat may win more than one.
 */
export const RECOGNITION_KINDS = ["forecaster", "riskSteward", "builtToLast"] as const;
export const RecognitionKind = z.enum(RECOGNITION_KINDS);
export type RecognitionKind = z.infer<typeof RecognitionKind>;
export const RECOGNITION_RULES: Readonly<Record<RecognitionKind, string>> = {
  forecaster: "Best mean forecast skill (scoring forecastSkill, 13.1) over the seat's scored rounds; needs ≥ 2 scored rounds.",
  riskSteward: "Fewest quarter-ends with any breach of the seat's own R0 risk-appetite limits over the played rounds, among seats never gate-ranked-last.",
  builtToLast: "Smallest final look-through give-back (reportedOnlyValueCreatedRate − valueCreatedRate at the final scorecard; negative = gained).",
};
export const Recognition = z.object({
  kind: RecognitionKind,
  seatIds: z.array(SeatId).min(1), // ties shared
  metric: z.number(),
  factIds: z.array(FactId),
});
export type Recognition = z.infer<typeof Recognition>;

/** Glossary term (content glossary_v1.json): plain line + why it matters, optional concept-card link. */
export const GlossaryTerm = z.object({
  termId: slug,
  label: z.string().min(1).max(60),
  plain: z.string().min(1).max(200),
  whyItMatters: z.string().min(1).max(300),
  kpi: KpiId.optional(),
  conceptCardId: ConceptCardId.optional(),
});
export type GlossaryTerm = z.infer<typeof GlossaryTerm>;

/**
 * Pre/post check instrument (OD5-4; ADR-0026 §4; content assessment_v1.json, authored by the content WP with the answer key,
 * reviewed by Rob). Per form: exactly ASSESSMENT_SCORED_ITEMS scenario items, each with a 1–5 confidence rating (~15 min),
 * plus ASSESSMENT_JUDGMENT_CASES judgment cases that are CAPTURED, NOT SCORED in the pilot. Keys never leave the server.
 */
export const ASSESSMENT_SCORED_ITEMS = 10;
export const ASSESSMENT_JUDGMENT_CASES = 2;
const AssessmentItemBase = { itemId: z.string().regex(/^[A-Za-z0-9_-]{1,40}$/), competency: Competency, stem: z.string().min(1) };
export const AssessmentItem = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("scenario_mcq"), ...AssessmentItemBase, outcomeId: z.string().min(1), options: z.array(z.object({ id: z.string(), text: z.string() })).min(2).max(6), key: z.object({ optionId: z.string(), why: z.string().optional() }) }),
  z.object({ kind: z.literal("scenario_numeric"), ...AssessmentItemBase, outcomeId: z.string().min(1), unit: z.enum(["rate", "usd", "bp"]), key: z.object({ value: z.number(), toleranceAbs: z.number().nonnegative(), why: z.string().optional() }) }),
  z.object({ kind: z.literal("judgment_case"), ...AssessmentItemBase, maxChars: z.number().int().min(100).max(1500), scored: z.literal(false) }),
]);
export type AssessmentItem = z.infer<typeof AssessmentItem>;
export const AssessmentInstrument = z.object({
  key: slug,
  version: SemVer,
  form: z.enum(["A", "B"]),
  /** The fictional bank of this form and its fact sheet, shown above every item (assessment.md §1.4–1.5). */
  bankName: z.string().min(1).max(60),
  factSheet: z.string().min(1).max(1200),
  timeBudgetMinutes: z.number().int().min(5).max(30),
  items: z.array(AssessmentItem),
}).refine((i) => i.items.filter((x) => x.kind !== "judgment_case").length === ASSESSMENT_SCORED_ITEMS
  && i.items.filter((x) => x.kind === "judgment_case").length === ASSESSMENT_JUDGMENT_CASES, "a form has 10 scored scenario items and 2 judgment cases")
  .refine((i) => new Set(i.items.map((x) => x.itemId)).size === i.items.length, "itemIds must be unique")
  .refine((i) => i.items.every((x) => x.kind !== "scenario_mcq" || x.options.some((o) => o.id === x.key.optionId)), "an MCQ key must name one of its options");
export type AssessmentInstrument = z.infer<typeof AssessmentInstrument>;
